import DashboardOverview from '../components/DashboardOverview';
import DashboardUserMenu from '../components/DashboardUserMenu';
// AdminDashboard.js
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Accordion } from 'react-bootstrap'; // ⬅️ Add this at the top
import Select from 'react-select'; // ✅ Add this line
import axios from 'axios';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { getArray } from '../utils/api';
import { API_URL } from '../config'; // adjust path as needed

// charts
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';





import {
  Container, Row, Col, ListGroup, Button, Card, Modal, Form, Offcanvas, Nav, InputGroup, Table, Tabs, Tab, Pagination
} from 'react-bootstrap';
import { BiHomeAlt, BiChalkboard, BiUser, BiBell, BiFile, BiGroup, BiWalletAlt, BiUpload, BiDownload, BiCheckSquare, BiLogOut, BiBarChart, BiTime, BiPlus, BiEdit, BiTrash, BiPrinter, BiDotsVerticalRounded, BiListUl, BiUserCircle, BiMessageSquareDetail } from 'react-icons/bi';
import { FaWhatsapp } from 'react-icons/fa';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import './AdminDashboard.css';
import PageTitle from '../components/PageTitle';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// at the top of src/pages/AdminDashboard.js
import StudentNotesModal from '../components/StudentNotesModal';
import StudentGoalsModal from '../components/StudentGoalsModal';
import QuranAssignmentsModal from '../components/QuranAssignmentsModal';
import StudentAttendancePanel from '../components/StudentAttendancePanel';

import { useStudentNotes } from '../hooks/useStudentNotes';
import { useStudentGoals } from '../hooks/useStudentGoals';

import {
  computeAttendanceInsights
} from '../utils/attendanceInsights';
import { formatDateOnly, getDateOnlyKey, getLocalDateInputValue } from '../utils/dateDisplay';
import { formatPhone, normalizePhone } from '../utils/formatPhone';





ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);




const AdminDashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const normalizeMarkazName = (name) => String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  const normalizedCurrentMarkazName = normalizeMarkazName(currentUser?.markaz_name);
  const isAlsunahMarkaz =
    currentUser?.financials_enabled === true ||
    ['alsunnah', 'alsunah', 'demo', 'hikmah'].includes(normalizedCurrentMarkazName);
  const showMonthlyFeeFinancials = false; // Old monthly-fee setup is disabled for now.

  const [activeTab, setActiveTab] = useState('dashboard');
  const sessionExpiredRef = useRef(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [summary, setSummary] = useState({ recentParentNotes: [] });
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [allClasses, setAllClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [studentsInClass, setStudentsInClass] = useState([]);
  const [editParent, setEditParent] = useState(null);

  const [classes, setClasses] = useState([]);

  const [searchClass, setSearchClass] = useState('');
  const [searchTeacher, setSearchTeacher] = useState('');

  const [showStudentModal, setShowStudentModal] = useState(false);
  const [returnToClassStudents, setReturnToClassStudents] = useState(false);
  const [returnToParentProfile, setReturnToParentProfile] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [editStudent, setEditStudent] = useState(null);
  const [editClassId, setEditClassId] = useState(null);
  const [editClassName, setEditClassName] = useState('');
  const [editShift, setEditShift] = useState('');
  const [newClassName, setNewClassName] = useState('');
  const [newClassTeacher, setNewClassTeacher] = useState('');
  const [parents, setParents] = useState([]);
  const [newParent, setNewParent] = useState({ first_name: '', last_name: '', phone_number: '' });
  const [assigningParentId, setAssigningParentId] = useState(null);
  const [viewingStudents, setViewingStudents] = useState([]);
  const [showStudentListModal, setShowStudentListModal] = useState(false);
  const [allStudents, setAllStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
const [showStudentDetailsModal, setShowStudentDetailsModal] = useState(false);
const [showEditStudentModal, setShowEditStudentModal] = useState(false);
const [showMoveStudentModal, setShowMoveStudentModal] = useState(false);
const [studentToMove, setStudentToMove] = useState(null);
const [targetClassId, setTargetClassId] = useState('');
const [searchStudent, setSearchStudent] = useState('');
const [studentPage, setStudentPage] = useState(1);
const [teacherPage, setTeacherPage] = useState(1);
const [parentPage, setParentPage] = useState(1);
const [openTeacherDropdownId, setOpenTeacherDropdownId] = useState(null);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  // what action should student rows show? null | 'notes' | 'goals'
  const [studentAction, setStudentAction] = useState(null);

    // student notes/goals (admin view)
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showGoalsModal, setShowGoalsModal] = useState(false);
  const [showQuranAssignmentsModal, setShowQuranAssignmentsModal] = useState(false);
  const [quranAssignmentsStudent, setQuranAssignmentsStudent] = useState(null);
  const [returnToClassAfterQuran, setReturnToClassAfterQuran] = useState(false);

  const notesApi = useStudentNotes();
  const goalsApi = useStudentGoals();


 

  //const [newStudent, setNewStudent] = useState({ first_name: '', last_name: '', class_id: '', shift: '' });
  const [showAddClassModal, setShowAddClassModal] = useState(false);
  const [newClass, setNewClass] = useState({ name: '', shift: '' });
  const [showAddParentModal, setShowAddParentModal] = useState(false);
  const [searchParent, setSearchParent] = useState('');
  const [parentSearchTerm, setParentSearchTerm] = useState('');
const normalizedParentSearch = normalizePhone(parentSearchTerm);
const filteredParents = parents.filter(
  p =>
    `${p.first_name} ${p.last_name}`.toLowerCase().includes(parentSearchTerm.toLowerCase()) ||
    (normalizedParentSearch &&
      normalizePhone(p.phone_number).includes(normalizedParentSearch))
);
const [showUpdateModal, setShowUpdateModal] = useState(false);
const [showAssignModal, setShowAssignModal] = useState(false);
const [showAddTeacherModal, setShowAddTeacherModal] = useState(false);
const [editTeacher, setEditTeacher] = useState(null);
const [assignedClassIds, setAssignedClassIds] = useState([]);
const initialTeacherState = {
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  password: ''
};
const [newTeacher, setNewTeacher] = useState(initialTeacherState);

const [selectedTeacherId, setSelectedTeacherId] = useState('');
const [attendance, setAttendance] = useState({});
const [lateAttendance, setLateAttendance] = useState({});
const [comments, setComments] = useState({});
const [attendanceDate, setAttendanceDate] = useState(() => getLocalDateInputValue());
const [reportFilters, setReportFilters] = useState({
  class_id: '',
  student_id: '',
  start_date: '',
  end_date: ''
});
const [report, setReport] = useState([]);
const [showReportModal, setShowReportModal] = useState(false);
const [reportStudents, setReportStudents] = useState([]);
const [activeAccordionKey, setActiveAccordionKey] = useState(null);
const [waitingList, setWaitingList] = useState([]); // fetched waiting list rows
const [waitingForm, setWaitingForm] = useState({
  first_name: '',
  last_name: '',
  parent_name: '',
  parent_phone: '',
  previous_markaz: '',
  shift: '',
  date_added: getLocalDateInputValue(), // default to today (YYYY-MM-DD)
});
const [showWaitingModal, setShowWaitingModal] = useState(false);
const [editingWaitingEntry, setEditingWaitingEntry] = useState(null);
const [waitingRegistration, setWaitingRegistration] = useState({
  show: false,
  entry: null,
  class_id: '',
  submitting: false,
});
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [showCSVModal, setShowCSVModal] = useState(false);
const [csvFile, setCsvFile] = useState(null);
const [formDocuments, setFormDocuments] = useState([]);
const [formsLoading, setFormsLoading] = useState(false);
const [formsUploading, setFormsUploading] = useState(false);
const [formsUpload, setFormsUpload] = useState({ title: '', file: null });
const [formPreview, setFormPreview] = useState({ show: false, document: null, url: '', isImage: false });
const [students, setStudents] = useState([]);
const [selectedClassId, setSelectedClassId] = useState(null);
const [openDropdownId, setOpenDropdownId] = useState(null);
const [openParentDropdownId, setOpenParentDropdownId] = useState(null);
const [openStudentDropdownId, setOpenStudentDropdownId] = useState(null);
const [reminders, setReminders] = useState([]);
const [reminderText, setReminderText] = useState('');
const [reminderDate, setReminderDate] = useState('');
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [studentToDelete, setStudentToDelete] = useState(null);
const [confirmAction, setConfirmAction] = useState({ show: false, type: '', payload: null });
const [showParentProfile, setShowParentProfile] = useState(false);
const [parentProfileTab, setParentProfileTab] = useState('profile');
const [selectedParent, setSelectedParent] = useState(null);
const [parentStudents, setParentStudents] = useState([]);
const [showParentStudentActionModal, setShowParentStudentActionModal] = useState(false);
const [parentStudentActionType, setParentStudentActionType] = useState('');
const [parentStudentActionId, setParentStudentActionId] = useState('');
const [selectedStudentId, setSelectedStudentId] = useState('');
const SHIFT_OPTIONS = ['Morning Weekend', 'Afternoon Weekend', 'Evening Weekdays', 'Full Time Weekend', 'Summer Program'];
const PAGE_SIZE = 40;
const normalizeShiftLabel = (shift) => {
  const normalized = String(shift || '').trim().toLowerCase();
  if (normalized === 'morning' || normalized === 'morning weekend') return 'Morning Weekend';
  if (normalized === 'afternoon' || normalized === 'afternoon weekend') return 'Afternoon Weekend';
  if (normalized === 'after-school' || normalized === 'afterschool' || normalized === 'evening' || normalized === 'evening weekdays') return 'Evening Weekdays';
  if (normalized === 'mo/af' || normalized === 'm-t-w' || normalized === 'all' || normalized === 'full time weekend' || normalized === 'fulltimeweekend') return 'Full Time Weekend';
  if (normalized === 'summer' || normalized === 'summer program' || normalized === 'summerprogram') return 'Summer Program';
  return shift || '';
};
const initialStudentState = {
  first_name: '',
  last_name: '',
  class_id: '',
  shift: 'Morning Weekend',
  parent1_first_name: '',
  parent1_last_name: '',
  parent1_phone: '',
  parent2_first_name: '',
  parent2_last_name: '',
  parent2_phone: ''
};
const [newStudent, setNewStudent] = useState(initialStudentState);
const initialParentStudentForm = {
  mode: 'new',
  existing_student_id: '',
  first_name: '',
  last_name: '',
  class_id: '',
  shift: 'Morning Weekend',
};
const [showParentStudentModal, setShowParentStudentModal] = useState(false);
const [parentStudentForm, setParentStudentForm] = useState(initialParentStudentForm);
const [editMode, setEditMode] = useState(false);
const [editableStudent, setEditableStudent] = useState(null);
const [editableParent, setEditableParent] = useState(null);
const [studentAvatarError, setStudentAvatarError] = useState(false);

const userId = localStorage.getItem('id');
const [todos, setTodos] = useState([]);
const [todoText, setTodoText] = useState('');
const [financials, setFinancials] = useState([]);
const [loadingFinancials, setLoadingFinancials] = useState(false);
const emptyLedgerForm = {
  student_id: '',
  teacher_name: '',
  entry_date: getLocalDateInputValue(),
  entry_month: String(new Date().getMonth() + 1),
  entry_year: String(new Date().getFullYear()),
  weekend_fee: '',
  weekday_fee: '',
  supplemental_fee: '',
  amount_paid: '',
  weekend_paid: false,
  weekday_paid: false,
  supplemental_paid: false,
  payment_method: 'Cash',
  notes: '',
};
const [financialLedger, setFinancialLedger] = useState([]);
const [loadingFinancialLedger, setLoadingFinancialLedger] = useState(false);
const [showLedgerModal, setShowLedgerModal] = useState(false);
const [editingLedgerRecord, setEditingLedgerRecord] = useState(null);
const [ledgerModalMode, setLedgerModalMode] = useState('charge');
const [ledgerForm, setLedgerForm] = useState(emptyLedgerForm);
const [showReceiptModal, setShowReceiptModal] = useState(false);
const [receiptRecord, setReceiptRecord] = useState(null);
const [isSharingReceipt, setIsSharingReceipt] = useState(false);
const [showAddnewFee, setShowAddnewFee] = useState(false);
const [newFee, setNewFee] = useState({
  month: '',
  year: '',
  amount_due: '',
  amount_paid: '',
  status: 'Unpaid',
});
const [showAddFeeModal, setShowAddFeeModal] = useState(false);
const [showEditFeeModal, setShowEditFeeModal] = useState(false);
const [showPayBalanceModal, setShowPayBalanceModal] = useState(false);
const [payBalanceAmount, setPayBalanceAmount] = useState('');
const [selectedFee, setSelectedFee] = useState(null);
const [editFeeData, setEditFeeData] = useState({
  amount_paid: '',
  status: '',
});
const [useExistingParent, setUseExistingParent] = useState(false);
const [selectedExistingParentId, setSelectedExistingParentId] = useState(null);
const [reportParents, setReportParents] = useState([]);
const [selectedReportParents, setSelectedReportParents] = useState(null);
const [unpaidReports, setUnpaidReports] = useState([]);
const [parentFeeReport, setParentFeeReport] = useState({ summary: {}, parents: [] });
const [loadingParentFeeReport, setLoadingParentFeeReport] = useState(false);
const [parentFeeReportSearch, setParentFeeReportSearch] = useState('');
const [selectedMonth, setSelectedMonth] = useState('');
const initialReportMonthOption = () => {
  const now = new Date();
  return { value: now.getMonth() + 1, label: now.toLocaleString('en-US', { month: 'short' }) };
};
const initialReportYearOption = () => {
  const year = new Date().getFullYear();
  return { value: year, label: year.toString() };
};
const [selectedReportMonth, setSelectedReportMonth] = useState(initialReportMonthOption);
const [selectedReportYear, setSelectedReportYear] = useState(initialReportYearOption);
const [showFinancialReport, setShowFinancialReport] = useState(false);
const [financialReportSearch, setFinancialReportSearch] = useState('');
const [financialReportPage, setFinancialReportPage] = useState(1);
const [coParents, setCoParents] = useState([]);
const [assignParentId, setAssignParentId] = useState('');
const [showAssignParentModal, setShowAssignParentModal] = useState(false);
const [selectedParentToAssign, setSelectedParentToAssign] = useState(null);
const [allParents, setAllParents] = useState([]);
const initialCoParentForm = {
  mode: 'new',
  existing_parent_id: '',
  first_name: '',
  last_name: '',
  phone_number: '',
};
const [showCoParentModal, setShowCoParentModal] = useState(false);
const [coParentForm, setCoParentForm] = useState(initialCoParentForm);
const [editingCoParent, setEditingCoParent] = useState(null);
const [showCoParentActionModal, setShowCoParentActionModal] = useState(false);
const [coParentActionId, setCoParentActionId] = useState('');

// --- Parent Notes (inline) ---
const [notes, setNotes] = useState([]);
const [loadingNotes, setLoadingNotes] = useState(false);
const [newNoteText, setNewNoteText] = useState('');
const [editingNoteId, setEditingNoteId] = useState(null);
const [editingNoteText, setEditingNoteText] = useState('');
const [noteToDelete, setNoteToDelete] = useState(null); // { id, text }

const {
  showNotes,
  setShowNotes,
  notesStudent,
  openNotesFor,
} = useStudentNotes();

const {
  showGoals,
  setShowGoals,
  goalsStudent,
  openGoalsFor,
} = useStudentGoals();


const [reportInsights, setReportInsights] = useState({
  totalMeetings: 0,
  byStudent: {},
  ranked: [],
  bestStudent: null,
  worstStudent: null,
  bestStudents: [],
  worstStudents: [],
});









const reportParentSource = reportParents.length > 0 ? reportParents : parents;
const parentOptions = [
  { value: 'ALL', label: '🟢 All Parents' },
  ...reportParentSource.map(p => ({
    value: p.id,
    label: `${p.first_name} ${p.last_name} — ${formatPhone(p.phone_number)}`,
  })),
];

const monthOptions = [
  { value: null, label: 'All Months' }, // ✅ Use null instead of empty string
  ...[
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ].map((m, i) => ({ value: i + 1, label: m }))
];


const currentYear = new Date().getFullYear();
const yearOptions = [
  { value: '', label: 'All Years' },
  ...Array.from({ length: 5 }, (_, i) => ({
    value: currentYear - i,
    label: (currentYear - i).toString(), // ✅ Fix here
  }))
];

const feeMonthOptions = monthOptions.filter((opt) => opt.value);
const feeYearOptions = yearOptions.filter((opt) => opt.value);
const currentReportMonthOption = useMemo(initialReportMonthOption, []);
const currentReportYearOption = useMemo(initialReportYearOption, []);

const studentFullName = editableStudent
  ? `${editableStudent.first_name || ''} ${editableStudent.last_name || ''}`.trim()
  : '';

const studentInitials = studentFullName
  ? studentFullName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || '')
      .join('')
  : 'S';

useEffect(() => {
  setStudentAvatarError(false);
}, [showStudentDetailsModal, editableStudent?.id]);




const openNotesForStudent = (student) => {
  setSelectedStudent(student);
  // close the student list modal so we don't have 2 modals
  setShowStudentModal(false);

  if (notesApi?.loadForStudent) {
    notesApi.loadForStudent(student.id);
  }
  setShowNotesModal(true);
};

const openGoalsForStudent = (student) => {
  setSelectedStudent(student);
  setShowStudentModal(false);

  if (goalsApi?.loadForStudent) {
    goalsApi.loadForStudent(student.id);
  }
  setShowGoalsModal(true);
};








const handleAudioUpload = (e) => {
  // no-op: audio uploads removed for SMS-only
};
















useEffect(() => {
  const fetchParents = async () => {
    try {
      const res = await axios.get(`${API_URL}/parents`, authHeader());
      setAllParents(res.data); // ✅ must set into `allParents`
    } catch (err) {
      console.error('Failed to fetch parents:', err);
    }
  };

  fetchParents();
}, []);


useEffect(() => {
  if (selectedParent?.id) fetchCoParents(selectedParent.id);
  else setCoParents([]);
}, [selectedParent]);





const fetchFinancials = async (parentId) => {
  try {
    setLoadingFinancials(true);
    const res = await axios.get(`${API_URL}/parents/${parentId}/financials`, authHeader());
    setFinancials(res.data);
  } catch (err) {
    console.error('Failed to fetch financials:', err);
    toast.error('Failed to load financials');
  } finally {
    setLoadingFinancials(false);
  }
};

const fetchFinancialLedger = async (parentId) => {
  try {
    setLoadingFinancialLedger(true);
    const res = await axios.get(`${API_URL}/parents/${parentId}/financial-ledger`, authHeader());
    setFinancialLedger(res.data || []);
  } catch (err) {
    console.error('Failed to fetch financial ledger:', err);
    toast.error('Failed to load financial ledger');
  } finally {
    setLoadingFinancialLedger(false);
  }
};

const getLedgerStudentName = (record) => {
  const fromRecord = `${record?.student_first_name || ''} ${record?.student_last_name || ''}`.trim();
  if (fromRecord) return fromRecord;
  const student = parentStudents.find((s) => String(s.id) === String(record?.student_id));
  return student ? `${student.first_name} ${student.last_name}` : 'General';
};

const getLedgerTotals = () => financialLedger.reduce((totals, record) => {
  const weekend = parseFloat(record.weekend_fee) || 0;
  const weekday = parseFloat(record.weekday_fee) || 0;
  const supplemental = parseFloat(record.supplemental_fee) || 0;
  const totalDue = parseFloat(record.total_due) || weekend + weekday + supplemental;
  const paid = parseFloat(record.amount_paid) || 0;
  totals.totalDue += totalDue;
  totals.totalPaid += paid;
  totals.balance += totalDue - paid;
  return totals;
}, { totalDue: 0, totalPaid: 0, balance: 0 });

const getMonthStartDate = (month, year) => {
  const monthNumber = parseInt(month, 10);
  const yearNumber = parseInt(year, 10);
  if (!monthNumber || !yearNumber) return getLocalDateInputValue();
  return `${yearNumber}-${String(monthNumber).padStart(2, '0')}-01`;
};

const getLedgerPeriod = (record) => {
  const key = getDateOnlyKey(record?.entry_date);
  if (!key) return { month: new Date().getMonth() + 1, year: new Date().getFullYear() };
  const [year, month] = key.split('-').map((part) => parseInt(part, 10));
  return { month, year };
};

const getLedgerPeriodLabel = (record) => {
  const { month, year } = getLedgerPeriod(record);
  return `${formatMonthLabel(month)} ${year}`;
};

const RECEIPT_TIME_ZONE = 'America/Chicago';

const parseReceiptTimestamp = (value) => {
  if (!value) return new Date();
  if (value instanceof Date) return value;

  const text = String(value).trim();
  const mysqlTimestamp = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
  if (mysqlTimestamp) {
    const [, year, month, day, hour = '00', minute = '00', second = '00'] = mysqlTimestamp;
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    );
  }

  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? new Date() : date;
};

const formatReceiptDateTime = (value) => (
  parseReceiptTimestamp(value).toLocaleString('en-US', {
    timeZone: RECEIPT_TIME_ZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  })
);

const getPaidLabel = (isPaid) => (isPaid ? 'Paid' : 'Not paid');
const getVisibleLedgerNote = (note) => (
  String(note || '').trim() === 'Auto-created from saved fee setup' ? '' : note
);

const getParentLedgerDefaults = () => ({
  weekend_fee: editableParent?.parent_weekend_fee ?? '',
  weekday_fee: editableParent?.parent_weekday_fee ?? '',
  supplemental_fee: editableParent?.parent_supplemental_fee ?? '',
});

const getLedgerReceiptItems = (record = {}) => {
  if (Array.isArray(record.receipt_items)) {
    return record.receipt_items.filter((item) => (parseFloat(item.amount) || 0) > 0);
  }

  const items = [
    { label: 'Weekend Fee', amount: parseFloat(record.weekend_fee) || 0, paid: Boolean(record.weekend_paid) },
    { label: 'Weekday Fee', amount: parseFloat(record.weekday_fee) || 0, paid: Boolean(record.weekday_paid) },
    { label: 'Supplemental Fee', amount: parseFloat(record.supplemental_fee) || 0, paid: Boolean(record.supplemental_paid) },
  ];
  return items.filter((item) => item.paid && item.amount > 0);
};

const getLedgerReceiptTotal = (record = {}) => (
  getLedgerReceiptItems(record).reduce((total, item) => total + item.amount, 0)
);

const getLedgerReceiptBalance = (record = {}) => {
  if (record.receipt_balance !== undefined && record.receipt_balance !== null) {
    return Math.max(0, parseFloat(record.receipt_balance) || 0);
  }

  const totalDue =
    (parseFloat(record.weekend_fee) || 0) +
    (parseFloat(record.weekday_fee) || 0) +
    (parseFloat(record.supplemental_fee) || 0);
  return Math.max(0, totalDue - getLedgerReceiptTotal(record));
};

// Receipt records normalize ledger/monthly-fee data into one shape that the
// receipt modal, print window, text share, and image share can all use.
const buildLedgerReceiptRecord = (record = {}) => {
  const period = getLedgerPeriod(record);
  return {
    ...record,
    receipt_number: `MS-${record.id || 'NEW'}-${period.year}${String(period.month).padStart(2, '0')}`,
    parent_name: `${editableParent?.first_name || ''} ${editableParent?.last_name || ''}`.trim(),
    parent_phone: editableParent?.phone_number || '',
    period_label: getLedgerPeriodLabel(record),
    receipt_date: formatReceiptDateTime(record.payment_recorded_at || record.updated_at || record.created_at),
    receipt_total: getLedgerReceiptTotal(record),
    receipt_balance: getLedgerReceiptBalance(record),
  };
};

const openLedgerReceipt = (record) => {
  const receipt = buildLedgerReceiptRecord(record);
  if (receipt.receipt_total <= 0) {
    toast.info('No payment recorded for this receipt');
    return;
  }
  setReceiptRecord(receipt);
  setShowReceiptModal(true);
};

const buildMonthlyFeeReceiptRecord = (fee = {}) => {
  const amountPaid = parseFloat(fee.amount_paid) || 0;
  const amountDue = parseFloat(fee.amount_due) || 0;
  const balance = Math.max(0, amountDue - amountPaid);
  return {
    ...fee,
    receipt_number: `MS-FEE-${fee.id || 'NEW'}-${fee.year}${String(fee.month).padStart(2, '0')}`,
    parent_name: `${editableParent?.first_name || ''} ${editableParent?.last_name || ''}`.trim(),
    parent_phone: editableParent?.phone_number || '',
    period_label: `${formatMonthLabel(fee.month)} ${fee.year}`,
    receipt_date: formatReceiptDateTime(fee.updated_at || fee.created_at),
    payment_method: fee.payment_method || 'Cash',
    receipt_items: [{ label: 'Monthly Fee', amount: amountPaid }],
    receipt_total: amountPaid,
    receipt_balance: balance,
  };
};

const openMonthlyFeeReceipt = (fee) => {
  const receipt = buildMonthlyFeeReceiptRecord(fee);
  if (receipt.receipt_total <= 0) {
    toast.info('No payment recorded for this receipt');
    return;
  }
  setReceiptRecord(receipt);
  setShowReceiptModal(true);
};

const getReceiptText = (receipt = receiptRecord) => {
  if (!receipt) return '';
  const lines = [
    'MarkazSync Payment Receipt',
    `Receipt: ${receipt.receipt_number}`,
    `Parent: ${receipt.parent_name || 'Parent'}`,
    receipt.parent_phone ? `Phone: ${formatPhone(receipt.parent_phone)}` : null,
    `Period: ${receipt.period_label}`,
    `Date: ${receipt.receipt_date}`,
    `Payment Method: ${receipt.payment_method || 'Cash'}`,
    '',
    ...getLedgerReceiptItems(receipt).map((item) => `${item.label}: $${formatMoney(item.amount)}`),
    '',
    `Total Paid: $${formatMoney(receipt.receipt_total)}`,
    `Balance: $${formatMoney(receipt.receipt_balance)}`,
  ].filter(Boolean);
  return lines.join('\n');
};

const escapeReceiptHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

const handlePrintReceipt = () => {
  if (!receiptRecord) return;
  const items = getLedgerReceiptItems(receiptRecord)
    .map((item) => `
      <tr>
        <td>${escapeReceiptHtml(item.label)}</td>
        <td style="text-align:right;">$${formatMoney(item.amount)}</td>
      </tr>
    `)
    .join('');
  const printWindow = window.open('', '_blank', 'width=720,height=720');
  if (!printWindow) {
    toast.error('Allow pop-ups to print this receipt');
    return;
  }

  printWindow.document.write(`
    <html>
      <head>
        <title>Receipt ${receiptRecord.receipt_number}</title>
        <style>
          body { font-family: Arial, sans-serif; color: #111827; padding: 28px; }
          .receipt { max-width: 620px; margin: 0 auto; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; }
          h1 { margin: 0 0 6px; font-size: 24px; }
          .muted { color: #6b7280; font-size: 13px; }
          .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 18px; margin: 22px 0; }
          .label { color: #6b7280; font-size: 12px; text-transform: uppercase; font-weight: 700; }
          .value { font-size: 15px; font-weight: 700; margin-top: 3px; }
          table { width: 100%; border-collapse: collapse; margin-top: 18px; }
          td { padding: 10px 0; border-bottom: 1px solid #e5e7eb; }
          .total { margin-top: 18px; text-align: right; font-size: 20px; font-weight: 800; color: #047857; }
          .balance { margin-top: 6px; text-align: right; font-size: 14px; font-weight: 700; color: #b91c1c; }
        </style>
      </head>
      <body>
        <div class="receipt">
          <h1>Payment Receipt</h1>
          <div class="muted">MarkazSync</div>
          <div class="grid">
          <div><div class="label">Receipt</div><div class="value">${escapeReceiptHtml(receiptRecord.receipt_number)}</div></div>
          <div><div class="label">Date</div><div class="value">${escapeReceiptHtml(receiptRecord.receipt_date)}</div></div>
          <div><div class="label">Parent</div><div class="value">${escapeReceiptHtml(receiptRecord.parent_name || 'Parent')}</div></div>
          <div><div class="label">Phone</div><div class="value">${escapeReceiptHtml(formatPhone(receiptRecord.parent_phone) || '-')}</div></div>
          <div><div class="label">Period</div><div class="value">${escapeReceiptHtml(receiptRecord.period_label)}</div></div>
          <div><div class="label">Method</div><div class="value">${escapeReceiptHtml(receiptRecord.payment_method || 'Cash')}</div></div>
          </div>
          <table>${items}</table>
          <div class="total">Total Paid: $${formatMoney(receiptRecord.receipt_total)}</div>
          <div class="balance">Balance: $${formatMoney(receiptRecord.receipt_balance)}</div>
        </div>
        <script>window.onload = () => { window.print(); window.close(); };</script>
      </body>
    </html>
  `);
  printWindow.document.close();
};

const drawRoundedRect = (ctx, x, y, width, height, radius) => {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
};

const drawReceiptImageText = (ctx, text, x, y, maxWidth, lineHeight) => {
  const words = String(text || '').split(' ');
  let line = '';
  let currentY = y;

  words.forEach((word) => {
    const testLine = line ? `${line} ${word}` : word;
    if (ctx.measureText(testLine).width > maxWidth && line) {
      ctx.fillText(line, x, currentY);
      line = word;
      currentY += lineHeight;
    } else {
      line = testLine;
    }
  });

  if (line) ctx.fillText(line, x, currentY);
  return currentY;
};

const createReceiptImageFile = async (receipt) => {
  // Web Share works best with a real image file, so the receipt is drawn on a
  // canvas and exported as PNG for sharing to Messages, AirDrop, WhatsApp, etc.
  const items = getLedgerReceiptItems(receipt);
  const width = 760;
  const rowHeight = 46;
  const height = 700 + (items.length * rowHeight);
  const scale = Math.min(window.devicePixelRatio || 2, 3);
  const canvas = document.createElement('canvas');
  canvas.width = width * scale;
  canvas.height = height * scale;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  const ctx = canvas.getContext('2d');
  ctx.scale(scale, scale);

  ctx.fillStyle = '#f8fafc';
  ctx.fillRect(0, 0, width, height);

  ctx.shadowColor = 'rgba(15, 23, 42, 0.10)';
  ctx.shadowBlur = 18;
  ctx.shadowOffsetY = 8;
  ctx.fillStyle = '#ffffff';
  drawRoundedRect(ctx, 36, 32, width - 72, height - 64, 18);
  ctx.fill();
  ctx.shadowColor = 'transparent';

  ctx.fillStyle = '#0f172a';
  ctx.font = '700 34px Arial, sans-serif';
  ctx.fillText('Payment Receipt', 72, 92);
  ctx.fillStyle = '#64748b';
  ctx.font = '600 17px Arial, sans-serif';
  ctx.fillText('MarkazSync', 72, 124);

  ctx.textAlign = 'right';
  ctx.fillStyle = '#0f766e';
  ctx.font = '700 18px Arial, sans-serif';
  ctx.fillText(receipt.receipt_number || 'Receipt', width - 72, 92);
  ctx.textAlign = 'left';

  const details = [
    ['Date', receipt.receipt_date],
    ['Parent', receipt.parent_name || 'Parent'],
    ['Phone', formatPhone(receipt.parent_phone) || '-'],
    ['Period', receipt.period_label],
    ['Method', receipt.payment_method || 'Cash'],
  ];

  let detailY = 178;
  details.forEach(([label, value], index) => {
    const colX = index % 2 === 0 ? 72 : 410;
    if (index > 0 && index % 2 === 0) detailY += 70;

    ctx.fillStyle = '#64748b';
    ctx.font = '700 13px Arial, sans-serif';
    ctx.fillText(String(label).toUpperCase(), colX, detailY);
    ctx.fillStyle = '#111827';
    ctx.font = '700 20px Arial, sans-serif';
    drawReceiptImageText(ctx, value, colX, detailY + 30, 270, 24);
  });

  let y = detailY + 86;
  ctx.strokeStyle = '#e5e7eb';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(72, y);
  ctx.lineTo(width - 72, y);
  ctx.stroke();

  y += 34;
  ctx.fillStyle = '#64748b';
  ctx.font = '700 13px Arial, sans-serif';
  ctx.fillText('ITEM', 72, y);
  ctx.textAlign = 'right';
  ctx.fillText('AMOUNT', width - 72, y);
  ctx.textAlign = 'left';

  y += 28;
  items.forEach((item) => {
    ctx.fillStyle = '#111827';
    ctx.font = '600 20px Arial, sans-serif';
    ctx.fillText(item.label, 72, y);
    ctx.textAlign = 'right';
    ctx.fillText(`$${formatMoney(item.amount)}`, width - 72, y);
    ctx.textAlign = 'left';
    y += rowHeight;
  });

  y += 20;
  ctx.fillStyle = '#ecfdf5';
  drawRoundedRect(ctx, 72, y, width - 144, 72, 14);
  ctx.fill();
  ctx.fillStyle = '#047857';
  ctx.font = '700 18px Arial, sans-serif';
  ctx.fillText('Total Paid', 98, y + 45);
  ctx.textAlign = 'right';
  ctx.font = '800 30px Arial, sans-serif';
  ctx.fillText(`$${formatMoney(receipt.receipt_total)}`, width - 98, y + 48);
  ctx.textAlign = 'left';

  y += 96;
  ctx.fillStyle = '#fff7ed';
  drawRoundedRect(ctx, 72, y, width - 144, 58, 14);
  ctx.fill();
  ctx.fillStyle = '#b91c1c';
  ctx.font = '700 17px Arial, sans-serif';
  ctx.fillText('Balance', 98, y + 36);
  ctx.textAlign = 'right';
  ctx.font = '800 23px Arial, sans-serif';
  ctx.fillText(`$${formatMoney(receipt.receipt_balance)}`, width - 98, y + 38);
  ctx.textAlign = 'left';

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 0.95));
  if (!blob) throw new Error('Could not create receipt image');

  const fileName = `${String(receipt.receipt_number || 'receipt').replace(/[^a-z0-9_-]+/gi, '_')}.png`;
  return new File([blob], fileName, { type: 'image/png' });
};

const handleShareReceipt = async () => {
  if (isSharingReceipt) return;

  const text = getReceiptText();
  if (!text) return;

  setIsSharingReceipt(true);
  try {
    const imageFile = await createReceiptImageFile(receiptRecord);
    if (navigator.canShare?.({ files: [imageFile] }) && navigator.share) {
      await navigator.share({
        title: 'Payment Receipt',
        files: [imageFile],
      });
    } else if (navigator.share) {
      await navigator.share({ title: 'Payment Receipt', text });
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      toast.success('Receipt copied to clipboard');
    } else {
      toast.info('Sharing is not supported in this browser');
    }
  } catch (err) {
    if (err?.name !== 'AbortError') {
      console.error('Could not share receipt:', err);
      toast.error('Could not share receipt');
    }
  } finally {
    setIsSharingReceipt(false);
  }
};

const handleWhatsAppReceipt = async () => {
  if (isSharingReceipt) return;

  const text = getReceiptText();
  if (!text) return;

  setIsSharingReceipt(true);
  try {
    const imageFile = await createReceiptImageFile(receiptRecord);
    let copiedImage = false;

    if (navigator.clipboard && window.ClipboardItem) {
      await navigator.clipboard.write([
        new ClipboardItem({ [imageFile.type]: imageFile }),
      ]);
      copiedImage = true;
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    }

    const message = copiedImage
      ? 'Payment receipt image copied. Paste it into this WhatsApp chat.'
      : text;
    const whatsappUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    const opened = window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

    if (!opened) {
      toast.error('Allow pop-ups to open WhatsApp');
      return;
    }

    toast.success(copiedImage ? 'Receipt image copied. Paste it in WhatsApp.' : 'Receipt text copied. Paste it in WhatsApp.');
  } catch (err) {
    if (err?.name !== 'AbortError') {
      console.error('Could not open WhatsApp receipt:', err);
      toast.error('Could not prepare WhatsApp receipt');
    }
  } finally {
    setIsSharingReceipt(false);
  }
};

const handleSaveLedgerFeeSetup = async () => {
  if (!editableParent?.id) return;
  try {
    await axios.put(
      `${API_URL}/parents/${editableParent.id}`,
      { ...editableParent, auto_create_ledger_charge: true },
      authHeader()
    );
    setSelectedParent(editableParent);
    fetchParents();
    await fetchFinancialLedger(editableParent.id);
    toast.success('Fee setup saved');
  } catch (err) {
    console.error('Failed to save fee setup:', err);
    toast.error('Failed to save fee setup');
  }
};

const openAddLedgerRecord = () => {
  setEditingLedgerRecord(null);
  setLedgerModalMode('charge');
  setLedgerForm({
    ...emptyLedgerForm,
    ...getParentLedgerDefaults(),
    entry_month: String(new Date().getMonth() + 1),
    entry_year: String(new Date().getFullYear()),
    entry_date: getMonthStartDate(new Date().getMonth() + 1, new Date().getFullYear()),
  });
  setShowLedgerModal(true);
};

const openEditLedgerRecord = (record) => {
  const { month, year } = getLedgerPeriod(record);
  setEditingLedgerRecord(record);
  setLedgerModalMode('charge');
  setLedgerForm({
    student_id: record.student_id || '',
    teacher_name: record.teacher_name || '',
    entry_date: getDateOnlyKey(record.entry_date) || getLocalDateInputValue(),
    entry_month: String(month),
    entry_year: String(year),
    weekend_fee: record.weekend_fee ?? '',
    weekday_fee: record.weekday_fee ?? '',
    supplemental_fee: record.supplemental_fee ?? '',
    amount_paid: record.amount_paid ?? '',
    weekend_paid: Boolean(record.weekend_paid),
    weekday_paid: Boolean(record.weekday_paid),
    supplemental_paid: Boolean(record.supplemental_paid),
    payment_method: record.payment_method || 'Cash',
    notes: record.notes || '',
  });
  setShowLedgerModal(true);
};

const openPayLedgerRecord = (record) => {
  const { month, year } = getLedgerPeriod(record);
  setEditingLedgerRecord(record);
  setLedgerModalMode('pay');
  setLedgerForm({
    student_id: record.student_id || '',
    teacher_name: record.teacher_name || '',
    entry_date: getDateOnlyKey(record.entry_date) || getLocalDateInputValue(),
    entry_month: String(month),
    entry_year: String(year),
    weekend_fee: record.weekend_fee ?? '',
    weekday_fee: record.weekday_fee ?? '',
    supplemental_fee: record.supplemental_fee ?? '',
    amount_paid: record.amount_paid ?? '',
    weekend_paid: Boolean(record.weekend_paid),
    weekday_paid: Boolean(record.weekday_paid),
    supplemental_paid: Boolean(record.supplemental_paid),
    payment_method: record.payment_method || 'Cash',
    notes: record.notes || '',
  });
  setShowLedgerModal(true);
};

const handleLedgerStudentChange = (studentId) => {
  const student = parentStudents.find((s) => String(s.id) === String(studentId));
  const teacherName = student
    ? `${student.teacher_first_name || ''} ${student.teacher_last_name || ''}`.trim()
    : '';
  setLedgerForm((prev) => ({
    ...prev,
    student_id: studentId,
    teacher_name: teacherName || prev.teacher_name,
  }));
};

const handleSaveLedgerRecord = async (e) => {
  e.preventDefault();
  if (!editableParent?.id) return;

  const paymentRecordedAt = new Date().toISOString();
  const payload = {
    ...ledgerForm,
    student_id: ledgerForm.student_id || null,
    entry_date: getMonthStartDate(ledgerForm.entry_month, ledgerForm.entry_year),
    weekend_fee: parseFloat(ledgerForm.weekend_fee) || 0,
    weekday_fee: parseFloat(ledgerForm.weekday_fee) || 0,
    supplemental_fee: parseFloat(ledgerForm.supplemental_fee) || 0,
    weekend_paid: Boolean(ledgerForm.weekend_paid),
    weekday_paid: Boolean(ledgerForm.weekday_paid),
    supplemental_paid: Boolean(ledgerForm.supplemental_paid),
    payment_recorded_at: paymentRecordedAt,
  };

  try {
    let savedRecord = null;
    if (editingLedgerRecord?.id) {
      await axios.put(
        `${API_URL}/parents/${editableParent.id}/financial-ledger/${editingLedgerRecord.id}`,
        payload,
        authHeader()
      );
      savedRecord = { ...editingLedgerRecord, ...payload, id: editingLedgerRecord.id, payment_recorded_at: paymentRecordedAt };
      toast.success('Ledger record updated');
    } else {
      const response = await axios.post(
        `${API_URL}/parents/${editableParent.id}/financial-ledger`,
        payload,
        authHeader()
      );
      savedRecord = { ...payload, id: response.data?.id, payment_recorded_at: paymentRecordedAt };
      toast.success('Ledger record added');
    }
    setShowLedgerModal(false);
    setEditingLedgerRecord(null);
    await fetchFinancialLedger(editableParent.id);
    if (ledgerModalMode === 'pay' && savedRecord) {
      openLedgerReceipt(savedRecord);
    }
  } catch (err) {
    console.error('Failed to save ledger record:', err);
    toast.error(err?.response?.data?.error || 'Failed to save ledger record');
  }
};

const handleDeleteLedgerRecord = (record) => {
  if (!editableParent?.id || !record?.id) return;
  setConfirmAction({ show: true, type: 'delete-ledger-record', payload: record });
};

const openPayLedgerBalance = () => {
  const unpaidRecords = financialLedger
    .filter((record) => (parseFloat(record.balance) || 0) > 0)
    .sort((a, b) => {
      const dateA = new Date(a.entry_date).getTime() || 0;
      const dateB = new Date(b.entry_date).getTime() || 0;
      return dateA - dateB;
    });

  if (!unpaidRecords.length) {
    toast.info('No balance due');
    return;
  }

  openPayLedgerRecord(unpaidRecords[0]);
};

const handleSave = async () => {
  try {
    await axios.put(`${API_URL}/parents/${editableParent.id}`, editableParent, authHeader());
    toast.success('Parent updated');
    setSelectedParent(editableParent);
    setEditMode(false);
    setShowParentProfile(false); // ✅ instead of onClose()
    fetchParents();              // ✅ refresh
  } catch (err) {
    console.error(err);
    toast.error('Update failed');
  }
};

const handleAddFee = async (e) => {
  e.preventDefault();

  try {
    await axios.post(`${API_URL}/parents/${editableParent.id}/financials`, {
      month: newFee.month,
      year: newFee.year,
      amount_due: parseFloat(newFee.amount),
      amount_paid: newFee.status === 'Paid' ? parseFloat(newFee.amount) : 0,
      status: newFee.status
    }, authHeader());

    toast.success('Fee added successfully');
    setShowAddFeeModal(false);
    setNewFee({ month: '', year: '', amount: '', status: '' });
    // Refresh financials
    axios
      .get(`${API_URL}/parents/${editableParent.id}/financials`, authHeader())
      .then(res => setFinancials(res.data));
  } catch (err) {
    console.error('Error adding fee:', err);
    toast.error('Failed to add fee');
  }
};

const handleAddFeeSubmit = async (e) => {
  e.preventDefault();
  if (!editableParent?.id) return;

  try {
    const amountDue = parseFloat(newFee.amount_due);
    const amountPaidRaw = newFee.amount_paid === '' ? 0 : parseFloat(newFee.amount_paid);
    if (!newFee.month || !newFee.year || Number.isNaN(amountDue)) {
      toast.error('Please fill in month, year, and amount due.');
      return;
    }

    await axios.post(
      `${API_URL}/parents/${editableParent.id}/financials`,
      {
        month: parseInt(newFee.month, 10),
        year: parseInt(newFee.year, 10),
        amount_due: amountDue,
        amount_paid: Number.isNaN(amountPaidRaw) ? 0 : amountPaidRaw,
        status: newFee.status || 'Unpaid',
      },
      authHeader()
    );
    toast.success('Fee added successfully');
    setShowAddFeeModal(false);
    setNewFee({
      month: '',
      year: '',
      amount_due: '',
      amount_paid: '',
      status: 'Unpaid',
    });
    fetchFinancials(editableParent.id); // refresh data
  } catch (err) {
    console.error('Error adding fee:', err);
    toast.error('Failed to add fee');
  }
};

const handleEditFeeSubmit = async (e) => {
  e.preventDefault();
  try {
    const amountPaidRaw = editFeeData.amount_paid === '' ? 0 : parseFloat(editFeeData.amount_paid);
    await axios.put(
      `${API_URL}/parents/${editableParent.id}/financials/${selectedFee.id}`,
      {
        amount_paid: Number.isNaN(amountPaidRaw) ? 0 : amountPaidRaw,
        status: editFeeData.status || selectedFee?.status || 'Unpaid',
      },
      authHeader()
    );
    await fetchFinancials(editableParent.id);
    setShowEditFeeModal(false);
    setSelectedFee(null);
    toast.success('Fee updated successfully!');
  } catch (err) {
    console.error(err);
    toast.error('Failed to update fee');
  }
};


const handleDeleteFee = (fee) => {
  if (!editableParent?.id || !fee?.id) return;
  setConfirmAction({ show: true, type: 'delete-fee', payload: fee });
};

const getTotalBalanceDue = () => {
  return financials
    .filter(fee => fee.status !== 'Paid')
    .reduce((acc, fee) => acc + (parseFloat(fee.amount_due) - parseFloat(fee.amount_paid)), 0)
    .toFixed(2);
};

const handleSaveMonthlyFee = async () => {
  if (!editableParent?.id) return;
  try {
    await axios.put(
      `${API_URL}/parents/${editableParent.id}`,
      editableParent,
      authHeader()
    );
    toast.success('Monthly fee updated');
    setSelectedParent(editableParent);
    await Promise.all([
      fetchParents(),
      fetchFinancials(editableParent.id)
    ]);
  } catch (err) {
    console.error('Error updating monthly fee:', err);
    toast.error('Failed to update monthly fee');
  }
};

const handleClearMonthlyFee = async () => {
  if (!editableParent?.id) return;
  try {
    const updatedParent = {
      ...editableParent,
      monthly_fee: ''
    };
    await axios.put(
      `${API_URL}/parents/${editableParent.id}`,
      updatedParent,
      authHeader()
    );
    setEditableParent(updatedParent);
    setSelectedParent(updatedParent);
    await Promise.all([
      fetchParents(),
      fetchFinancials(editableParent.id)
    ]);
    toast.success('Monthly fee cleared');
  } catch (err) {
    console.error('Error clearing monthly fee:', err);
    toast.error('Failed to clear monthly fee');
  }
};

const handlePayFee = async (fee) => {
  if (!editableParent?.id || !fee?.id) return;
  setConfirmAction({ show: true, type: 'pay-fee', payload: fee });
};

const handlePayBalance = () => {
  if (!editableParent?.id) return;
  const unpaid = financials.filter((fee) => fee.status !== 'Paid');
  if (unpaid.length === 0) return;
  setPayBalanceAmount('');
  setShowPayBalanceModal(true);
};

const applyPaymentToFees = async (totalAmount) => {
  const unpaid = financials
    .map((fee) => ({
      ...fee,
      balance: (parseFloat(fee.amount_due) || 0) - (parseFloat(fee.amount_paid) || 0),
    }))
    .filter((fee) => fee.balance > 0)
    .sort((a, b) => (b.year - a.year) || (b.month - a.month));

  if (unpaid.length === 0) return;

  let remaining = totalAmount;
  await Promise.all(
    unpaid.map((fee) => {
      if (remaining <= 0) return Promise.resolve();
      const pay = Math.min(fee.balance, remaining);
      remaining -= pay;
      const newPaid = (parseFloat(fee.amount_paid) || 0) + pay;
      const status = newPaid >= (parseFloat(fee.amount_due) || 0) ? 'Paid' : 'Partial';
      return axios.put(
        `${API_URL}/parents/${editableParent.id}/financials/${fee.id}`,
        { amount_paid: newPaid, status },
        authHeader()
      );
    })
  );
};

const handlePayBalanceFull = async () => {
  if (!editableParent?.id) return;
  const total = parseFloat(getTotalBalanceDue());
  if (!Number.isFinite(total) || total <= 0) return;
  try {
    await applyPaymentToFees(total);
    await fetchFinancials(editableParent.id);
    setShowPayBalanceModal(false);
    toast.success('Balance paid');
  } catch (err) {
    console.error('Error paying balance:', err);
    toast.error('Failed to pay balance');
  }
};

const handlePayBalancePartial = async () => {
  if (!editableParent?.id) return;
  const amount = parseFloat(payBalanceAmount);
  if (!Number.isFinite(amount) || amount <= 0) {
    toast.error('Enter a valid amount');
    return;
  }
  const total = parseFloat(getTotalBalanceDue());
  const payAmount = Math.min(amount, total);
  try {
    await applyPaymentToFees(payAmount);
    await fetchFinancials(editableParent.id);
    setShowPayBalanceModal(false);
    toast.success('Partial payment recorded');
  } catch (err) {
    console.error('Error paying balance:', err);
    toast.error('Failed to record partial payment');
  }
};

const fetchUnpaidBalances = async () => {
  try {
    let parentIds = [];

    if (selectedReportParents?.value === 'ALL') {
      parentIds = [];
    } else if (Array.isArray(selectedReportParents)) {
      parentIds = selectedReportParents.map(p => p.value);
    } else if (selectedReportParents?.value) {
      parentIds = [selectedReportParents.value];
    }

    const effectiveMonth = selectedReportMonth?.value ? selectedReportMonth : currentReportMonthOption;
    const effectiveYear = selectedReportYear?.value ? selectedReportYear : currentReportYearOption;
    setSelectedReportMonth(effectiveMonth);
    setSelectedReportYear(effectiveYear);

    const monthValue = effectiveMonth?.value;
    const yearValue = effectiveYear?.value;

    const response = await axios.post(
      `${API_URL}/parents/report-unpaid`,
      {
        parentIds,
        month: monthValue,  // ✅ sends null or number
        year: yearValue
      },
      authHeader()
    );

    setUnpaidReports(response.data);
    setFinancialReportPage(1);
  } catch (err) {
    toast.error('Failed to fetch financial report');
    console.error(err);
  }
};

const fetchParentFeeReport = async () => {
  try {
    setLoadingParentFeeReport(true);
    let parentIds = [];
    if (selectedReportParents?.value === 'ALL') {
      parentIds = [];
    } else if (selectedReportParents?.value) {
      parentIds = [selectedReportParents.value];
    }

    const params = {};
    if (parentIds.length > 0) params.parentIds = parentIds.join(',');
    const effectiveMonth = selectedReportMonth?.value ? selectedReportMonth : currentReportMonthOption;
    const effectiveYear = selectedReportYear?.value ? selectedReportYear : currentReportYearOption;
    setSelectedReportMonth(effectiveMonth);
    setSelectedReportYear(effectiveYear);

    params.month = effectiveMonth?.value;
    params.year = effectiveYear?.value;

    const response = await axios.get(`${API_URL}/parents/financial-ledger-report`, {
      ...authHeader(),
      params,
    });
    setParentFeeReport({
      summary: response.data?.summary || {},
      parents: response.data?.rows || response.data?.parents || [],
    });
    setFinancialReportPage(1);
  } catch (err) {
    toast.error('Failed to fetch financial report');
    console.error(err);
  } finally {
    setLoadingParentFeeReport(false);
  }
};

const getParentFeeReportExportRows = () => filteredParentFeeReportRows.map((parent) => ({
  Month: formatMonthLabel(parent.month),
  Year: parent.year || '',
  Parent: `${parent.first_name || ''} ${parent.last_name || ''}`.trim(),
  Phone: formatPhone(parent.phone_number),
  'Weekend Due': Number(formatMoney(parent.weekend_due)),
  'Weekend Paid': Number(formatMoney(parent.weekend_paid)),
  'Weekday Due': Number(formatMoney(parent.weekday_due)),
  'Weekday Paid': Number(formatMoney(parent.weekday_paid)),
  'Supplemental Due': Number(formatMoney(parent.supplemental_due)),
  'Supplemental Paid': Number(formatMoney(parent.supplemental_paid)),
  'Payment Method': parent.payment_method || '',
  'Total Due': Number(formatMoney(parent.total_due)),
  'Total Paid': Number(formatMoney(parent.total_paid)),
  Balance: Number(formatMoney(parent.balance)),
  Status: parent.status || '',
}));

const getParentFeeReportFileBase = () => {
  const month = selectedReportMonth?.value ? formatMonthLabel(selectedReportMonth.value) : 'all-months';
  const year = selectedReportYear?.value || 'all-years';
  return `parent-financial-report-${String(month).toLowerCase()}-${year}`;
};

const downloadReportBlob = (content, fileName, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const exportParentFeeReportCsv = () => {
  const rows = getParentFeeReportExportRows();
  if (!rows.length) {
    toast.warn('No financial report rows to export');
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(worksheet);
  downloadReportBlob(`\uFEFF${csv}`, `${getParentFeeReportFileBase()}.csv`, 'text/csv;charset=utf-8;');
  toast.success('Financial report CSV exported');
};

const exportParentFeeReportSheet = () => {
  const rows = getParentFeeReportExportRows();
  if (!rows.length) {
    toast.warn('No financial report rows to export');
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet['!cols'] = [
    { wch: 12 },
    { wch: 8 },
    { wch: 24 },
    { wch: 16 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 18 },
    { wch: 18 },
    { wch: 18 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Financial Report');
  XLSX.writeFile(workbook, `${getParentFeeReportFileBase()}.xlsx`);
  toast.success('Financial report spreadsheet exported');
};

const token = localStorage.getItem('token');

const loadParentNotes = async (parentId) => {
  try {
    setLoadingNotes(true);
    const res = await fetch(`${API_URL}/parents/${parentId}/notes`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (res.status === 401 || res.status === 403) {
      handleSessionExpired();
      return;
    }
    if (!res.ok) throw new Error('Failed to load notes');
    const data = await res.json();
    setNotes(data);
  } catch (e) {
    console.error(e);
    toast.error('Could not load notes');
  } finally {
    setLoadingNotes(false);
  }
};

const handleAddNote = async (e) => {
  e.preventDefault();
  if (!newNoteText.trim()) return toast.warn('Please type a note first');

  try {
    const { data } = await axios.post(
      `${API_URL}/parents/${editableParent.id}/notes`,
      { note_text: newNoteText.trim() },
      authHeader()
    );
    setNotes(prev => [data, ...prev]);
    setNewNoteText('');
    toast.success('Note added');
    // keep dashboard "Recent Parent Notes" in sync
    fetchSummary?.();
  } catch (err) {
    console.error('Add note failed', err?.response?.status, err?.response?.data);
    toast.error(`Failed to add note${err?.response?.status ? ` (${err.response.status})` : ''}`);
  }
};


const startEditNote = (note) => {
  setEditingNoteId(note.id);
  setEditingNoteText(note.note_text);
};

const cancelEditNote = () => {
  setEditingNoteId(null);
  setEditingNoteText('');
};

const handleSaveNote = async () => {
  if (!editingNoteText.trim()) return toast.warn('Note cannot be empty');
  try {
    const res = await fetch(`${API_URL}/parents/${editableParent.id}/notes/${editingNoteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ note_text: editingNoteText.trim() })
    });
    if (!res.ok) throw new Error('Failed to update note');
    const updated = await res.json();
    setNotes(prev => prev.map(n => (n.id === editingNoteId ? updated : n)));
    cancelEditNote();
    toast.success('Note updated');
  } catch (e) {
    console.error(e);
    toast.error('Failed to update note');
  }
};

const confirmDeleteNote = (note) => {
  setNoteToDelete({ id: note.id, text: note.note_text });
};

const handleDeleteNote = async () => {
  try {
    const res = await fetch(`${API_URL}/parents/${editableParent.id}/notes/${noteToDelete.id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Failed to delete note');
    setNotes(prev => prev.filter(n => n.id !== noteToDelete.id));
    setNoteToDelete(null);
    toast.success('Note deleted');
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete note');
  }
};

const fmtDateTime = (s) => {
  try { return new Date(s).toLocaleString(); } catch { return s; }
};

// months (approx) between today and provided date string
const monthsSince = (dateStr) => {
  if (!dateStr) return '—';
  const created = new Date(dateStr);
  if (Number.isNaN(created.getTime())) return '—';
  const diffMs = Date.now() - created.getTime();
  const months = diffMs / (1000 * 60 * 60 * 24 * 30.44); // average month length
  return Math.max(0, Math.floor(months));
};

const formatMoney = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric.toFixed(2) : '0.00';
};

const formatMonthLabel = (monthValue) => {
  const monthNumber = parseInt(monthValue, 10);
  return monthOptions.find(m => m.value === monthNumber)?.label || monthValue;
};

const FeePaymentStatus = ({ paid, due }) => {
  const paidAmount = parseFloat(paid) || 0;
  const dueAmount = parseFloat(due) || 0;
  const status = dueAmount <= 0
    ? 'none'
    : paidAmount >= dueAmount
      ? 'paid'
      : paidAmount > 0
        ? 'partial'
        : 'unpaid';
  return (
    <span
      className={`fee-payment-status fee-payment-status--${status}`}
      title={status === 'paid' ? 'Paid' : status === 'partial' ? 'Partial' : status === 'none' ? 'No charge' : 'Not paid'}
    >
      <span className="fee-payment-status__amount">${formatMoney(dueAmount)}</span>
    </span>
  );
};

const financialReportPageSize = 10;
const normalizedFinancialReportSearch = financialReportSearch.trim().toLowerCase();
const filteredFinancialReports = unpaidReports.filter((report) => {
  if (!normalizedFinancialReportSearch) return true;
  const searchableText = [
    report.first_name,
    report.last_name,
    report.phone_number,
    formatPhone(report.phone_number),
    formatMonthLabel(report.month),
    report.year,
    report.status,
    report.amount_due,
    report.amount_paid,
    report.balance
  ].join(' ').toLowerCase();
  return searchableText.includes(normalizedFinancialReportSearch);
});
const financialReportTotalPages = Math.max(1, Math.ceil(filteredFinancialReports.length / financialReportPageSize));
const currentFinancialReportPage = Math.min(financialReportPage, financialReportTotalPages);
const paginatedFinancialReports = filteredFinancialReports.slice(
  (currentFinancialReportPage - 1) * financialReportPageSize,
  currentFinancialReportPage * financialReportPageSize
);
const financialReportStart = filteredFinancialReports.length === 0
  ? 0
  : (currentFinancialReportPage - 1) * financialReportPageSize + 1;
const financialReportEnd = Math.min(currentFinancialReportPage * financialReportPageSize, filteredFinancialReports.length);
const financialReportSummary = unpaidReports.reduce((summary, report) => {
  const parentKey = report.parent_id || `${report.first_name}-${report.last_name}-${report.phone_number}`;
  const status = String(report.status || '').toLowerCase();
  summary.totalParents.add(parentKey);
  if (status === 'paid') {
    summary.paidParents.add(parentKey);
  } else if (status === 'partial') {
    summary.partialParents.add(parentKey);
    summary.notPaidParents.add(parentKey);
  } else {
    summary.unpaidParents.add(parentKey);
    summary.notPaidParents.add(parentKey);
  }
  summary.totalDue += parseFloat(report.amount_due) || 0;
  summary.totalPaid += parseFloat(report.amount_paid) || 0;
  summary.totalBalance += parseFloat(report.balance) || 0;
  return summary;
}, {
  totalParents: new Set(),
  paidParents: new Set(),
  partialParents: new Set(),
  unpaidParents: new Set(),
  notPaidParents: new Set(),
  totalDue: 0,
  totalPaid: 0,
  totalBalance: 0
});
const ledgerTotals = getLedgerTotals();
const parentFeeReportRows = parentFeeReport.parents || [];
const filteredParentFeeReportRows = parentFeeReportRows;
const parentFeeReportTotalPages = Math.max(1, Math.ceil(filteredParentFeeReportRows.length / financialReportPageSize));
const currentParentFeeReportPage = Math.min(financialReportPage, parentFeeReportTotalPages);
const paginatedParentFeeReportRows = filteredParentFeeReportRows.slice(
  (currentParentFeeReportPage - 1) * financialReportPageSize,
  currentParentFeeReportPage * financialReportPageSize
);
const parentFeeReportStart = filteredParentFeeReportRows.length === 0
  ? 0
  : (currentParentFeeReportPage - 1) * financialReportPageSize + 1;
const parentFeeReportEnd = Math.min(currentParentFeeReportPage * financialReportPageSize, filteredParentFeeReportRows.length);
const parentFeeReportTotals = parentFeeReportRows.reduce((totals, parent) => {
  totals.totalDue += parseFloat(parent.total_due) || 0;
  totals.totalPaid += parseFloat(parent.total_paid) || 0;
  totals.balance += parseFloat(parent.balance) || 0;
  if (parent.status === 'Paid') totals.paidParents += 1;
  if (parent.status === 'Partial') totals.partialParents += 1;
  if (parent.status === 'Unpaid') totals.unpaidParents += 1;
  return totals;
}, {
  totalDue: 0,
  totalPaid: 0,
  balance: 0,
  paidParents: 0,
  partialParents: 0,
  unpaidParents: 0,
});
const parentFeeSummary = parentFeeReport.summary || {};
const parentFeeDashboard = parentFeeReportRows.reduce((dashboard, row) => {
  const weekendDue = parseFloat(row.weekend_due) || 0;
  const weekendPaid = parseFloat(row.weekend_paid) || 0;
  const weekdayDue = parseFloat(row.weekday_due) || 0;
  const weekdayPaid = parseFloat(row.weekday_paid) || 0;
  const supplementalDue = parseFloat(row.supplemental_due) || 0;
  const supplementalPaid = parseFloat(row.supplemental_paid) || 0;

  dashboard.weekendBalance += Math.max(0, weekendDue - weekendPaid);
  dashboard.weekdayBalance += Math.max(0, weekdayDue - weekdayPaid);
  dashboard.supplementalBalance += Math.max(0, supplementalDue - supplementalPaid);
  dashboard.weekendCollected += weekendPaid;
  dashboard.weekdayCollected += weekdayPaid;
  dashboard.supplementalCollected += supplementalPaid;
  dashboard.totalCollected += parseFloat(row.total_paid) || 0;
  dashboard.totalBalance += parseFloat(row.balance) || 0;

  return dashboard;
}, {
  weekendBalance: 0,
  weekdayBalance: 0,
  supplementalBalance: 0,
  weekendCollected: 0,
  weekdayCollected: 0,
  supplementalCollected: 0,
  totalCollected: 0,
  totalBalance: 0,
});
const parentFeeStatusCounts = {
  paid: parentFeeReportTotals.paidParents,
  partial: parentFeeReportTotals.partialParents,
  unpaid: parentFeeReportTotals.unpaidParents,
};







const fetchAllParentsForReport = async () => {
  try {
    const res = await axios.get(`${API_URL}/parents`, authHeader());
    setReportParents(res.data);
  } catch (err) {
    toast.error('Failed to load parents');
  }
};








const handleSaveParentUpdate = async () => {
  try {
    await axios.put(
      `${API_URL}/parents/${editableParent.id}`,
      editableParent,
      authHeader()
    );
    toast.success('Parent updated');
    setSelectedParent(editableParent);
    setEditMode(false);
    fetchParents(); // reload parent list
  } catch (err) {
    console.error('Error updating parent:', err);
    toast.error('Update failed');
  }
};




useEffect(() => {
  if (selectedParent?.id) {
    setEditableParent(selectedParent);
    setEditMode(false);
    if (isAlsunahMarkaz) {
      if (showMonthlyFeeFinancials) {
        setLoadingFinancials(true);
        axios
          .get(`${API_URL}/parents/${selectedParent.id}/financials`, authHeader())
          .then(res => setFinancials(res.data))
          .catch(err => {
            console.error('Error fetching financials:', err);
            toast.error('Could not load financial records');
          })
          .finally(() => setLoadingFinancials(false));
      } else {
        setFinancials([]);
        setLoadingFinancials(false);
      }
      fetchFinancialLedger(selectedParent.id);
    } else {
      setFinancials([]);
      setLoadingFinancials(false);
      setFinancialLedger([]);
      setLoadingFinancialLedger(false);
    }
  }
}, [selectedParent, isAlsunahMarkaz, showMonthlyFeeFinancials]);

// Load notes whenever the Parent Profile is open and we have a parent id
useEffect(() => {
  if (showParentProfile && editableParent?.id) {
    loadParentNotes(editableParent.id);
  }
  // optional: clear notes when modal closes so old notes don't flash
  if (!showParentProfile) {
    setNotes([]);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [showParentProfile, editableParent?.id]);

useEffect(() => {
  if (!showFinancialReport) {
    setUnpaidReports([]);
    setSelectedReportParents(null);
    setSelectedReportMonth(currentReportMonthOption);
    setSelectedReportYear(currentReportYearOption);
  }
}, [showFinancialReport, currentReportMonthOption, currentReportYearOption]);

useEffect(() => {
  if (activeTab !== 'reporting-parents') {
    setUnpaidReports([]);
    setSelectedReportParents(null);
    setSelectedReportMonth(currentReportMonthOption);
    setSelectedReportYear(currentReportYearOption);
    setParentFeeReportSearch('');
  } else if (isAlsunahMarkaz) {
    setSelectedReportMonth((month) => month || currentReportMonthOption);
    setSelectedReportYear((year) => year || currentReportYearOption);
    fetchAllParentsForReport();
    fetchParentFeeReport();
  }
}, [activeTab, isAlsunahMarkaz, currentReportMonthOption, currentReportYearOption]);














const loadStudents = async () => {
  try {
    const res = await axios.get(`${API_URL}/students/all`, authHeader());
    setStudents(res.data);
  } catch (err) {
    console.error('❌ Failed to fetch all students:', err);
    toast.error('Failed to load students');
  }
};

const handleCSVUpload = async (e) => {
  e.preventDefault();

  if (!csvFile) return toast.error("Please select a file.");
  if (!selectedClassId) return toast.error("No class selected for upload.");

  const fileName = csvFile.name.toLowerCase().trim();
  const isCsv = fileName.endsWith('.csv');
  const isExcel = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');

  if (!isCsv && !isExcel) {
    return toast.error("Only .csv, .xlsx, or .xls files are allowed.");
  }

  try {
    const arrayBuffer = await csvFile.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const rows = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      blankrows: false,
      defval: ''
    });

    const { data } = await axios.post(`${API_URL}/students/upload-sheet`, {
      class_id: selectedClassId,
      rows
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    const [classList] = await Promise.all([
      fetchAllClasses(),
      fetchClasses(),
      fetchAllStudents(),
      loadStudents(),
      fetchParents(),
      fetchSummary()
    ]);

    if (showStudentModal && selectedClass?.id) {
      const refreshedClass =
        (Array.isArray(classList) ? classList.find((cls) => cls.id === selectedClass.id) : null) ||
        selectedClass;
      await fetchStudentsInClass(refreshedClass);
    }

    const importedCount = data?.imported ?? 0;
    const skippedCount = data?.skipped ?? 0;
    const parts = [
      `Imported ${importedCount} student${importedCount === 1 ? '' : 's'}`
    ];
    if (skippedCount) {
      parts.push(`skipped ${skippedCount}`);
    }
    toast.success(`${parts.join(', ')}.`);
    setCsvFile(null);
    setShowCSVModal(false);
  } catch (err) {
    console.error("CSV Upload Error:", err);
    toast.error(err?.response?.data?.error || "Upload failed.");
  }
};

const handleDownloadStudentTemplate = () => {
  const templateRows = [
    ['student name', 'parent name', 'parent phone number'],
    ['Ayaan Mohamed', 'Nuroow Hussein', '612-229-4256'],
    ['nimco kaafi', 'Hassan Omar', '612-353-9844']
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(templateRows);
  worksheet['!cols'] = [
    { wch: 28 },
    { wch: 28 },
    { wch: 22 }
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
  XLSX.writeFile(workbook, 'student-upload-template.xlsx');
};




  // ✅ Fetch students when component mounts
  useEffect(() => {
    loadStudents();
  }, []);





const handleNav = (tabName) => {
  setActiveTab(tabName);
  // close only on small / medium screens
  if (window.innerWidth < 992) setSidebarOpen(false);
};

// Accordion open/close toggle
const handleAccordionSelect = (eventKey) => {
  setActiveAccordionKey(prevKey => (prevKey === eventKey ? null : eventKey));
};





const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const handleSessionExpired = () => {
  if (sessionExpiredRef.current) return;
  sessionExpiredRef.current = true;
  toast.error('Your session expired. Please log in again.');
  logout();
  navigate('/login');
};

const handleApiError = (err, fallbackMsg) => {
  const status = err?.response?.status;
  if (status === 401 || status === 403) {
    handleSessionExpired();
    return;
  }
  if (status >= 500) {
    toast.error('Server issue. Please try again later.');
    return;
  }
  if (fallbackMsg) toast.error(fallbackMsg);
};

const fetchFormDocuments = async () => {
  try {
    setFormsLoading(true);
    const { data } = await axios.get(`${API_URL}/forms`, authHeader());
    setFormDocuments(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error('Failed to load forms', err);
    handleApiError(err, 'Could not load forms');
  } finally {
    setFormsLoading(false);
  }
};

const handleUploadFormDocument = async (event) => {
  event.preventDefault();
  if (!formsUpload.file) {
    toast.error('Please choose a PDF or image to upload.');
    return;
  }

  const uploadData = new FormData();
  uploadData.append('title', formsUpload.title || formsUpload.file.name);
  uploadData.append('document', formsUpload.file);

  try {
    setFormsUploading(true);
    const { data } = await axios.post(`${API_URL}/forms`, uploadData, {
      headers: {
        ...authHeader().headers,
      },
    });
    setFormDocuments((prev) => [data, ...prev]);
    setFormsUpload({ title: '', file: null });
    event.target.reset();
    toast.success('Document uploaded');
  } catch (err) {
    console.error('Failed to upload form', err);
    handleApiError(err, err?.response?.data?.error || 'Could not upload document');
  } finally {
    setFormsUploading(false);
  }
};

const handleViewFormDocument = async (documentRecord) => {
  const token = localStorage.getItem('token');
  if (!token) {
    handleSessionExpired();
    return;
  }

  const url = `${API_URL}/forms/${documentRecord.id}/file?token=${encodeURIComponent(token)}`;
  setFormPreview({
    show: true,
    document: documentRecord,
    url,
    isImage: String(documentRecord.mime_type || '').startsWith('image/'),
  });
};

const closeFormPreview = () => {
  setFormPreview({ show: false, document: null, url: '', isImage: false });
};

const handleDeleteFormDocument = async (documentRecord) => {
  if (!window.confirm(`Delete "${documentRecord.title}"?`)) return;

  try {
    await axios.delete(`${API_URL}/forms/${documentRecord.id}`, authHeader());
    setFormDocuments((prev) => prev.filter((item) => item.id !== documentRecord.id));
    toast.success('Document deleted');
  } catch (err) {
    console.error('Failed to delete form', err);
    handleApiError(err, 'Could not delete document');
  }
};

const fetchTodos = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/admin/todos`, authHeader());
    setTodos(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error('Failed to load todos', err);
    handleApiError(err, 'Could not load to-do list');
  }
};

const addTodo = async (text) => {
  if (!text?.trim()) return;
  try {
    const { data } = await axios.post(
      `${API_URL}/admin/todos`,
      { text: text.trim() },
      authHeader()
    );
    setTodos((prev) => [data, ...prev]);
  } catch (err) {
    console.error('Failed to add todo', err);
    handleApiError(err, 'Could not add task');
  }
};

const toggleTodo = async (todo) => {
  try {
    const { data } = await axios.put(
      `${API_URL}/admin/todos/${todo.id}`,
      { done: !todo.done },
      authHeader()
    );
    setTodos((prev) => prev.map((t) => (t.id === todo.id ? data : t)));
  } catch (err) {
    console.error('Failed to update todo', err);
    handleApiError(err, 'Could not update task');
  }
};

const deleteTodo = async (todoId) => {
  try {
    await axios.delete(`${API_URL}/admin/todos/${todoId}`, authHeader());
    setTodos((prev) => prev.filter((t) => t.id !== todoId));
  } catch (err) {
    console.error('Failed to delete todo', err);
    handleApiError(err, 'Could not delete task');
  }
};

useEffect(() => {
  if (!currentUser || currentUser.role !== 'admin') {
    navigate('/login');
  } else {
    fetchSummary();
    fetchTodos();
  }
}, [currentUser]);

  useEffect(() => {
    if (showStudentDetailsModal) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showStudentDetailsModal]);

  // When opening Add Student modal, ensure parents are loaded for "existing parent" selector
  useEffect(() => {
    if (showAddStudentModal && parents.length === 0) {
      fetchParents();
    }
  }, [showAddStudentModal, parents.length]);

  useEffect(() => {
    const fetchStudents = async () => {
      if (reportFilters.class_id) {
        try {
          const res = await axios.get(`${API_URL}/students/class/${reportFilters.class_id}`, authHeader());
          setReportStudents(res.data);
        } catch (err) {
          console.error('❌ Failed to fetch students for report:', err);
        }
      }
    };

  
    fetchStudents();
  }, [reportFilters.class_id]);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!openDropdownId) return;
      const menuRoot = event.target instanceof Element
        ? event.target.closest('[data-class-actions-root="true"]')
        : null;
      if (!menuRoot) {
        setOpenDropdownId(null);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [openDropdownId]);
  


  const fetchAllClasses = async () => {
    try {
      const res = await axios.get(`${API_URL}/classes/all`, authHeader());
      setAllClasses(res.data);
      return res.data;
    } catch (err) {
      console.error('Failed to fetch classes:', err);
      handleApiError(err, 'Failed to fetch classes');
      return [];
    }
  };

  useEffect(() => {
    if (activeTab === 'classes') {
      fetchAllClasses();
      fetchTeachers();
    }

    if (activeTab === 'students') {
      fetchAllStudents();
      fetchParents(); // useful for assigning
    }
    
    if (activeTab === 'parents') fetchParents();

    if (activeTab === 'teachers') fetchTeachers();

    if (activeTab === 'forms') fetchFormDocuments();
    setSidebarOpen(false); // ✅ close sidebar on mobile when tab changes
  }, [activeTab]);

  const fetchSummary = async () => {
    try {
      setSummaryLoading(true);
      const res = await axios.get(`${API_URL}/admin/summary`, authHeader());
      setSummary(res.data || { recentParentNotes: [] });
    } catch (err) {
      handleApiError(err, 'Failed to load summary');
    } finally {
      setSummaryLoading(false);
    }
  };

  const fetchTeachers = async () => {
    const data = await getArray('/users/teachers', 'Teachers');
    setTeachers(data);
  };
  
  const fetchClasses = async () => {
    try {
      const response = await axios.get(`${API_URL}/classes/all`
        , authHeader());
      setClasses(response.data);
      return response.data;
    } catch (err) {
      toast.error("Failed to fetch classes");
      return [];
    }
  };
  
  
  
  

  const fetchParents = async () => {
    try {
      const res = await axios.get(`${API_URL}/parents`, authHeader());
      setParents(res.data);
      setAllParents(res.data);
      return res.data;
    } catch (err) {
      console.error('Failed to fetch parents', err);
      handleApiError(err, 'Failed to fetch parents');
      return [];
    }
  };

  const fetchCoParents = async (parentId) => {
    if (!parentId) {
      setCoParents([]);
      return [];
    }

    try {
      const res = await axios.get(`${API_URL}/parents/${parentId}/other-parents`, authHeader());
      setCoParents(res.data || []);
      return res.data || [];
    } catch (err) {
      console.error('Failed to fetch co-parents:', err);
      handleApiError(err, 'Failed to load other parents');
      return [];
    }
  };

  const fetchParentStudents = async (parentId) => {
    if (!parentId) return [];
    try {
      const res = await axios.get(`${API_URL}/parents/${parentId}/students`, authHeader());
      setParentStudents(res.data);
      return res.data;
    } catch (err) {
      console.error('Error fetching parent students:', err);
      handleApiError(err, 'Failed to load assigned students');
      return [];
    }
  };

  const handleViewParentProfile = async (parent, tab = 'profile') => {
    setParentProfileTab(tab);
    setSelectedParent(parent);                   // Show parent immediately
    setEditableParent({ ...parent });            // Initialize inline editing state
    setEditMode(false);                          // Start in view mode
    setParentStudents([]);                       // Clear previous students
    setShowParentProfile(true);                  // Show modal
  
    await Promise.all([
      fetchParentStudents(parent.id),
      allClasses.length ? Promise.resolve(allClasses) : fetchAllClasses(),
      allStudents.length ? Promise.resolve(allStudents) : fetchAllStudents(),
    ]);
};
  
  
  
  
  

  const fetchStudentsInClass = async (cls) => {
    try {
      const res = await axios.get(`${API_URL}/students/class/${cls.id}`, authHeader());
      setSelectedClass(cls);
      setStudentsInClass(res.data);
      setShowStudentModal(true);
    } catch (err) {
      console.error('Failed to load students for class', err);
      handleApiError(err, 'Failed to load students for this class');
    }
  };

  const fetchAllStudents = async () => {
    try {
      const res = await axios.get(`${API_URL}/students/all`, authHeader());
      setAllStudents(res.data);
      return res.data;
    } catch (err) {
      console.error('Failed to fetch students', err);
      handleApiError(err, 'Failed to fetch students');
      return [];
    }
  };

  

  const handleCreateClass = async () => {
      if (!newClassName) return toast.error('Class name is required');
  
    try {
      const response = await axios.post(`${API_URL}/classes`, { name: newClassName }, authHeader());
      console.log('✅ Class created:', response.data);
  
      setNewClassName('');
      fetchAllClasses();
      toast.success('Class created successfully');
      setShowAddClassModal(false); // if using modal
    } catch (error) {
      console.error('❌ Error creating class:', error);
      toast.error(error?.response?.data?.error || 'Failed to create class');
    }
  };

  const fetchWaitingList = async () => {
    try {
      const res = await axios.get(`${API_URL}/waiting-list`, authHeader());
      setWaitingList(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch waiting list:", err);
      toast.error("Could not load waiting list");
    }
  };

  useEffect(() => {
    if (activeTab === 'waiting') {
      fetchWaitingList();
    }
  }, [activeTab]);
  
  

  const handleStartClassEdit = (cls) => {
    setEditClassId(cls.id);
    setEditClassName(cls.name);
    setEditShift(normalizeShiftLabel(cls.shift) || '');
  };
  

  const handleSaveClassEdit = async () => {
    if (!editClassName || !editShift) {
      toast.error('Class name and shift are required');
      return;
    }
  
    try {
      await axios.put(
        `${API_URL}/classes/${editClassId}`,
        { name: editClassName, shift: editShift },
        authHeader()
      );
  
      toast.success('✅ Class updated successfully');
      fetchAllClasses();       // Refresh class list
      setEditClassId(null);    // Exit edit mode
    } catch (err) {
      toast.error(err?.response?.data?.error || '❌ Failed to update class');
      console.error('Edit class error:', err);
    }
  };
  

  const handleDeleteClass = (cls) => {
    setConfirmAction({ show: true, type: 'delete-class', payload: cls });
  };

  const handleSaveStudent = async () => {
    if (!editableStudent?.id) return;

    try {
      const selectedClassForStudent = allClasses.find((cls) => String(cls.id) === String(editableStudent.class_id));
      const classChanged = String(selectedStudent?.class_id || '') !== String(editableStudent.class_id || '');
      const nextShift = classChanged
        ? (selectedClassForStudent?.shift || editableStudent.shift)
        : editableStudent.shift;

      await axios.put(
        `${API_URL}/students/${editableStudent.id}`,
        {
          first_name: editableStudent.first_name,
          last_name: editableStudent.last_name,
          shift: nextShift,
          class_id: editableStudent.class_id || undefined,
        },
        authHeader()
      );
  
      toast.success('Student updated successfully');
  
      const updatedStudent = {
        ...editableStudent,
        shift: nextShift,
        class_name: selectedClassForStudent?.name || editableStudent.class_name,
        teacher_name: getClassTeacherName(editableStudent.class_id) || editableStudent.teacher_name,
      };

      setSelectedStudent(updatedStudent);
      setEditableStudent(updatedStudent);
      setEditMode(false);
      setShowStudentDetailsModal(false);
      await Promise.all([
        fetchAllStudents(),
        selectedParent?.id ? fetchParentStudents(selectedParent.id) : Promise.resolve([]),
        selectedClass?.id ? fetchStudentsInClass(selectedClass) : Promise.resolve([]),
      ]);
    } catch (error) {
      console.error('Error updating student:', error);
      toast.error(error?.response?.data?.error || 'Failed to update student');
    }
  };

  const openMoveStudentModal = async (student) => {
    await fetchAllClasses();
    setStudentToMove(student);
    setTargetClassId(String(student.class_id || selectedClass?.id || ''));
    setShowMoveStudentModal(true);
  };

  const handleMoveStudent = async () => {
    if (!studentToMove?.id && !studentToMove?.student_id) return;
    if (!targetClassId) {
      toast.error('Please select a class');
      return;
    }

    const studentId = studentToMove.student_id || studentToMove.id;
    try {
      await axios.put(
        `${API_URL}/students/${studentId}`,
        {
          first_name: studentToMove.student_first_name || studentToMove.first_name,
          last_name: studentToMove.student_last_name || studentToMove.last_name,
          shift: studentToMove.shift || 'Morning Weekend',
          class_id: Number(targetClassId),
        },
        authHeader()
      );

      toast.success('Student moved successfully');
      setStudentsInClass((prev) => prev.filter((student) => student.id !== studentId));
      setShowMoveStudentModal(false);
      setStudentToMove(null);
      setTargetClassId('');
      await Promise.all([fetchAllStudents(), fetchAllClasses()]);
      if (selectedParent?.id) {
        await fetchParentStudents(selectedParent.id);
      }
      if (selectedClass?.id) {
        await fetchStudentsInClass(selectedClass);
      }
    } catch (error) {
      console.error('Error moving student:', error);
      toast.error(error?.response?.data?.error || 'Failed to move student');
    }
  };


  const handleAssignToParent = async (e) => {
    e.preventDefault();
  
    if (!selectedStudent || !selectedParentToAssign) return;
  
    const studentId = selectedStudent.student_id || selectedStudent.id;
    const parentId = selectedParentToAssign?.value;
  
    // ✅ ADD THIS HERE
    console.log("📤 Sending payload:", {
      student_id: studentId,
      parent_id: parentId,
    });
  
    try {
      const response = await fetch(`${API_URL}/parents/assign-student`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader().headers.Authorization,
        },
        body: JSON.stringify({
          student_id: studentId,
          parent_id: parentId,
        }),
      });
  
      if (!response.ok) throw new Error('Failed to assign parent');
  
      toast.success('Student assigned to parent successfully!');
      setShowAssignParentModal(false);
      setSelectedParentToAssign(null);
      setSelectedStudent(null);
      fetchAllStudents?.(); // reload table
    } catch (err) {
      console.error(err);
      toast.error('Error assigning student to parent');
    }
  };
  
  const getStudentId = (student) => student?.student_id || student?.id;

  const parentLinkedStudentIds = new Set(parentStudents.map((student) => String(getStudentId(student))));

  const parentExistingStudentOptions = allStudents
    .filter((student) => !parentLinkedStudentIds.has(String(getStudentId(student))))
    .map((student) => {
      const studentId = getStudentId(student);
      const name = `${student.student_first_name || student.first_name || ''} ${student.student_last_name || student.last_name || ''}`.trim();
      const className = student.class_name ? ` - ${student.class_name}` : '';
      return {
        value: studentId,
        label: `${name}${className}`,
      };
    });

  const coParentLinkedIds = new Set([
    selectedParent?.id ? String(selectedParent.id) : '',
    ...coParents.map((parent) => String(parent.id)),
  ].filter(Boolean));

  const coParentExistingOptions = allParents
    .filter((parent) => !coParentLinkedIds.has(String(parent.id)))
    .map((parent) => ({
      value: parent.id,
      label: `${parent.first_name} ${parent.last_name} — ${formatPhone(parent.phone_number) || 'No phone'}`,
    }));

  const openParentStudentModal = async () => {
    if (!selectedParent?.id) return;
    await Promise.all([
      allClasses.length ? Promise.resolve(allClasses) : fetchAllClasses(),
      allStudents.length ? Promise.resolve(allStudents) : fetchAllStudents(),
    ]);
    setParentStudentForm(initialParentStudentForm);
    setShowParentStudentModal(true);
  };

  const handleParentStudentClassChange = (classId) => {
    const selected = allClasses.find((cls) => String(cls.id) === String(classId));
    setParentStudentForm((prev) => ({
      ...prev,
      class_id: classId,
      shift: selected?.shift || prev.shift,
    }));
  };

  const handleSaveParentStudent = async (e) => {
    e.preventDefault();
    if (!selectedParent?.id) return;

    try {
      if (parentStudentForm.mode === 'existing') {
        if (!parentStudentForm.existing_student_id) {
          toast.error('Select a student');
          return;
        }

        await axios.put(
          `${API_URL}/parents/assign-student`,
          {
            student_id: parentStudentForm.existing_student_id,
            parent_id: selectedParent.id,
          },
          authHeader()
        );
        toast.success('Student linked to parent');
      } else {
        if (!parentStudentForm.first_name || !parentStudentForm.last_name || !parentStudentForm.class_id) {
          toast.error('Student name and class are required');
          return;
        }

        await axios.post(
          `${API_URL}/students/admin-add`,
          {
            first_name: parentStudentForm.first_name,
            last_name: parentStudentForm.last_name,
            class_id: parentStudentForm.class_id,
            shift: parentStudentForm.shift,
            parent_id: selectedParent.id,
          },
          authHeader()
        );
        toast.success('Student added to parent');
      }

      setShowParentStudentModal(false);
      setParentStudentForm(initialParentStudentForm);
      await Promise.all([
        fetchParentStudents(selectedParent.id),
        fetchAllStudents(),
        fetchParents(),
        fetchSummary(),
      ]);
    } catch (err) {
      console.error('Failed to save parent student:', err);
      toast.error(err?.response?.data?.error || 'Failed to save student');
    }
  };

  const handleRemoveStudentFromParent = (student) => {
    if (!selectedParent?.id || !getStudentId(student)) return;
    setConfirmAction({ show: true, type: 'delete-parent-profile-student', payload: student });
  };

  const openCoParentModal = async (mode = 'new', parent = null) => {
    if (!selectedParent?.id) return;
    await fetchParents();

    setEditingCoParent(parent);
    setCoParentForm({
      ...initialCoParentForm,
      mode,
      first_name: parent?.first_name || '',
      last_name: parent?.last_name || '',
      phone_number: parent?.phone_number || '',
    });
    setShowCoParentModal(true);
  };

  const closeCoParentModal = () => {
    setShowCoParentModal(false);
    setEditingCoParent(null);
    setCoParentForm(initialCoParentForm);
  };

  const openCoParentUpdateAction = () => {
    if (coParents.length === 0) return;
    if (coParents.length === 1) {
      openCoParentModal('edit', coParents[0]);
      return;
    }

    setCoParentActionId('');
    setShowCoParentActionModal(true);
  };

  const handleCoParentActionSubmit = () => {
    const selected = coParents.find((parent) => String(parent.id) === String(coParentActionId));
    if (!selected) {
      toast.error('Select a parent');
      return;
    }

    setShowCoParentActionModal(false);
    setCoParentActionId('');
    openCoParentModal('edit', selected);
  };

  const linkParentToCurrentStudents = async (parentId) => {
    const studentIds = parentStudents.map(getStudentId).filter(Boolean);
    if (studentIds.length === 0) {
      throw new Error('Add or assign a student before adding another parent');
    }

    await Promise.all(studentIds.map((studentId) => axios.put(
      `${API_URL}/parents/assign-student`,
      { student_id: studentId, parent_id: parentId },
      authHeader()
    )));
  };

  const handleSaveCoParent = async (e) => {
    e.preventDefault();
    if (!selectedParent?.id) return;

    try {
      if (coParentForm.mode === 'edit') {
        if (!editingCoParent?.id) return;
        await axios.put(
          `${API_URL}/parents/${editingCoParent.id}`,
          {
            first_name: coParentForm.first_name,
            last_name: coParentForm.last_name,
            phone_number: coParentForm.phone_number,
          },
          authHeader()
        );
        toast.success('Other parent updated');
      } else {
        let parentId = coParentForm.existing_parent_id;

        if (coParentForm.mode === 'existing') {
          if (!parentId) {
            toast.error('Select a parent');
            return;
          }
        } else {
          if (!coParentForm.first_name || !coParentForm.last_name || !coParentForm.phone_number) {
            toast.error('First name, last name, and phone are required');
            return;
          }

          const response = await axios.post(
            `${API_URL}/parents`,
            {
              first_name: coParentForm.first_name,
              last_name: coParentForm.last_name,
              phone_number: coParentForm.phone_number,
            },
            authHeader()
          );
          parentId = response.data?.parent_id;
        }

        await linkParentToCurrentStudents(parentId);
        toast.success(coParentForm.mode === 'existing' ? 'Parent linked' : 'Other parent added');
      }

      closeCoParentModal();
      await Promise.all([
        fetchCoParents(selectedParent.id),
        fetchParents(),
        fetchAllStudents(),
      ]);
    } catch (err) {
      console.error('Failed to save other parent:', err);
      toast.error(err?.response?.data?.error || err?.message || 'Failed to save other parent');
    }
  };

  const getClassTeacherName = (classId) => {
    const selected = allClasses.find((cls) => String(cls.id) === String(classId));
    return [selected?.teacher_first_name, selected?.teacher_last_name].filter(Boolean).join(' ').trim() ||
      selected?.teacher_name ||
      '';
  };

  const openParentStudentAction = async (type) => {
    if (type === 'add') {
      openParentStudentModal();
      return;
    }

    await Promise.all([
      allClasses.length ? Promise.resolve(allClasses) : fetchAllClasses(),
      allStudents.length ? Promise.resolve(allStudents) : fetchAllStudents(),
    ]);
    setParentStudentActionType(type);
    setParentStudentActionId('');
    setShowParentStudentActionModal(true);
  };

  const handleParentStudentActionSubmit = () => {
    const selected = parentStudents.find((student) => String(getStudentId(student)) === String(parentStudentActionId));
    if (!selected) {
      toast.error('Select a student');
      return;
    }

    setShowParentStudentActionModal(false);
    setParentStudentActionId('');

    if (parentStudentActionType === 'update') {
      handleEditStudent(selected);
      return;
    }

    if (parentStudentActionType === 'remove') {
      handleRemoveStudentFromParent(selected);
    }
  };
  
  
  
  
  

  const handleSaveStudentEdit = async () => {
    try {
      await axios.put(
        `${API_URL}/students/${editableStudent.id}`,
        {
          first_name: editableStudent.first_name,
          last_name: editableStudent.last_name,
          shift: editableStudent.shift,
          class_id: editableStudent.class_id || undefined,
        },
        authHeader()
      );
  
      toast.success('Student updated successfully');
      setSelectedStudent(editableStudent);
      setEditMode(false);
      await Promise.all([
        fetchAllStudents(),
        selectedParent?.id ? fetchParentStudents(selectedParent.id) : Promise.resolve([]),
      ]);
    } catch (error) {
      console.error('Error updating student:', error);
      toast.error('Failed to update student');
    }
  };
  


  

  const handleViewStudents = async (parentId) => {
    const res = await axios.get(`${API_URL}/parents/${parentId}/students`, authHeader());
    setViewingStudents(res.data);
    setShowStudentListModal(true);
  };
  

  const handleDeleteStudent = (studentId) => {
    setStudentToDelete(studentId);
    setShowDeleteConfirm(true);
  };
  
  

  const handleEditStudent = async (student) => {
    if (!allClasses.length) {
      await fetchAllClasses();
    }

    const fallbackTeacherName = [selectedClass?.teacher_first_name, selectedClass?.teacher_last_name].filter(Boolean).join(' ').trim();
    const parsedStudent = {
      ...student,
      id: student.student_id || student.id,
      first_name: student.student_first_name || student.first_name,
      last_name: student.student_last_name || student.last_name,
      shift: student.shift || '',
      class_name: student.class_name || selectedClass?.name || '',
      class_id: student.class_id || selectedClass?.id || '',
      teacher_name:
        student.teacher_name ||
        [student.teacher_first_name, student.teacher_last_name].filter(Boolean).join(' ').trim() ||
        fallbackTeacherName ||
        '',
    };
  
    setShowStudentModal(false);
    setSelectedStudent(parsedStudent);
    setEditableStudent({ ...parsedStudent });
    setEditMode(true);
    setShowStudentDetailsModal(true);
  };
  
  

  const handleDeleteStudentConfirmed = async () => {
    if (!studentToDelete) return;
  
    try {
      await axios.delete(`${API_URL}/students/${studentToDelete}`, authHeader());
      toast.success('✅ Student deleted successfully');
      fetchAllStudents();
      fetchSummary();
    } catch (err) {
      console.error('Error deleting student:', err);
      toast.error('❌ Failed to delete student');
    } finally {
      setStudentToDelete(null);
      setShowDeleteConfirm(false);
    }
  };
  
  
  

  
  
  const handleEditParent = (parent) => {
    setEditParent(parent);
  };

  const handleDeleteParent = (parent) => {
    setConfirmAction({ show: true, type: 'delete-parent', payload: parent });
  };
  
  const openClassStudentProfile = (student) => {
    setReturnToClassStudents(true);
    setShowStudentModal(false);
    handleViewStudentDetails(student);
  };

  const openParentStudentProfile = (student) => {
    setReturnToParentProfile(true);
    setShowParentProfile(false);
    handleViewStudentDetails(student);
  };

  const openAdminQuranAssignments = (student, returnToClass = false) => {
    setQuranAssignmentsStudent(student);
    setReturnToClassAfterQuran(returnToClass);
    if (returnToClass) setShowStudentModal(false);
    setShowQuranAssignmentsModal(true);
  };

  const closeAdminQuranAssignments = () => {
    setShowQuranAssignmentsModal(false);
    setQuranAssignmentsStudent(null);
    if (returnToClassAfterQuran) setShowStudentModal(true);
    setReturnToClassAfterQuran(false);
  };

  const handleViewStudentDetails = (student) => {
    const fallbackTeacherName = [selectedClass?.teacher_first_name, selectedClass?.teacher_last_name].filter(Boolean).join(' ').trim();
    const parsedStudent = {
      ...student,
      id: student.student_id || student.id,
      first_name: student.student_first_name || student.first_name,
      last_name: student.student_last_name || student.last_name,
      shift: student.shift || '',
      class_name: student.class_name || selectedClass?.name || '',
      class_id: student.class_id || selectedClass?.id || '',
      teacher_name:
        student.teacher_name ||
        [student.teacher_first_name, student.teacher_last_name].filter(Boolean).join(' ').trim() ||
        fallbackTeacherName ||
        '',
    };
  
    setSelectedStudent(parsedStudent);
    setEditableStudent(parsedStudent);
    setEditMode(false); // default to view mode
    setShowStudentDetailsModal(true);
  };
  
  
  
  

  const handleAddStudent = async (e) => {
    e.preventDefault();
  
    if (!currentUser || !currentUser.markaz_id) {
      toast.error('Admin markaz not available. Please re-login.');
      return;
    }

    if (!useExistingParent) {
      if (!newStudent.parent1_first_name || !newStudent.parent1_last_name || !newStudent.parent1_phone) {
        toast.error('Parent 1 is required');
        return;
      }

      const hasPartialParent2 = Boolean(
        newStudent.parent2_first_name ||
        newStudent.parent2_last_name ||
        newStudent.parent2_phone
      );
      const hasCompleteParent2 = Boolean(
        newStudent.parent2_first_name &&
        newStudent.parent2_last_name &&
        newStudent.parent2_phone
      );

      if (hasPartialParent2 && !hasCompleteParent2) {
        toast.error('Complete all Parent 2 fields or leave Parent 2 blank');
        return;
      }
    } else if (!newStudent.parent_id) {
      toast.error('Select Parent 1');
      return;
    }
  
    try {
      const payload = {
        first_name: newStudent.first_name,
        last_name: newStudent.last_name,
        class_id: newStudent.class_id,
        markaz_id: currentUser.markaz_id,
        shift: newStudent.shift,
        ...(useExistingParent && newStudent.parent_id
          ? { parent_id: newStudent.parent_id } // 🔹 Use selected existing parent
          : {
              parents: [
                {
                  first_name: newStudent.parent1_first_name,
                  last_name: newStudent.parent1_last_name,
                  phone_number: newStudent.parent1_phone
                },
                ...(newStudent.parent2_first_name || newStudent.parent2_last_name || newStudent.parent2_phone
                  ? [{
                      first_name: newStudent.parent2_first_name,
                      last_name: newStudent.parent2_last_name,
                      phone_number: newStudent.parent2_phone
                    }]
                  : [])
              ]
            }
        )
      };
  
      const response = await axios.post(`${API_URL}/students/admin-add`, payload, authHeader());
  
      if (response.status === 200 || response.status === 201) {
        toast.success('Student added successfully');
        setNewStudent(initialStudentState);
        setParentSearchTerm('');
        setUseExistingParent(false);
        setShowAddStudentModal(false);
        selectedClass ? fetchStudentsInClass(selectedClass) : fetchAllStudents();
        fetchSummary();
      } else {
        toast.error('Unexpected response from server');
      }
    } catch (err) {
      console.error('Add student error:', err);
      toast.error(err?.response?.data?.error || 'Failed to add student');
    }
  };

  const openAddStudentForSelectedClass = () => {
    if (!selectedClass) return;
    setNewStudent({
      ...initialStudentState,
      class_id: selectedClass.id,
      shift: selectedClass.shift || initialStudentState.shift,
    });
    setShowAddStudentModal(true);
  };
  
  
  

  const handleAddClass = async (e) => {
    e.preventDefault();
  
    if (!newClass.name) return toast.error('Class name is required');
    if (!newClass.shift) return toast.error('Shift is required');
  
    try {
      const response = await axios.post(`${API_URL}/classes`, newClass, authHeader());
  
      if (response.status === 200 || response.status === 201) {
        await Promise.all([fetchAllClasses(), fetchClasses(), fetchSummary()]);
        toast.success('✅ Class created successfully');
        setNewClass({ name: '', shift: '' });  // Reset both fields
        setShowAddClassModal(false);
        setActiveTab('classes');
      } else {
        toast.error('⚠️ Unexpected server response');
      }
    } catch (err) {
      toast.error(err?.response?.data?.error || '❌ Failed to create class');
      console.error('❌ Add class error:', err);
    }
  };
  

  const handleEditTeacher = (teacher) => {
    setEditTeacher({
      ...teacher,
      phone_number: teacher.phone_number || teacher.phone || '',
    });
    setShowUpdateModal(true);
  };

  const generateTempPassword = () => Math.random().toString(36).slice(-10);

  const openAddTeacherModal = () => {
    setNewTeacher({
      ...initialTeacherState,
      password: generateTempPassword(),
    });
    setShowAddTeacherModal(true);
  };
  
  

  const handleAssignToTeacher = (cls) => {
    setSelectedClass(cls);
    setSelectedTeacherId('');
    setShowAssignModal(true);
  };
  
  
  
  
  const handleUpdateTeacher = async () => {
    try {
      await axios.put(`${API_URL}/users/${editTeacher.id}`, {
        first_name: editTeacher.first_name,
        last_name: editTeacher.last_name,
        phone_number: editTeacher.phone_number,
        email: editTeacher.email,
      }, authHeader());
  
      toast.success("Teacher updated successfully");
      fetchTeachers();
      fetchSummary();
      setShowUpdateModal(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to update teacher");
    }
  };

  const handleCreateTeacher = async () => {
    if (!newTeacher.first_name || !newTeacher.last_name || !newTeacher.email || !newTeacher.password) {
      return toast.error('First name, last name, email, and temporary password are required');
    }

    try {
      await axios.post(`${API_URL}/users/teachers`, {
        first_name: newTeacher.first_name,
        last_name: newTeacher.last_name,
        email: newTeacher.email,
        phone_number: newTeacher.phone_number,
        password: newTeacher.password,
      }, authHeader());

      toast.success('Teacher created successfully');
      setShowAddTeacherModal(false);
      setNewTeacher(initialTeacherState);
      fetchTeachers();
      fetchSummary();
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to create teacher');
    }
  };

  const handleDeleteTeacher = async (teacher) => {
    if (!teacher?.id) return;
    setConfirmAction({ show: true, type: 'delete-teacher', payload: teacher });
  };
  
  const handleAssignClassToTeacher = async () => {
    try {
      if (!selectedClass || !selectedTeacherId) return;

      await axios.put(`${API_URL}/classes/${selectedClass.id}/assign-teacher`, {
        teacher_id: selectedTeacherId
      }, authHeader());

      toast.success("Class assigned to teacher successfully");
      setShowAssignModal(false);
      fetchClasses(); // if needed
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to assign class");
    }
  };

  const handleUnassignClassFromTeacher = async (cls) => {
    try {
      await axios.put(
        `${API_URL}/classes/${cls.id}/unassign-teacher`,
        {},
        authHeader()
      );
      toast.success('Teacher unassigned from class');
      fetchClasses?.();
    } catch (err) {
      console.error('Unassign teacher error:', err);
      toast.error(err?.response?.data?.error || 'Failed to unassign teacher');
    }
  };

  const handleTakeAttendance = async (cls) => {
    try {
      const res = await axios.get(`${API_URL}/classes/${cls.id}/students`, authHeader());
      const classWithStudents = { ...cls, students: res.data };
  
      setSelectedClass(classWithStudents);
      setActiveTab('attendance');
      setAttendance({});
      setLateAttendance({});
      setComments({});
    } catch (err) {
      console.error('❌ Failed to fetch students:', err);
      toast.error('Could not load students for this class');
    }
  };

  const setAllAttendance = (status) => {
    const updated = {};
    selectedClass.students.forEach((s) => {
      updated[s.id] = status;
    });
    setAttendance(updated);
    if (status !== 'present') setLateAttendance({});
  };
  
  
  
  const handleAttendanceChange = (studentId, status) => {
    setAttendance((prev) => ({ ...prev, [studentId]: status }));
    if (status !== 'present') {
      setLateAttendance((prev) => ({ ...prev, [studentId]: false }));
    }
  };

  const handleLateChange = (studentId, checked) => {
    setLateAttendance((prev) => ({ ...prev, [studentId]: checked }));
    if (checked) {
      setAttendance((prev) => ({ ...prev, [studentId]: 'present' }));
    }
  };
  
  const handleCommentChange = (studentId, text) => {
    setComments((prev) => ({ ...prev, [studentId]: text }));
  };
  
  const handleSubmitAttendance = async (classId, students) => {
    const attendanceData = students
      .map((s) => ({
        student_id: s.id,
        class_id: classId,
        status: attendance[s.id] || '',
        is_late: attendance[s.id] === 'present' && !!lateAttendance[s.id],
        comment: comments[s.id] || '',
      }))
      .filter((entry) => entry.status);
  
    try {
      await axios.post(`${API_URL}/attendance/mark`, { attendance: attendanceData, date: attendanceDate }, authHeader());
      setAttendance({});
      setLateAttendance({});
      setComments({});
      setAttendanceDate(getLocalDateInputValue());
      setSelectedClass(null);
      setActiveTab('classes');
      await fetchSummary();
      toast.success('Attendance completed successfully');
    } catch (err) {
      console.error('❌ Attendance submission failed:', err);
      toast.error('Failed to submit attendance');
    }
  };




 const handleGenerateReport = async () => {
  try {
    const res = await axios.post(`${API_URL}/attendance/report`, reportFilters, authHeader());
    const rows = res.data || [];
    setReport(rows);

    const insights = computeAttendanceInsights(rows);
    const ranked = Object.values(insights.byStudent || {})
      .sort((a, b) => (b.pct - a.pct) || (a.absent - b.absent) || (b.total - a.total));
    const needsAttentionRanked = Object.values(insights.byStudent || {})
      .sort((a, b) => (b.absent - a.absent) || (a.pct - b.pct) || (b.total - a.total));
    const bestStudent = ranked[0] || null;
    const worstStudent = needsAttentionRanked[0]?.absent > 0 ? needsAttentionRanked[0] : null;
    const bestStudents = bestStudent ? ranked.filter((s) => s.pct === bestStudent.pct) : [];
    const worstStudents = worstStudent ? needsAttentionRanked.filter((s) => s.absent === worstStudent.absent) : [];

    setReportInsights({
      ...insights,
      ranked,
      bestStudent,
      worstStudent,
      bestStudents,
      worstStudents,
    });

    setShowReportModal(true);
  } catch (err) {
    console.error('Failed to generate report:', err);
    toast.error('Error generating attendance report');
  }
};

  
  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text('Attendance Report', 14, 15);
    autoTable(doc, {
      startY: 20,
      head: [['Date', 'First Name', 'Last Name', 'Status', 'Late', 'Comment']],
      body: report.map(r => [
        formatDateOnly(r.date),
        r.first_name, r.last_name, r.status, r.is_late ? 'Yes' : 'No', r.comment || ''
      ])
    });
    doc.save('Attendance_Report.pdf');
  };

  const handleExportInsightsPDF = async () => {
  const doc = new jsPDF();
  const margin = 14;

  doc.setFontSize(16);
  doc.text('Attendance Insights', margin, 16);
  doc.setFontSize(11);
  doc.text(
    `Meetings: ${reportInsights.totalMeetings} | Students: ${Object.keys(reportInsights.byStudent || {}).length}`,
    margin,
    24
  );

  let y = 34;
  doc.setFontSize(13);
  doc.text('Best Attendance', margin, y);
  y += 8;
  doc.setFontSize(11);
  doc.text(
    reportInsights.bestStudents?.length
      ? `${reportInsights.bestStudents.length} student(s) tied at ${reportInsights.bestStudent.pct}%: ${reportInsights.bestStudents.map((s) => s.name).join(', ')}`
      : 'No attendance summary available.',
    margin,
    y
  );

  y += 14;
  doc.setFontSize(13);
  doc.text('Needs Attention', margin, y);
  y += 8;
  doc.setFontSize(11);
  doc.text(
    reportInsights.worstStudents?.length
      ? `${reportInsights.worstStudents.length} student(s) with ${reportInsights.worstStudent.absent} absent day(s): ${reportInsights.worstStudents.map((s) => s.name).join(', ')}`
      : 'No attendance summary available.',
    margin,
    y
  );

  // Leaderboard page
  doc.addPage();
  doc.setFontSize(14);
  doc.text('Leaderboard', margin, 16);

  const rows = (reportInsights.ranked || [])
    .map((s, idx) => [idx + 1, s.name, s.present, s.late, s.absent, s.excused, s.total, `${s.pct}%`]);

  autoTable(doc, {
    startY: 22,
    head: [['#', 'Name', 'Present', 'Late', 'Absent', 'Excused', 'Total', 'Present %']],
    body: rows,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] },
    margin: { left: margin, right: margin },
  });

  doc.save('Attendance_Insights.pdf');
};

  const buildAttendanceReportShareText = () => {
    const best = reportInsights.bestStudents?.length
      ? `${reportInsights.bestStudents.length} student(s) tied at ${reportInsights.bestStudent?.pct}%: ${reportInsights.bestStudents.map((s) => s.name).join(', ')}`
      : 'No best attendance summary available';
    const needsAttention = reportInsights.worstStudents?.length
      ? `${reportInsights.worstStudents.length} student(s) with ${reportInsights.worstStudent?.absent} absent day(s): ${reportInsights.worstStudents.map((s) => s.name).join(', ')}`
      : 'No needs-attention summary available';

    return [
      'Attendance Report',
      `Meetings: ${reportInsights.totalMeetings}`,
      `Students tracked: ${Object.keys(reportInsights.byStudent || {}).length}`,
      `Best Attendance: ${best}`,
      `Needs Attention: ${needsAttention}`,
      `Late arrivals: ${(reportInsights.ranked || []).reduce((sum, s) => sum + (Number(s.late) || 0), 0)}`
    ].join('\n');
  };

  const handleShareAttendanceReport = async () => {
    const text = buildAttendanceReportShareText();
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Attendance Report', text });
        return;
      }
      await navigator.clipboard.writeText(text);
      toast.success('Attendance report summary copied');
    } catch (err) {
      if (err?.name !== 'AbortError') {
        console.error('Share attendance report failed:', err);
        toast.error('Could not share report');
      }
    }
  };

  
  const handleClearReport = () => {
    setReport([]);
    setReportFilters({ class_id: '', student_id: '', start_date: '', end_date: '' });
  };

  const handlePrintReport = () => {
    window.print();
  };

  const isSingleStudentReport = Boolean(reportFilters.student_id);

  const dismissMobilePicker = () => {
    const activeEl = document.activeElement;
    if (
      activeEl &&
      typeof activeEl.blur === 'function' &&
      ['INPUT', 'SELECT', 'TEXTAREA'].includes(activeEl.tagName)
    ) {
      activeEl.blur();
    }
  };
  

  const resetWaitingForm = () => {
    setWaitingForm({
      first_name: '',
      last_name: '',
      parent_name: '',
      parent_phone: '',
      previous_markaz: '',
      shift: '',
      date_added: getLocalDateInputValue(),
    });
    setEditingWaitingEntry(null);
  };

  const openAddWaitingModal = () => {
    resetWaitingForm();
    setShowWaitingModal(true);
  };

  const openEditWaitingModal = (entry) => {
    setEditingWaitingEntry(entry);
    setWaitingForm({
      first_name: entry.first_name || '',
      last_name: entry.last_name || '',
      parent_name: entry.parent_name || '',
      parent_phone: formatPhone(entry.parent_phone || ''),
      previous_markaz: entry.previous_markaz || '',
      shift: entry.shift || '',
      date_added: getLocalDateInputValue(entry.date_added),
    });
    setShowWaitingModal(true);
  };

  const closeWaitingModal = () => {
    setShowWaitingModal(false);
    resetWaitingForm();
  };


  const handleWaitingSubmit = async () => {
    const { first_name, last_name, parent_phone, shift, date_added } = waitingForm;
    if (!first_name || !last_name || !parent_phone || !shift || !date_added) {
      toast.error("Please fill in all fields.");
      return;
    }
  
    try {
      if (editingWaitingEntry?.id) {
        await axios.put(`${API_URL}/waiting-list/${editingWaitingEntry.id}`, waitingForm, authHeader());
        toast.success("Waiting list entry updated.");
      } else {
        await axios.post(`${API_URL}/waiting-list`, waitingForm, authHeader());
        toast.success("Student added to waiting list.");
      }
  
      // ✅ Refresh list
      fetchWaitingList();
      fetchSummary();
  
      // ✅ Reset form & close modal
      closeWaitingModal();
    } catch (err) {
      console.error("Error adding to waiting list:", err);
      const errorMessage = err.response?.data?.error || (editingWaitingEntry?.id ? "Failed to update waiting list entry." : "Failed to add student.");
      toast.error(errorMessage);
    }
  };

  const handleDeleteWaiting = (entry) => {
    setConfirmAction({ show: true, type: 'delete-waiting', payload: entry });
  };

  const openRegisterWaitingModal = async (entry) => {
    const loadedClasses = allClasses.length ? allClasses : await fetchAllClasses();
    const matchingClass = loadedClasses.find((cls) => cls.shift === entry.shift);

    setWaitingRegistration({
      show: true,
      entry,
      class_id: matchingClass?.id ? String(matchingClass.id) : '',
      submitting: false,
    });
  };

  const closeRegisterWaitingModal = () => {
    setWaitingRegistration({
      show: false,
      entry: null,
      class_id: '',
      submitting: false,
    });
  };

  const handleRegisterWaitingStudent = async () => {
    if (!waitingRegistration.entry?.id) return;

    if (!waitingRegistration.class_id) {
      toast.error('Please select a class.');
      return;
    }

    setWaitingRegistration((current) => ({ ...current, submitting: true }));

    try {
      await axios.post(
        `${API_URL}/waiting-list/${waitingRegistration.entry.id}/register`,
        { class_id: waitingRegistration.class_id },
        authHeader()
      );

      toast.success('Student registered successfully.');
      closeRegisterWaitingModal();
      await Promise.all([
        fetchWaitingList(),
        fetchAllStudents(),
        fetchParents(),
        fetchAllClasses(),
        fetchSummary(),
      ]);
    } catch (err) {
      console.error('Error registering waiting list student:', err);
      toast.error(err?.response?.data?.error || 'Failed to register student.');
      setWaitingRegistration((current) => ({ ...current, submitting: false }));
    }
  };

  const handleConfirmAction = async () => {
    const { type, payload } = confirmAction;

    try {
      if (type === 'delete-class') {
        await axios.delete(`${API_URL}/classes/${payload.id}`, authHeader());
        toast.success('Class deleted successfully');
        fetchAllClasses();
        fetchSummary();
      } else if (type === 'delete-fee') {
        await axios.delete(
          `${API_URL}/parents/${editableParent.id}/financials/${payload.id}`,
          authHeader()
        );
        setFinancials((prev) => prev.filter((fee) => fee.id !== payload.id));
        await fetchFinancials(editableParent.id);
        toast.success('Fee deleted successfully!');
      } else if (type === 'delete-ledger-record') {
        await axios.delete(
          `${API_URL}/parents/${editableParent.id}/financial-ledger/${payload.id}`,
          authHeader()
        );
        setFinancialLedger((prev) => prev.filter((record) => record.id !== payload.id));
        toast.success('Ledger record deleted');
      } else if (type === 'delete-parent-profile-student') {
        const studentId = getStudentId(payload);
        await axios.delete(
          `${API_URL}/students/${studentId}`,
          authHeader()
        );
        await Promise.all([
          fetchParentStudents(selectedParent.id),
          fetchAllStudents(),
          fetchParents(),
          fetchSummary(),
        ]);
        toast.success('Student deleted successfully');
      } else if (type === 'delete-parent') {
        await axios.delete(`${API_URL}/parents/${payload.id}`, authHeader());
        toast.success('Parent deleted successfully');
        fetchParents();
        fetchSummary();
      } else if (type === 'pay-fee') {
        await axios.put(
          `${API_URL}/parents/${editableParent.id}/financials/${payload.id}`,
          { amount_paid: payload.amount_due, status: 'Paid' },
          authHeader()
        );
        await fetchFinancials(editableParent.id);
        toast.success('Payment recorded');
      } else if (type === 'delete-teacher') {
        await axios.delete(`${API_URL}/users/teachers/${payload.id}`, authHeader());
        toast.success('Teacher deleted successfully');
        fetchTeachers();
        fetchClasses();
        fetchSummary();
      } else if (type === 'delete-waiting') {
        await axios.delete(`${API_URL}/waiting-list/${payload.id}`, authHeader());
        toast.success('Student removed from waiting list.');
        fetchWaitingList();
        fetchSummary();
      }
    } catch (err) {
      console.error('Confirm action error:', err);
      toast.error(err?.response?.data?.error || 'Action failed');
    } finally {
      setConfirmAction({ show: false, type: '', payload: null });
    }
  };

  const confirmContent = (() => {
    if (confirmAction.type === 'delete-class') {
      return {
        title: 'Delete Class',
        body: `Delete "${confirmAction.payload?.name || 'this class'}"? This will remove attendance records linked to the class.`,
        confirmText: 'Delete Class'
      };
    }
    if (confirmAction.type === 'delete-parent') {
      const name = `${confirmAction.payload?.first_name || ''} ${confirmAction.payload?.last_name || ''}`.trim();
      return {
        title: 'Delete Parent',
        body: `Delete ${name || 'this parent'}?`,
        confirmText: 'Delete Parent'
      };
    }
    if (confirmAction.type === 'delete-fee') {
      return {
        title: 'Delete Fee',
        body: 'Are you sure you want to delete this fee?',
        confirmText: 'Delete Fee'
      };
    }
    if (confirmAction.type === 'delete-ledger-record') {
      return {
        title: 'Delete Ledger Record',
        body: 'Are you sure you want to delete this financial ledger record?',
        confirmText: 'Delete Record'
      };
    }
    if (confirmAction.type === 'delete-parent-profile-student') {
      const student = confirmAction.payload || {};
      const name = `${student.first_name || student.student_first_name || ''} ${student.last_name || student.student_last_name || ''}`.trim();
      return {
        title: 'Delete Student',
        body: `Delete ${name || 'this student'} from the whole system? Attendance records and parent links for this student will also be removed.`,
        confirmText: 'Delete Student'
      };
    }
    if (confirmAction.type === 'pay-fee') {
      return {
        title: 'Mark Fee as Paid',
        body: 'Mark this fee as paid in full?',
        confirmText: 'Mark as Paid'
      };
    }
    if (confirmAction.type === 'delete-teacher') {
      const name = `${confirmAction.payload?.first_name || ''} ${confirmAction.payload?.last_name || ''}`.trim();
      return {
        title: 'Delete Teacher',
        body: `Delete ${name || 'this teacher'}?`,
        confirmText: 'Delete Teacher'
      };
    }
    if (confirmAction.type === 'delete-waiting') {
      const name = `${confirmAction.payload?.first_name || ''} ${confirmAction.payload?.last_name || ''}`.trim();
      return {
        title: 'Delete Waiting List Entry',
        body: `Remove ${name || 'this entry'} from the waiting list?`,
        confirmText: 'Delete Entry'
      };
    }
    return { title: 'Confirm Action', body: 'Are you sure?', confirmText: 'Confirm' };
  })();
  


  
  
  
  
  
  
  
  
  
  
  
  
  

  const filteredClasses = allClasses.filter(cls =>
    cls.name.toLowerCase().includes(searchClass.toLowerCase())
  );


  const groupedByShift = Object.fromEntries(SHIFT_OPTIONS.map((shift) => [shift, []]));
  const getShiftClassName = (shift) => String(shift || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  
  filteredClasses.forEach((cls) => {
    const normalizedShift = normalizeShiftLabel(cls.shift);
    if (groupedByShift[normalizedShift]) {
      groupedByShift[normalizedShift].push({ ...cls, shift: normalizedShift });
    }
  });
  

  const normalizedTeacherSearch = normalizePhone(searchTeacher);
  const filteredStudents = allStudents.filter(s =>
    `${s.first_name || s.student_first_name} ${s.last_name || s.student_last_name}`
      .toLowerCase()
      .includes(searchStudent.toLowerCase())
  );
  const filteredTeachers = teachers.filter(t =>
    (`${t.first_name} ${t.last_name}`.toLowerCase().includes(searchTeacher.toLowerCase()) ||
     (normalizedTeacherSearch &&
      normalizePhone(t.phone || t.phone_number).includes(normalizedTeacherSearch)))
  );
  const totalStudentPages = Math.max(1, Math.ceil(filteredStudents.length / PAGE_SIZE));
  const totalTeacherPages = Math.max(1, Math.ceil(filteredTeachers.length / PAGE_SIZE));
  const totalParentPages = Math.max(1, Math.ceil(filteredParents.length / PAGE_SIZE));
  const paginatedStudents = filteredStudents.slice((studentPage - 1) * PAGE_SIZE, studentPage * PAGE_SIZE);
  const paginatedTeachers = filteredTeachers.slice((teacherPage - 1) * PAGE_SIZE, teacherPage * PAGE_SIZE);
  const paginatedParents = filteredParents.slice((parentPage - 1) * PAGE_SIZE, parentPage * PAGE_SIZE);

  const renderPagination = (page, totalPages, setPage) => {
    if (totalPages <= 1) return null;

    const items = [];
    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, page + 2);

    const goToPage = (nextPage) => {
      setPage(nextPage);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    for (let current = startPage; current <= endPage; current += 1) {
      items.push(
        <Pagination.Item
          key={current}
          active={current === page}
          onClick={() => goToPage(current)}
        >
          {current}
        </Pagination.Item>
      );
    }

    return (
      <Pagination className="mb-0 flex-wrap">
        <Pagination.First onClick={() => goToPage(1)} disabled={page === 1} />
        <Pagination.Prev onClick={() => goToPage(page - 1)} disabled={page === 1} />
        {startPage > 1 && <Pagination.Ellipsis disabled />}
        {items}
        {endPage < totalPages && <Pagination.Ellipsis disabled />}
        <Pagination.Next onClick={() => goToPage(page + 1)} disabled={page === totalPages} />
        <Pagination.Last onClick={() => goToPage(totalPages)} disabled={page === totalPages} />
      </Pagination>
    );
  };

  useEffect(() => {
    setTeacherPage(1);
  }, [searchTeacher]);

  useEffect(() => {
    setParentPage(1);
  }, [parentSearchTerm]);

  useEffect(() => {
    setStudentPage(1);
  }, [searchStudent]);

  useEffect(() => {
    setStudentPage((page) => Math.min(page, totalStudentPages));
  }, [totalStudentPages]);

  useEffect(() => {
    setTeacherPage((page) => Math.min(page, totalTeacherPages));
  }, [totalTeacherPages]);

  useEffect(() => {
    setParentPage((page) => Math.min(page, totalParentPages));
  }, [totalParentPages]);
  


  const renderSidebarContent = () => (
    <>
      <div className="admin-sidebar-brand">
        <div className="admin-sidebar-brand__logo-crop">
          <img src="/sidebar-logo.png" alt="MarkazSync" />
        </div>
      </div>
      <Button
        variant={activeTab === 'dashboard' ? 'secondary' : 'outline-primary'}
        className="w-100 text-start"
        onClick={() => handleNav('dashboard')}
      >
        <BiHomeAlt className="me-2" /> Dashboard
      </Button>
  
      <Button
        variant={activeTab === 'teachers' ? 'secondary' : 'outline-secondary'}
        className="w-100 text-start"
        onClick={() => handleNav('teachers')}
      >
        <BiUser className="me-2" /> Teachers
      </Button>
  
      <Accordion
        flush
        activeKey={activeAccordionKey}
        onSelect={handleAccordionSelect}
        className="custom-accordion"
      >
        {/* Classes */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="sidebar-header d-flex align-items-center">
              <BiChalkboard className="me-2" />
              <span>Classes</span>
            </div>
          </Accordion.Header>
          <Accordion.Body className="d-grid gap-2">
            <Button
              variant={activeTab === 'classes' ? 'secondary' : 'outline-secondary'}
              className="w-100 text-start"
              onClick={() => handleNav('classes')}
            >
              <BiListUl className="me-2" /> All Classes
            </Button>
          </Accordion.Body>
        </Accordion.Item>
  
        {/* Students */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <div className="sidebar-header d-flex align-items-center">
              <BiUser className="me-2" />
              <span>Students</span>
            </div>
          </Accordion.Header>
          <Accordion.Body className="d-grid gap-2">
            <Button
              variant={activeTab === 'students' ? 'secondary' : 'outline-secondary'}
              className="w-100 text-start"
              onClick={() => handleNav('students')}
            >
              <BiUserCircle className="me-2" /> All Students
            </Button>
          </Accordion.Body>
        </Accordion.Item>
  
        {/* Parents */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <div className="sidebar-header d-flex align-items-center">
              <BiUser className="me-2" />
              <span>Parents</span>
            </div>
          </Accordion.Header>
          <Accordion.Body className="d-grid gap-2">
            <Button
              variant={activeTab === 'parents' ? 'secondary' : 'outline-secondary'}
              className="w-100 text-start"
              onClick={() => handleNav('parents')}
            >
              <BiUserCircle className="me-2" /> All Parents
            </Button>
          </Accordion.Body>
        </Accordion.Item>
  
        {/* Waiting List */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <div className="sidebar-header d-flex align-items-center">
              <BiTime className="me-2" />
              <span>Waiting-List</span>
            </div>
          </Accordion.Header>
          <Accordion.Body className="d-grid gap-2">
            <Button
              variant={activeTab === 'waiting' ? 'secondary' : 'outline-info'}
              className="w-100 text-start"
              onClick={() => handleNav('waiting')}
            >
              <BiTime className="me-2" /> View List
            </Button>
          </Accordion.Body>
        </Accordion.Item>
      {isAlsunahMarkaz && (
        <Accordion.Item eventKey="reporting">
          <Accordion.Header>
            <div className="sidebar-header d-flex align-items-center">
              <BiBarChart className="me-2" />
              <span>Reporting</span>
            </div>
          </Accordion.Header>
          <Accordion.Body className="d-grid gap-2">
        <Button
          variant={activeTab === 'reporting-parents' ? 'secondary' : 'outline-secondary'}
          className={`admin-financial-report-link w-100 text-start ${activeTab === 'reporting-parents' ? 'active-subtab' : ''}`}
          aria-current={activeTab === 'reporting-parents' ? 'page' : undefined}
          onClick={() => handleNav('reporting-parents')}
        >
          <BiBarChart className="me-2" /> Financial Reporting
        </Button>
          </Accordion.Body>
        </Accordion.Item>
      )}
      </Accordion>
  
      <Button
        variant={activeTab === 'forms' ? 'secondary' : 'outline-secondary'}
        className="w-100 text-start"
        onClick={() => handleNav('forms')}
      >
        <BiFile className="me-2" /> Forms
      </Button>
  
      <Button
        variant="outline-danger"
        className="dashboard-logout-btn w-100 text-start"
        onClick={logout}
      >
        <BiLogOut className="me-2" /> Logout
      </Button>
    </>
  );
  
  

  return (
    <div className="admin-dashboard-shell d-flex min-vh-100" style={{ flexGrow: 1 }}>
      <PageTitle title="Admin Dashboard" />
   {/* Sidebar */}
   {/* Static Sidebar (for large screens) */}
<div className="sidebar d-none d-lg-flex flex-column">
  {renderSidebarContent()}
</div>

{/* Offcanvas Sidebar (for small/medium screens) */}
<Offcanvas
  show={sidebarOpen}
  onHide={() => setSidebarOpen(false)}
  responsive="lg"
  className="sidebar d-lg-none"
>
  <Offcanvas.Header closeButton className="text-white">
    <Offcanvas.Title>Menu</Offcanvas.Title>
  </Offcanvas.Header>
  <Offcanvas.Body className="d-flex flex-column gap-2 overflow-auto">
    {renderSidebarContent()}
  </Offcanvas.Body>
</Offcanvas>





<div className="flex-grow-1 overflow-auto">
  <Container fluid className="admin-dashboard-container">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <Button
          variant="dark"          // Dark for better visibility on light backgrounds
          className="d-lg-none menu-toggle-btn"
          onClick={() => setSidebarOpen(true)}
        >
          <i className="bi bi-list"></i>
        </Button>
          <DashboardUserMenu />

        </div>
        {activeTab === 'dashboard' && (
  <>
    <Card className="admin-welcome mb-4">
      <Card.Body className="admin-welcome__body">
        <div className="admin-welcome__copy">
          <span className="admin-welcome__eyebrow">School overview</span>
          <h1 className="admin-welcome__title">Welcome back, {currentUser?.name || 'Admin'} <span aria-hidden="true">👋</span></h1>
          <p className="admin-welcome__description">View your classes, parent notes, and tasks.</p>
        </div>
        <div className="admin-welcome__date">
          <i className="bi bi-calendar3" aria-hidden="true" />
          <div>
            <span className="admin-welcome__date-label">Today</span>
            <span>{new Date().toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}</span>
          </div>
        </div>
      </Card.Body>

    <DashboardOverview embedded items={[]} actionsLabel="Quick actions">
      <Button onClick={() => {
        fetchAllClasses();
        setShowAddStudentModal(true);
      }}>Add student</Button>
      <Button variant="outline-secondary" onClick={openAddTeacherModal}>Add teacher</Button>
      <Button variant="outline-secondary" onClick={() => setShowAddParentModal(true)}>Add parent</Button>
      <Button variant="outline-secondary" onClick={() => setShowAddClassModal(true)}>Create class</Button>
      <Button variant="outline-secondary" onClick={() => handleNav('students')}>Find a student</Button>
      <Button variant="outline-secondary" onClick={() => handleNav('parents')}>Find a parent</Button>
    </DashboardOverview>
    </Card>

    <Card className="admin-attention-card border-0 shadow-sm mb-4">
      <Card.Body>
        <div className="admin-attention-card__heading">
          <div className="admin-attention-card__title">
            <i className="bi bi-exclamation-circle" aria-hidden="true" />
            <div>
              <h2>Needs attention</h2>
              <p>Classes that still need today’s attendance.</p>
            </div>
          </div>
          <span>{summaryLoading ? '…' : summary?.classesMissingAttendance?.length || 0}</span>
        </div>
        {summaryLoading ? (
          <div className="admin-attention-card__empty">Checking today’s attendance…</div>
        ) : summary?.classesMissingAttendance?.length ? (
          <div className="admin-attention-list">
            {summary.classesMissingAttendance.map((cls) => (
              <button
                type="button"
                className="admin-attention-item"
                key={cls.class_id}
                onClick={() => handleTakeAttendance({ id: cls.class_id, name: cls.class_name, shift: cls.shift })}
              >
                <span className="admin-attention-item__icon"><i className="bi bi-clipboard-x" aria-hidden="true" /></span>
                <span className="admin-attention-item__copy">
                  <strong>Attendance has not been submitted for {cls.class_name}.</strong>
                  <small>{cls.student_count} {cls.student_count === 1 ? 'student' : 'students'} · Open attendance</small>
                </span>
                <i className="bi bi-arrow-right" aria-hidden="true" />
              </button>
            ))}
          </div>
        ) : (
          <div className="admin-attention-card__empty admin-attention-card__empty--success">
            <i className="bi bi-check-circle" aria-hidden="true" />
            <div><strong>Attendance is up to date</strong><span>All classes with students have attendance submitted today.</span></div>
          </div>
        )}
      </Card.Body>
    </Card>

    {/* Summary Cards */}
    <Card className="summary-cards-wrapper border-0 shadow-sm rounded-4 mb-4">
      <Card.Body className="p-3 p-md-4">
        <div className="admin-totals-grid">
  {[
    {
      label: 'Classes',
      value: summary.total_classes || 0,
      icon: <BiChalkboard size={30} style={{ color: '#157347' }} />,
      gradient: 'linear-gradient(135deg, #f0f7ff 0%, #c5dcfa 55%, #9fc3ef 100%)',
      onClick: () => handleNav('classes'),
    },
    {
      label: 'Students',
      value: summary.total_students || 0,
      icon: <BiUser size={30} style={{ color: '#1a4f70' }} />,
      gradient: 'linear-gradient(135deg, #eafafb 0%, #b8e7ec 55%, #83cdd7 100%)',
      onClick: () => handleNav('students'),
    },
    {
      label: 'Teachers',
      value: summary.total_teachers || 0,
      icon: <BiGroup size={30} style={{ color: '#b36b00' }} />,
      gradient: 'linear-gradient(135deg, #fff5df 0%, #ffe0a0 55%, #f3c56c 100%)',
      onClick: () => handleNav('teachers'),
    },
    {
      label: 'Parents',
      value: summary.total_parents || 0,
      icon: <BiUser size={30} style={{ color: '#6a5acd' }} />,
      gradient: 'linear-gradient(135deg, #f6efff 0%, #ddcafa 55%, #bea3eb 100%)',
      onClick: () => handleNav('parents'),
    },
    {
      label: 'Waiting List',
      value: summary.total_waiting || 0,
      icon: <BiTime size={30} style={{ color: '#e74c3c' }} />,
      gradient: 'linear-gradient(135deg, #fff0f2 0%, #f9c6d0 55%, #efa1b3 100%)',
      onClick: () => handleNav('waiting'),
    },
  ].map((item) => (
    <button type="button" key={item.label} className="admin-total-card" onClick={item.onClick} style={{ background: item.gradient }}>
      <span className="admin-total-card__top"><span className="admin-total-card__icon">{item.icon}</span><i className="bi bi-arrow-up-right" aria-hidden="true" /></span>
      <span className="admin-total-card__value">{item.value}</span>
      <span className="admin-total-card__label">{item.label}</span>
    </button>
  ))}
        </div>
      </Card.Body>
    </Card>



    {/* Recent parent notes / alerts */}
    <Card
      id="admin-parent-notes" tabIndex={-1} aria-label="Recent parent notes"
      className="dashboard-section-card admin-activity-card shadow-sm mb-4 border-0 rounded-4 overflow-hidden"
      style={{ maxWidth: 880, margin: '0 auto' }}
    >
      <Card.Header className="dashboard-section-header d-flex justify-content-between align-items-center">
        <div className="admin-activity-title"><i className="bi bi-chat-left-text" aria-hidden="true" /><div><h5 className="mb-0">Parent notes</h5><p>Updates from the last 7 days</p></div></div>
        <div className="dashboard-section-count">
          {summaryLoading ? '…' : `${summary?.recentParentNotes?.length || 0} ${(summary?.recentParentNotes?.length || 0) === 1 ? 'note' : 'notes'}`}
        </div>
      </Card.Header>
      <Card.Body>

        {summaryLoading ? (
          <div className="text-muted small">Loading…</div>
        ) : !summary?.recentParentNotes || summary.recentParentNotes.length === 0 ? (
          <div className="admin-activity-empty"><i className="bi bi-chat-left-text" aria-hidden="true" /><strong>No recent parent notes</strong><p>Notes from the last 7 days will appear here.</p></div>
        ) : (
          <>
            {/* Desktop / tablet: table */}
            {!isMobile && (
              <div className="table-responsive">
                <Table size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th>Student</th>
                      <th>Class</th>
                      <th>Note</th>
                      <th>Created</th>
                      <th style={{ width: 90 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.recentParentNotes.slice(0, 6).map((n) => {
                      const parent = {
                        id: n.parent_id,
                        first_name: n.parent_first_name,
                        last_name: n.parent_last_name,
                        phone_number: n.parent_phone
                      };
                      return (
                        <tr key={n.id}>
                          <td>{n.parent_first_name} {n.parent_last_name}</td>
                          <td>{formatPhone(n.parent_phone) || '—'}</td>
                          <td>
                            <span
                              className="small"
                              style={{
                                display: 'inline-block',
                                maxWidth: 260,
                              }}
                            >
                              {n.note_text?.length > 80
                                ? n.note_text.slice(0, 80) + '…'
                                : n.note_text}
                            </span>
                          </td>
                          <td className="small">
                            {fmtDateTime(n.created_at)}
                          </td>
                          <td className="text-end">
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() => handleViewParentProfile(parent, 'notes')}
                            >
                              View
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}

            {/* Mobile: cards */}
            {isMobile && (
              <Row xs={1} className="g-2 mt-2">
                {summary.recentParentNotes.slice(0, 6).map((n) => {
                  const parent = {
                    id: n.parent_id,
                    first_name: n.parent_first_name,
                    last_name: n.parent_last_name,
                    phone_number: n.parent_phone
                  };
                  return (
                    <Col key={n.id}>
                      <Card className="shadow-sm bg-light">
                        <Card.Body className="p-3">
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <div>
                              <div className="fw-semibold">
                                {n.parent_first_name} {n.parent_last_name}
                              </div>
                              <div className="small text-muted">
                                {formatPhone(n.parent_phone) || 'No phone'}
                              </div>
                            </div>
                            <small className="text-muted ms-2">
                              {fmtDateTime(n.created_at)}
                            </small>
                          </div>

                          <div className="small mb-2"
                            style={{
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                              >
                            {n.note_text}
                          </div>

                          <div className="d-flex justify-content-end">
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() => handleViewParentProfile(parent, 'notes')}
                            >
                              View
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </>
        )}
      </Card.Body>
    </Card>

    {/* To-Do List Only */}
    <Row>
  <Col xs={12} className="mx-auto mb-4" style={{ maxWidth: 904 }}>
    <Card
      id="admin-tasks" tabIndex={-1} aria-label="Your tasks"
      className="dashboard-section-card admin-activity-card admin-todo-card shadow-sm border-0 rounded-4 overflow-hidden"
    >
      <div
        className="dashboard-section-header px-4 py-3 fw-semibold"
        style={{
          fontSize: '1.25rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="admin-activity-title"><BiCheckSquare size={22} aria-hidden="true" /><div><h5 className="mb-0">Your tasks</h5><p>Tasks to get done</p></div></div><span className="dashboard-section-count ms-auto">{todos.filter(task => !task.done).length} open</span>
      </div>

      <Card.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            addTodo(todoText);
            setTodoText('');
          }}
        >
          <InputGroup className="mb-3">
            <Form.Control
              placeholder="What needs to be done?"
              aria-label="New task"
              value={todoText}
              onChange={(e) => setTodoText(e.target.value)}
              className="rounded-start-3"
            />
            <Button type="submit" variant="success" className="rounded-end-3 px-4" disabled={!todoText.trim()}>
              Add
            </Button>
          </InputGroup>
        </Form>

        {todos.length === 0 ? (
          <div className="admin-activity-empty"><i className="bi bi-check2-circle" aria-hidden="true" /><strong>No tasks yet</strong><p>Add your first task above.</p></div>
        ) : (
          <ListGroup variant="flush">
            {todos.map((t) => (
              <ListGroup.Item
                key={t.id}
                className="d-flex justify-content-between align-items-center shadow-sm"
                style={{
                  backgroundColor: '#fff', // crisp white task card
                  borderRadius: '0.75rem',
                  padding: '0.85rem 1rem',
                  marginBottom: '0.75rem',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                  textDecoration: t.done ? 'line-through' : 'none',
                  color: t.done ? '#888' : '#212529',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <div
                  onClick={() => {
                    toggleTodo(t);
                  }}
                  style={{ cursor: 'pointer', flex: 1 }}
                >
                 <Form.Check
                    type="checkbox"
                    checked={t.done}
                    onChange={() => {}}
                    className="me-2 d-inline-block custom-checkbox"
                  />

                  {t.text}
                </div>

                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => {
                    deleteTodo(t.id);
                  }}
                >
                  Delete
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Card.Body>
    </Card>
  </Col>
</Row>

  </>
)}










{activeTab === 'classes' && (
  <>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">All Classes</h5>
      <Button variant="success" onClick={() => setShowAddClassModal(true)}>
        <BiPlus className="me-2" /> Add Class
      </Button>
    </div>

    <Form.Control
      type="text"
      placeholder="Search classes..."
      className="mb-4"
      value={searchClass}
      onChange={e => setSearchClass(e.target.value)}
    />

    {SHIFT_OPTIONS.map((shift) => (
      groupedByShift[shift]?.length > 0 && (
    <div key={shift} className={`mb-4 p-3 rounded shift-section shift-${getShiftClassName(shift)}`}>

      <div className={`d-flex align-items-center mb-3 shift-heading shift-${getShiftClassName(shift)}`}>
        <div className="shift-color-bar me-2"></div>
        <h5 className="mb-0">{shift} Classes</h5>
      </div>
          <Row className="gx-3 gy-4">
            {groupedByShift[shift].map((cls) => (
              <Col
                key={cls.id}
                xs={12}
                md={6}
                lg={4}
                style={{ position: 'relative', zIndex: openDropdownId === cls.id ? 4000 : 1 }}
              >
                <Card
                  className={`shadow-sm class-card card-${getShiftClassName(cls.shift)}`}
                  style={{
                    position: 'relative',
                    overflow: 'visible',
                    zIndex: openDropdownId === cls.id ? 4001 : 1
                  }}
                >

                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div className="d-flex justify-content-between align-items-start">
                      <div
                        style={{ cursor: editClassId === cls.id ? 'default' : 'pointer', flex: 1, minWidth: 0, paddingRight: 12 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (editClassId !== cls.id) {
                            fetchStudentsInClass(cls);
                            setStudentAction(null);
                          }
                        }}
                      >
                        <Card.Title>
                          {editClassId === cls.id ? (
                            <>
                              <Form.Group className="mb-2">
                                <Form.Control
                                  size="sm"
                                  value={editClassName}
                                  onChange={(e) => setEditClassName(e.target.value)}
                                  placeholder="Class name"
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Select
                                  size="sm"
                                  value={editShift}
                                  onChange={(e) => setEditShift(e.target.value)}
                                >
                                  <option value="">Select shift</option>
                                  {SHIFT_OPTIONS.map((shiftOption) => (
                                    <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </>
                          ) : (
                            <>
                              <Card.Title>{cls.name}</Card.Title>
                              {cls.shift && (
                                <div className="class-card__meta">
                                  <span className="class-card__label">Shift</span>
                                  <span className="class-card__value">{cls.shift}</span>
                                </div>
                              )}
                            </>
                          )}
                        </Card.Title>

                        <div className="class-card__meta">
                          <span className="class-card__label">Teacher</span>
                          <span className="class-card__value">
                            {(cls.teacher_first_name || cls.teacher_last_name)
                              ? `${cls.teacher_first_name || ''} ${cls.teacher_last_name || ''}`.trim()
                              : 'Unassigned'}
                          </span>
                        </div>
                        <div className="class-card__meta">
                          <span className="class-card__label">Students</span>
                          <span className="class-card__value">{cls.total_students || 0}</span>
                        </div>
                      </div>

                      {editClassId !== cls.id && (
                        <div
                          data-class-actions-root="true"
                          style={{ position: 'relative', zIndex: 1060, flexShrink: 0 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Button
                            size="sm"
                            variant="outline-dark"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenDropdownId(openDropdownId === cls.id ? null : cls.id);
                            }}
                          >
                            <BiDotsVerticalRounded />
                          </Button>
                          {openDropdownId === cls.id && (
                            <div className="class-card-actions-menu">
                              <button type="button" className="dropdown-item" onClick={() => { handleStartClassEdit(cls); setOpenDropdownId(null); }}>
                                <BiEdit className="me-2" /> Update
                              </button>
                              <button type="button" className="dropdown-item" onClick={() => { setSelectedClassId(cls.id); setShowCSVModal(true); setOpenDropdownId(null); }}>
                                <BiUpload className="me-2" /> Upload Students
                              </button>
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => {
                                  fetchStudentsInClass(cls);
                                  setStudentAction(null);
                                  setOpenDropdownId(null);
                                }}
                              >
                                <BiUser className="me-2" /> View Students
                              </button>
                              <button type="button" className="dropdown-item" onClick={() => { handleAssignToTeacher(cls); setOpenDropdownId(null); }}>
                                <BiUser className="me-2" /> Assign to Teacher
                              </button>
                              {cls.user_id && (
                                <button type="button" className="dropdown-item" onClick={() => { handleUnassignClassFromTeacher(cls); setOpenDropdownId(null); }}>
                                  <BiUser className="me-2" /> Unassign Teacher
                                </button>
                              )}
                              <button type="button" className="dropdown-item" onClick={() => { handleTakeAttendance(cls); setOpenDropdownId(null); }}>
                                <BiBarChart className="me-2" /> Take Attendance
                              </button>
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => {
                                  setReportFilters({ class_id: cls.id, student_id: '', start_date: '', end_date: '' });
                                  setActiveTab('report');
                                  setOpenDropdownId(null);
                                }}
                              >
                                <BiBarChart className="me-2" /> Generate Report
                              </button>
                              <button type="button" className="dropdown-item text-danger" onClick={() => { handleDeleteClass(cls); setOpenDropdownId(null); }}>
                                <BiTrash className="me-2" /> Delete
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {editClassId === cls.id && (
                      <div className="d-flex gap-2 mt-3">
                        <Button size="sm" variant="success" onClick={handleSaveClassEdit}>
                          Update
                        </Button>
                        <Button size="sm" variant="secondary" onClick={() => setEditClassId(null)}>
                          Cancel
                        </Button>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )
    ))}
  </>
)}






{/* ADMIN — TAKE ATTENDANCE */}
{activeTab === 'attendance' && selectedClass && (
  <Card className="mb-4">
    <Card.Body>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">{selectedClass.name} — Attendance</h5>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => setActiveTab('classes')}
        >
          ← Back to Classes
        </Button>
      </div>

      {/* Date Picker */}
      <Form.Group className="mb-3" style={{ maxWidth: 220 }}>
        <Form.Label>Date</Form.Label>
        <Form.Control
          type="date"
          value={attendanceDate}
          onChange={(e) => setAttendanceDate(e.target.value)}
        />
      </Form.Group>

      {selectedClass.students?.length ? (
        <>
          <div className="attendance-submit-bar">
            <div className="attendance-submit-bar__status" aria-live="polite">
              <strong>{selectedClass.students.filter(student => attendance[student.id]).length} of {selectedClass.students.length}</strong>
              <span>students marked</span>
            </div>
            <div className="attendance-submit-bar__actions">
              <Button size="sm" variant="outline-success" onClick={() => setAllAttendance('present')}>
                Mark all present
              </Button>
              <Button
                size="sm"
                variant="success"
                disabled={!selectedClass.students.some(student => attendance[student.id])}
                onClick={() => handleSubmitAttendance(selectedClass.id, selectedClass.students)}
              >
                <i className="bi bi-check2-circle" aria-hidden="true" /> Submit attendance
              </Button>
            </div>
          </div>

          {/* Desktop View – Table */}
          {!isMobile && (
            <Table striped bordered responsive size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th style={{ width: 120 }}>Status</th>
                  <th style={{ width: 110 }}>Late</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {selectedClass.students.map((s) => {
                  const status = attendance[s.id] || '';
                  return (
                    <tr key={s.id} className={status ? `attendance-row--${status}` : ''}>
                      <td>{s.first_name} {s.last_name}</td>
                      <td>
                        <Form.Select
                          size="sm"
                          className={`attendance-status-select attendance-status-select--${status || 'empty'}`}
                          value={status}
                          onChange={(e) => handleAttendanceChange(s.id, e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="present">Present</option>
                          <option value="absent">Absent</option>
                          <option value="excused">Excused</option>
                        </Form.Select>
                      </td>
                      <td>
                        <Form.Check
                          type="checkbox"
                          label="Late"
                          checked={!!lateAttendance[s.id]}
                          disabled={status !== 'present'}
                          onChange={(e) => handleLateChange(s.id, e.target.checked)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          placeholder="Comment"
                          value={comments[s.id] || ''}
                          onChange={(e) => handleCommentChange(s.id, e.target.value)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}

          {/* Mobile View – Cards */}
          {isMobile && (
            <Row xs={1} className="g-3">
              {selectedClass.students.map((s) => {
                const status = attendance[s.id] || '';
                return (
                  <Col key={s.id}>
                    <Card className={`p-3 attendance-mark-card attendance-mark-card--${status || 'empty'}`}>
                      <strong>{s.first_name} {s.last_name}</strong>
                      <Form.Group className="mt-2">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                          className={`attendance-status-select attendance-status-select--${status || 'empty'}`}
                          value={status}
                          onChange={(e) => handleAttendanceChange(s.id, e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="present">Present</option>
                          <option value="absent">Absent</option>
                          <option value="excused">Excused</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Check
                          type="checkbox"
                          label="Arrived late"
                          checked={!!lateAttendance[s.id]}
                          disabled={status !== 'present'}
                          onChange={(e) => handleLateChange(s.id, e.target.checked)}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Comment</Form.Label>
                        <Form.Control
                          placeholder="Comment"
                          value={comments[s.id] || ''}
                          onChange={(e) => handleCommentChange(s.id, e.target.value)}
                        />
                      </Form.Group>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          )}
        </>
      ) : (
        <p>No students in this class.</p>
      )}
    </Card.Body>
  </Card>
)}


{activeTab === 'report' && (
  <Card className="p-4 mb-4">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">Generate Attendance Report</h5>
      <Button
        variant="secondary"
        size="sm"
        onMouseDown={dismissMobilePicker}
        onTouchStart={dismissMobilePicker}
        onClick={() => {
          setActiveTab('classes');
          setReportFilters({ class_id: '', student_id: '', start_date: '', end_date: '' });
          setReport([]);
        }}
      >
        ← Back to Classes
      </Button>
    </div>

    <Form className="p-3 rounded shadow-sm bg-light mb-4">
      <Row className="g-2">
        {/* Student Dropdown */}
        <Col md={6}>
          <Form.Label className="fw-semibold">Student</Form.Label>
          <Form.Select
            value={reportFilters.student_id}
            onChange={(e) =>
              setReportFilters({
                ...reportFilters,
                student_id: e.target.value,
              })
            }
          >
            <option value="">All students</option>
            {reportStudents.length > 0 ? (
              reportStudents.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.first_name} {s.last_name}
                </option>
              ))
            ) : (
              <option disabled>Loading students...</option>
            )}
          </Form.Select>
        </Col>

        {/* Start Date */}
        <Col md={6}>
          <Form.Label className="fw-semibold">Start Date</Form.Label>
          <Form.Control
            type="date"
            value={reportFilters.start_date}
            onChange={(e) =>
              setReportFilters({
                ...reportFilters,
                start_date: e.target.value,
              })
            }
          />
        </Col>

        {/* End Date */}
        <Col md={6}>
          <Form.Label className="fw-semibold">End Date</Form.Label>
          <Form.Control
            type="date"
            value={reportFilters.end_date}
            onChange={(e) =>
              setReportFilters({
                ...reportFilters,
                end_date: e.target.value,
              })
            }
          />
        </Col>

        {/* Buttons */}
        <Col xs={12} className="d-flex justify-content-end gap-2 mt-3">
          <Button
            variant="primary"
            onMouseDown={dismissMobilePicker}
            onTouchStart={dismissMobilePicker}
            onClick={handleGenerateReport}
          >
            Generate
          </Button>
          <Button
            variant="secondary"
            onMouseDown={dismissMobilePicker}
            onTouchStart={dismissMobilePicker}
            onClick={handleClearReport}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  </Card>
)}


{isAlsunahMarkaz && activeTab === 'reporting-parents' && (
  <Container fluid className="mt-4 financial-ledger-report-page">
    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 mb-3">
      <div>
        <h4 className="mb-1">Parent Financial Reporting</h4>
        <p className="text-muted mb-0">Review weekend, weekday, and optional supplemental fee payments by parent.</p>
      </div>
      <div className="financial-report-header-actions">
        <Button variant="outline-primary" onClick={fetchParentFeeReport} disabled={loadingParentFeeReport}>
          {loadingParentFeeReport ? 'Refreshing...' : 'Refresh Report'}
        </Button>
        <Button
          variant="outline-secondary"
          onClick={exportParentFeeReportCsv}
          disabled={loadingParentFeeReport || filteredParentFeeReportRows.length === 0}
        >
          <BiDownload className="me-1" /> CSV
        </Button>
        <Button
          variant="outline-success"
          onClick={exportParentFeeReportSheet}
          disabled={loadingParentFeeReport || filteredParentFeeReportRows.length === 0}
        >
          <BiFile className="me-1" /> Google Sheets
        </Button>
      </div>
    </div>

    <Card className="shadow-sm border-0">
      <Card.Body>
        <Row className="g-3 align-items-end mb-3">
          <Col lg={4} md={6}>
            <Form.Label className="fw-semibold">Parent</Form.Label>
            <Select
              options={parentOptions}
              value={selectedReportParents?.value ? selectedReportParents : null}
              onChange={(option) => setSelectedReportParents(option || null)}
              placeholder="All Parents"
              isClearable
              isSearchable
            />
          </Col>
          <Col lg={3} md={6}>
            <Form.Label className="fw-semibold">Month</Form.Label>
            <Select
              options={monthOptions}
              value={selectedReportMonth || null}
              onChange={(option) => setSelectedReportMonth(option || '')}
              placeholder="All Months"
              isClearable
              isSearchable
            />
          </Col>
          <Col lg={3} md={6}>
            <Form.Label className="fw-semibold">Year</Form.Label>
            <Select
              options={yearOptions}
              value={selectedReportYear || null}
              onChange={(option) => setSelectedReportYear(option || '')}
              placeholder="All Years"
              isClearable
              isSearchable
            />
          </Col>
          <Col lg={2} md={6}>
            <Button className="w-100" variant="primary" onClick={fetchParentFeeReport} disabled={loadingParentFeeReport}>
              Run Report
            </Button>
          </Col>
        </Row>

        <Row className="g-3 mb-3">
          <Col sm={6} xl={3}>
            <div className="ledger-summary-card ledger-summary-card--paid">
              <div className="ledger-summary-card__label">Weekend Collected</div>
              <div className="ledger-summary-card__value ledger-summary-card__value--collected">${formatMoney(parentFeeDashboard.weekendCollected)}</div>
              <div className="ledger-summary-card__meta ledger-summary-card__meta--uncollected">Uncollected ${formatMoney(parentFeeDashboard.weekendBalance)}</div>
            </div>
          </Col>
          <Col sm={6} xl={3}>
            <div className="ledger-summary-card ledger-summary-card--paid">
              <div className="ledger-summary-card__label">Weekday Collected</div>
              <div className="ledger-summary-card__value ledger-summary-card__value--collected">${formatMoney(parentFeeDashboard.weekdayCollected)}</div>
              <div className="ledger-summary-card__meta ledger-summary-card__meta--uncollected">Uncollected ${formatMoney(parentFeeDashboard.weekdayBalance)}</div>
            </div>
          </Col>
          <Col sm={6} xl={3}>
            <div className="ledger-summary-card ledger-summary-card--paid">
              <div className="ledger-summary-card__label">Supplemental Collected</div>
              <div className="ledger-summary-card__value ledger-summary-card__value--collected">${formatMoney(parentFeeDashboard.supplementalCollected)}</div>
              <div className="ledger-summary-card__meta ledger-summary-card__meta--uncollected">Uncollected ${formatMoney(parentFeeDashboard.supplementalBalance)}</div>
            </div>
          </Col>
          <Col sm={6} xl={3}>
            <div className="ledger-summary-card">
              <div className="ledger-summary-card__label">Total Collected</div>
              <div className="ledger-summary-card__value ledger-summary-card__value--collected">${formatMoney(parentFeeDashboard.totalCollected)}</div>
              <div className="ledger-summary-card__meta ledger-summary-card__meta--uncollected">
                Uncollected ${formatMoney(parentFeeDashboard.totalBalance)}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="g-3 financial-report-summary">
          <Col md={4}>
            <div className="financial-summary-card financial-summary-card--paid">
              <div className="financial-summary-card__label">Paid Parents</div>
              <div className="financial-summary-card__value">{parentFeeStatusCounts.paid}</div>
            </div>
          </Col>
          <Col md={4}>
            <div className="financial-summary-card financial-summary-card--partial">
              <div className="financial-summary-card__label">Partial Parents</div>
              <div className="financial-summary-card__value">{parentFeeStatusCounts.partial}</div>
            </div>
          </Col>
          <Col md={4}>
            <div className="financial-summary-card financial-summary-card--unpaid">
              <div className="financial-summary-card__label">Not Paid Parents</div>
              <div className="financial-summary-card__value">{parentFeeStatusCounts.unpaid}</div>
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-between align-items-center gap-3 mb-3 flex-wrap">
          <div className="text-muted small">
            Showing {parentFeeReportStart}-{parentFeeReportEnd} of {filteredParentFeeReportRows.length}
          </div>
        </div>

        {loadingParentFeeReport ? (
          <p className="dashboard-empty-state mb-0">Loading financial report...</p>
        ) : filteredParentFeeReportRows.length === 0 ? (
          <p className="dashboard-empty-state mb-0">No parent fee records found.</p>
        ) : (
          <>
            <div className="table-responsive d-none d-md-block">
              <table className="table table-sm align-middle parent-profile-table ledger-table mb-0">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Parent</th>
                    <th>Phone</th>
                    <th>Weekend</th>
                    <th>Weekday</th>
                    <th>Supplemental</th>
                    <th>Method</th>
                    <th>Total Paid</th>
                    <th>Balance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedParentFeeReportRows.map((parent) => (
                    <tr key={`${parent.parent_id}-${parent.year}-${parent.month}`}>
                      <td className="fw-semibold">{formatMonthLabel(parent.month)} {parent.year}</td>
                      <td className="fw-semibold">{parent.first_name} {parent.last_name}</td>
                      <td>{formatPhone(parent.phone_number)}</td>
                      <td><FeePaymentStatus paid={parent.weekend_paid} due={parent.weekend_due} /></td>
                      <td><FeePaymentStatus paid={parent.weekday_paid} due={parent.weekday_due} /></td>
                      <td><FeePaymentStatus paid={parent.supplemental_paid} due={parent.supplemental_due} /></td>
                      <td>{parent.payment_method || '-'}</td>
                      <td>${formatMoney(parent.total_paid)}</td>
                      <td className={(parseFloat(parent.balance) || 0) <= 0 ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                        ${formatMoney(parent.balance)}
                      </td>
                      <td>
                        <span className={`fee-status-pill fee-status-pill--${String(parent.status || 'unpaid').toLowerCase()}`}>
                          {parent.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-md-none stack-list">
              {paginatedParentFeeReportRows.map((parent) => (
                <div key={`${parent.parent_id}-${parent.year}-${parent.month}`} className="stack-card report-card">
                  <div className="financial-card__header">
                    <div>
                      <div className="financial-card__subtitle">{formatMonthLabel(parent.month)} {parent.year}</div>
                      <div className="financial-card__title">{parent.first_name} {parent.last_name}</div>
                      <div className="financial-card__subtitle">{formatPhone(parent.phone_number)}</div>
                    </div>
                    <span className={`fee-status-pill fee-status-pill--${String(parent.status || 'unpaid').toLowerCase()}`}>
                      {parent.status}
                    </span>
                  </div>
                  <div className="financial-card__grid">
                    <div>
                      <div className="financial-card__label">Weekend</div>
                      <FeePaymentStatus paid={parent.weekend_paid} due={parent.weekend_due} />
                    </div>
                    <div>
                      <div className="financial-card__label">Weekday</div>
                      <FeePaymentStatus paid={parent.weekday_paid} due={parent.weekday_due} />
                    </div>
                    <div>
                      <div className="financial-card__label">Supplemental</div>
                      <FeePaymentStatus paid={parent.supplemental_paid} due={parent.supplemental_due} />
                    </div>
                    <div>
                      <div className="financial-card__label">Method</div>
                      <div className="financial-card__value">{parent.payment_method || '-'}</div>
                    </div>
                    <div>
                      <div className="financial-card__label">Balance</div>
                      <div className="financial-card__value">${formatMoney(parent.balance)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {parentFeeReportTotalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                <small className="text-muted">
                  Page {currentParentFeeReportPage} of {parentFeeReportTotalPages}
                </small>
                {renderPagination(currentParentFeeReportPage, parentFeeReportTotalPages, setFinancialReportPage)}
              </div>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  </Container>
)}











{activeTab === 'teachers' && (
  <>
    <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
      <Form.Control
        type="text"
        placeholder="Search teachers..."
        style={{ maxWidth: 360 }}
        value={searchTeacher}
        onChange={(e) => setSearchTeacher(e.target.value)}
      />
      <Button variant="success" onClick={openAddTeacherModal}>
        Add Teacher
      </Button>
    </div>

    {/* ✅ Desktop View */}
    <div className="table-responsive d-none d-sm-block">
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th style={{ minWidth: '40px' }}>#</th>
            <th style={{ minWidth: '120px' }}>Name</th>
            <th style={{ minWidth: '100px' }}>Phone</th>
            <th style={{ minWidth: '180px' }}>Email</th>
            <th style={{ minWidth: '100px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedTeachers.map((t, i) => (
            <tr key={t.id}>
              <td>{(teacherPage - 1) * PAGE_SIZE + i + 1}</td>
              <td>{t.first_name} {t.last_name}</td>
              <td>{formatPhone(t.phone_number) || '-'}</td>
              <td>{t.email}</td>
              <td className="dropdown-cell">
                <Dropdown>
                  <Dropdown.Toggle size="sm" variant="outline-dark">
                    Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleEditTeacher(t)}>Update</Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => handleDeleteTeacher(t)}>Delete</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedTeachers.length === 0 ? 0 : (teacherPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(teacherPage - 1) * PAGE_SIZE + paginatedTeachers.length} of {filteredTeachers.length}
      </small>
      {renderPagination(teacherPage, totalTeacherPages, setTeacherPage)}
    </div>

    {/* ✅ Mobile View */}
    <div className="d-block d-sm-none mobile-teacher-list">
      {paginatedTeachers.map((t) => (
        <div
          key={t.id}
          className="card mb-3 shadow-sm teacher-card-mobile"
          style={{
            position: 'relative',
            overflow: 'visible',
            zIndex: openTeacherDropdownId === t.id ? 5000 : 1,
          }}
        >
          <div className="card-body" style={{ overflow: 'visible' }}>
            <h6 className="card-title mb-1">
              {t.first_name} {t.last_name}
            </h6>
            <p className="card-text mb-1">
              <strong>Phone:</strong> {formatPhone(t.phone_number) || '-'}
            </p>
            <p className="card-text mb-2">
              <strong>Email:</strong> {t.email}
            </p>
            <Dropdown
              align="end"
              popperConfig={{ strategy: 'fixed' }}
              onToggle={(isOpen) => setOpenTeacherDropdownId(isOpen ? t.id : null)}
            >
              <Dropdown.Toggle size="sm" variant="outline-dark">
                Actions
              </Dropdown.Toggle>
              <Dropdown.Menu className="teacher-dropdown-menu">
                <Dropdown.Item onClick={() => handleEditTeacher(t)}>Update</Dropdown.Item>
                <Dropdown.Item className="text-danger" onClick={() => handleDeleteTeacher(t)}>Delete</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ))}
    </div>
    <div className="d-flex justify-content-between align-items-center mt-2 d-sm-none flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedTeachers.length === 0 ? 0 : (teacherPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(teacherPage - 1) * PAGE_SIZE + paginatedTeachers.length} of {filteredTeachers.length}
      </small>
      {renderPagination(teacherPage, totalTeacherPages, setTeacherPage)}
    </div>
  </>
)}





{activeTab === 'parents' && (
  <>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">All Parents</h5>
      <Button variant="success" onClick={() => setShowAddParentModal(true)}>
        <BiPlus className="me-2" /> Add Parent
      </Button>
    </div>

    <Form className="mb-3">
      <Row className="g-2">
        <Col md={6} lg={4}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search parents by name or phone"
              value={parentSearchTerm}
              onChange={e => setParentSearchTerm(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={() => setParentSearchTerm('')}>Clear</Button>
          </InputGroup>
        </Col>
      </Row>
    </Form>

    {/* Desktop/tablet */}
    <div className="table-responsive position-relative d-none d-md-block">
      <Table className="table-sm table-striped align-middle parent-list-table" bordered={false} responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedParents.map((p, i) => (
            <tr key={p.id}>
              <td>{(parentPage - 1) * PAGE_SIZE + i + 1}</td>
              <td>
                <div
                  className="clickable-name"
                  title="Click to view profile"
                  onClick={() => handleViewParentProfile(p)}
                  style={{ color: '#0d6efd', cursor: 'pointer' }}
                  onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                >
                  {p.first_name} {p.last_name}
                </div>
              </td>
              <td>{formatPhone(p.phone_number) || '-'}</td>
              <td className="position-relative">
                <Dropdown as={ButtonGroup} align="end">
                  <Dropdown.Toggle
                    size="sm"
                    variant="outline-dark"
                    id={`dropdown-${p.id}`}
                  >
                    Actions
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        handleViewParentProfile(p);
                        setEditMode(true);
                      }}
                    >
                      Update
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleViewParentProfile(p)}>View Profile</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={() => handleDeleteParent(p)}
                      className="text-danger"
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedParents.length === 0 ? 0 : (parentPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(parentPage - 1) * PAGE_SIZE + paginatedParents.length} of {filteredParents.length}
      </small>
      {renderPagination(parentPage, totalParentPages, setParentPage)}
    </div>

    {/* Mobile cards */}
    <div className="d-md-none mobile-parent-list">
      {paginatedParents.map((p, i) => (
        <Card
          key={p.id}
          className="mb-2 shadow-sm parent-card-mobile"
          style={{
            position: 'relative',
            zIndex: openParentDropdownId === p.id ? 5000 : 1,
            overflow: 'visible'
          }}
        >
          <Card.Body className="p-3" style={{ overflow: 'visible' }}>
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div
                  className="fw-semibold"
                  style={{ color: '#0d6efd', cursor: 'pointer' }}
                  onClick={() => handleViewParentProfile(p)}
                >
                  {(parentPage - 1) * PAGE_SIZE + i + 1}. {p.first_name} {p.last_name}
                </div>
                <div className="text-muted small">{formatPhone(p.phone_number) || '-'}</div>
              </div>

              <Dropdown
                align="end"
                popperConfig={{ strategy: 'fixed' }}
                onToggle={(isOpen) => setOpenParentDropdownId(isOpen ? p.id : null)}
              >
                <Dropdown.Toggle size="sm" variant="outline-secondary" id={`parent-actions-${p.id}`}>
                  Actions
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow parent-dropdown-menu">
                  <Dropdown.Item onClick={() => handleViewParentProfile(p)}>View Profile</Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      handleViewParentProfile(p);
                      setEditMode(true);
                    }}
                  >
                    Update
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item className="text-danger" onClick={() => handleDeleteParent(p)}>
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
    <div className="d-flex justify-content-between align-items-center mt-2 d-md-none flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedParents.length === 0 ? 0 : (parentPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(parentPage - 1) * PAGE_SIZE + paginatedParents.length} of {filteredParents.length}
      </small>
      {renderPagination(parentPage, totalParentPages, setParentPage)}
    </div>

    {/* Add Parent Modal */}
    <Modal show={showAddParentModal} onHide={() => setShowAddParentModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Parent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={async (e) => {
            e.preventDefault();

            if (!newParent.first_name || !newParent.last_name || !newParent.phone_number) {
              toast.error('All fields are required');
              return;
            }

            try {
              await axios.post(`${API_URL}/parents`, newParent, authHeader());
              toast.success('Parent added successfully');
              setNewParent({ first_name: '', last_name: '', phone_number: '' });
              setShowAddParentModal(false);
              fetchParents();
            } catch (err) {
              toast.error(err?.response?.data?.error || 'Failed to add parent');
            }
          }}
        >
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              required
              placeholder="Enter first name"
              value={newParent.first_name}
              onChange={e => setNewParent({ ...newParent, first_name: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              required
              placeholder="Enter last name"
              value={newParent.last_name}
              onChange={e => setNewParent({ ...newParent, last_name: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter phone"
              value={newParent.phone_number}
              onChange={(e) =>
                setNewParent({ ...newParent, phone_number: formatPhone(e.target.value) })
              }
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={() => setShowAddParentModal(false)} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="success">
              Add Parent
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  </>
)}





{activeTab === 'students' && (
  <>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">All Students</h5>
      <Button
        variant="success"
        onClick={() => {
          fetchAllClasses();
          setShowAddStudentModal(true);
        }}
      >
        + Add Student
      </Button>
    </div>

    <Form className="mb-3">
      <Row className="g-2">
        <Col md={6} lg={4}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search students by name"
              value={searchStudent}
              onChange={e => setSearchStudent(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={() => setSearchStudent('')}>
              Clear
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </Form>

    {/* Desktop/tablet */}
    <div className="table-responsive position-relative d-none d-md-block">
      <Table
        responsive
        hover
        size="sm"
        bordered={false}
        className="table-sm table-striped align-middle parent-list-table"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th style={{ maxWidth: '200px' }}>Parents</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedStudents.map((s, i) => (
              <tr key={s.student_id || s.id}>
                <td>{(studentPage - 1) * PAGE_SIZE + i + 1}</td>
                <td>
                  <div
                    className="clickable-name"
                    title="Click to view profile"
                    onClick={() => handleViewStudentDetails(s)}
                    style={{ color: '#0d6efd', cursor: 'pointer' }}
                    onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                  >
                    {s.student_first_name || s.first_name}{' '}
                    {s.student_last_name || s.last_name}
                  </div>
                </td>

                <td style={{ whiteSpace: 'normal', maxWidth: '260px' }}>
                  {Array.isArray(s.parents) && s.parents.length > 0 ? (
                    s.parents.slice(0, 2).map((p, idx) => (
                      <p key={p.id || idx} className="mb-1">
                        <strong>{p.first_name} {p.last_name}</strong><br />
                        <small className="text-muted">{formatPhone(p.phone_number) || 'No phone'}</small>
                      </p>
                    ))
                  ) : (
                    <span className="text-muted">No parents assigned</span>
                  )}
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle size="sm" variant="outline-dark">Actions</Dropdown.Toggle>
                  <Dropdown.Menu container={document.body}>
                      <Dropdown.Item onClick={() => handleViewStudentDetails(s)}>
                        View Profile
                      </Dropdown.Item>
                    <Dropdown.Item onClick={() => openAdminQuranAssignments(s)}>
                      <i className="bi bi-book me-2" aria-hidden="true" />
                      Quran assignments
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openMoveStudentModal(s)}>
                      Move to Class
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setSelectedStudent(s);
                        setShowAssignParentModal(true);
                      }}
                    >
                      Assign to Parent
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={() => handleEditStudent(s)}
                    >
                      Update
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={() => {
                        setStudentToDelete(s.student_id || s.id);
                        setShowDeleteConfirm(true);
                      }}
                      className="text-danger"
                    >
                      Delete
                    </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedStudents.length === 0 ? 0 : (studentPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(studentPage - 1) * PAGE_SIZE + paginatedStudents.length} of {filteredStudents.length}
      </small>
      {renderPagination(studentPage, totalStudentPages, setStudentPage)}
    </div>

    {/* Mobile cards */}
    <div className="d-md-none mobile-student-list">
      {paginatedStudents.map((s, i) => (
          <Card
            key={s.student_id || s.id}
            className="mb-2 shadow-sm student-card-mobile"
            style={{
              position: 'relative',
              overflow: 'visible',
              zIndex: openStudentDropdownId === (s.student_id || s.id) ? 5000 : 1,
            }}
          >
            <Card.Body className="p-3">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <div
                  className="fw-semibold"
                  style={{ color: '#0d6efd', cursor: 'pointer' }}
                  onClick={() => handleViewStudentDetails(s)}
                >
                    {(studentPage - 1) * PAGE_SIZE + i + 1}. {s.student_first_name || s.first_name}{' '}
                    {s.student_last_name || s.last_name}
                  </div>
                  <div className="text-muted small">
                    {Array.isArray(s.parents) && s.parents.length > 0
                      ? `${s.parents.length} parent(s)`
                      : 'No parents assigned'}
                  </div>
                </div>

                <Dropdown
                  align="end"
                  popperConfig={{ strategy: 'fixed' }}
                  onToggle={(isOpen) =>
                    setOpenStudentDropdownId(isOpen ? (s.student_id || s.id) : null)
                  }
                >
                  <Dropdown.Toggle size="sm" variant="outline-secondary">
                    Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow student-dropdown-menu">
                    <Dropdown.Item onClick={() => handleViewStudentDetails(s)}>
                      View Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openAdminQuranAssignments(s)}>
                      <i className="bi bi-book me-2" aria-hidden="true" />
                      Quran assignments
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openMoveStudentModal(s)}>
                      Move to Class
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setSelectedStudent(s);
                        setShowAssignParentModal(true);
                      }}
                    >
                      Assign to Parent
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleEditStudent(s)}>
                      Update
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      className="text-danger"
                      onClick={() => {
                        setStudentToDelete(s.student_id || s.id);
                        setShowDeleteConfirm(true);
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="mt-2">
                {Array.isArray(s.parents) && s.parents.length > 0 ? (
                  s.parents.slice(0, 2).map((p, idx) => (
                    <div key={p.id || idx} className="kv-grid mt-1">
                      <div className="kv">
                        <div className="kv-label">Parent</div>
                        <div className="kv-value fw-semibold">{p.first_name} {p.last_name}</div>
                      </div>
                        <div className="kv">
                        <div className="kv-label">Phone</div>
                        <div className="kv-value">{formatPhone(p.phone_number) || '—'}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-muted small">No parents assigned</div>
                )}
              </div>
            </Card.Body>
          </Card>
        ))}
    </div>
    <div className="d-flex justify-content-between align-items-center mt-2 d-md-none flex-wrap gap-2">
      <small className="text-muted">
        Showing {paginatedStudents.length === 0 ? 0 : (studentPage - 1) * PAGE_SIZE + 1}
        {' '}-{' '}
        {(studentPage - 1) * PAGE_SIZE + paginatedStudents.length} of {filteredStudents.length}
      </small>
      {renderPagination(studentPage, totalStudentPages, setStudentPage)}
    </div>
  </>
)}




{activeTab === 'waiting' && (
  <Card className="p-4 mb-4 shadow-sm waiting-list-panel">
    <div className="waiting-list-header">
      <div>
        <h5 className="mb-1">Waiting List</h5>
        <div className="text-muted small">{waitingList.length} student{waitingList.length === 1 ? '' : 's'} waiting</div>
      </div>
      <Button variant="success" className="waiting-list-add-btn" onClick={openAddWaitingModal}>
        <BiPlus className="me-2" /> Add to Waiting List
      </Button>
    </div>

    {waitingList.length === 0 ? (
      <p className="text-center text-muted">No students in the waiting list.</p>
    ) : isMobile ? (
      <div className="waiting-list-mobile">
        {waitingList.map((w, idx) => (
          <Card key={w.id} className="waiting-list-mobile-card">
            <Card.Body>
              <div className="waiting-list-mobile-card__top">
                <div className="waiting-list-mobile-card__identity">
                  <div className="waiting-list-mobile-card__index">#{idx + 1}</div>
                  <h6>{w.first_name} {w.last_name}</h6>
                </div>
                <Dropdown align="end">
                  <Dropdown.Toggle size="sm" variant="outline-dark" className="waiting-list-actions-toggle">
                    Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="waiting-list-actions-menu" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                    <Dropdown.Item onClick={() => openRegisterWaitingModal(w)}>Register Student</Dropdown.Item>
                    <Dropdown.Item onClick={() => openEditWaitingModal(w)}>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => handleDeleteWaiting(w)}>
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="waiting-list-mobile-card__grid">
                <div>
                  <span>Parent</span>
                  <strong>{w.parent_name || '-'}</strong>
                </div>
                <div>
                  <span>Phone</span>
                  <strong>{formatPhone(w.parent_phone) || '-'}</strong>
                </div>
                <div>
                  <span>Previous Markaz</span>
                  <strong>{w.previous_markaz || '-'}</strong>
                </div>
                <div>
                  <span>Shift</span>
                  <strong>{w.shift}</strong>
                </div>
                <div>
                  <span>Date Added</span>
                  <strong>{new Date(w.date_added).toLocaleDateString()}</strong>
                </div>
                <div>
                  <span>Months on List</span>
                  <strong>{monthsSince(w.date_added)}</strong>
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>
    ) : (
      <div className="table-responsive">
        <Table bordered hover className="table-striped align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Student Name</th>
              <th>Parent Name</th>
              <th>Parent Phone</th>
              <th>Previous Markaz</th>
              <th>Shift</th>
              <th>Date Added</th>
              <th>Months on List</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {waitingList.map((w, idx) => (
              <tr key={w.id}>
                <td>{idx + 1}</td>
                <td>{w.first_name} {w.last_name}</td>
              <td>{w.parent_name || '-'}</td>
              <td>{formatPhone(w.parent_phone)}</td>
              <td>{w.previous_markaz || '-'}</td>
              <td>{w.shift}</td>
              <td>{new Date(w.date_added).toLocaleDateString()}</td>
              <td>{monthsSince(w.date_added)}</td>
              <td>
                <Dropdown align="end">
                  <Dropdown.Toggle size="sm" variant="outline-dark">
                    Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="waiting-list-actions-menu" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                    <Dropdown.Item onClick={() => openRegisterWaitingModal(w)}>Register Student</Dropdown.Item>
                    <Dropdown.Item onClick={() => openEditWaitingModal(w)}>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => handleDeleteWaiting(w)}>
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    )}
  </Card>
)}

{activeTab === 'forms' && (
  <div className="forms-tab">
    <Card className="p-3 p-md-4 mb-4 shadow-sm border-0 forms-upload-card">
      <div className="d-flex flex-column flex-md-row justify-content-between gap-2 mb-3">
        <div>
          <h5 className="mb-1">Forms</h5>
          <p className="text-muted mb-0">Upload PDF or image documents for your markaz and print them later.</p>
        </div>
      </div>

      <Form onSubmit={handleUploadFormDocument}>
        <Row className="g-3 align-items-end">
          <Col xs={12} md={5}>
            <Form.Group>
              <Form.Label>Document name</Form.Label>
              <Form.Control
                value={formsUpload.title}
                onChange={(e) => setFormsUpload((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Example: Registration Form"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={5}>
            <Form.Group>
              <Form.Label>File</Form.Label>
              <Form.Control
                type="file"
                accept="application/pdf,image/png,image/jpeg,image/webp"
                onChange={(e) => setFormsUpload((prev) => ({ ...prev, file: e.target.files?.[0] || null }))}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2}>
            <Button type="submit" variant="primary" className="w-100" disabled={formsUploading}>
              <BiUpload className="me-2" />
              {formsUploading ? 'Uploading...' : 'Upload'}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>

    <Card className="p-3 p-md-4 mb-4 shadow-sm border-0">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Uploaded Documents</h5>
        <Button variant="outline-secondary" size="sm" onClick={fetchFormDocuments} disabled={formsLoading}>
          Refresh
        </Button>
      </div>

      {formsLoading ? (
        <p className="text-muted mb-0">Loading documents...</p>
      ) : formDocuments.length === 0 ? (
        <div className="forms-empty-state text-center text-muted py-4">
          <BiFile size={36} className="mb-2" />
          <p className="mb-0">No forms uploaded yet.</p>
        </div>
      ) : isMobile ? (
        <div className="d-flex flex-column gap-3">
          {formDocuments.map((doc) => (
            <Card
              key={doc.id}
              className="forms-document-card p-3"
              onClick={() => handleViewFormDocument(doc)}
              role="button"
              title="Click to open"
            >
              <div className="d-flex gap-3 align-items-start">
                <div className="forms-document-icon">
                  <BiFile />
                </div>
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-1">{doc.title}</h6>
                  <div className="text-muted small">{doc.original_name}</div>
                  <div className="text-muted small">
                    {doc.created_at ? new Date(doc.created_at).toLocaleDateString() : ''}
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2 mt-3">
                <Button
                  variant="outline-danger"
                  className="ms-auto"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleDeleteFormDocument(doc);
                  }}
                >
                  <BiTrash />
                </Button>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <div className="table-responsive">
          <Table hover className="align-middle forms-documents-table">
            <thead>
              <tr>
                <th>Document</th>
                <th>Uploaded</th>
                <th>Type</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {formDocuments.map((doc) => (
                <tr
                  key={doc.id}
                  className="forms-document-row"
                  onClick={() => handleViewFormDocument(doc)}
                  title="Click to open"
                >
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span className="forms-document-icon">
                        <BiFile />
                      </span>
                      <div>
                        <div className="fw-semibold">{doc.title}</div>
                        <div className="text-muted small">{doc.original_name}</div>
                      </div>
                    </div>
                  </td>
                  <td>{doc.created_at ? new Date(doc.created_at).toLocaleDateString() : '-'}</td>
                  <td>{doc.mime_type === 'application/pdf' ? 'PDF' : 'Image'}</td>
                  <td className="text-end">
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDeleteFormDocument(doc);
                      }}
                    >
                      <BiTrash className="me-1" /> Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  </div>
)}

<Modal
  show={formPreview.show}
  onHide={closeFormPreview}
  size="xl"
  fullscreen="md-down"
  centered
  dialogClassName="form-preview-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>{formPreview.document?.title || 'Document Preview'}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {formPreview.isImage ? (
      <img
        className="form-preview-image"
        src={formPreview.url}
        alt={formPreview.document?.title || 'Uploaded document'}
      />
    ) : (
      <iframe
        className="form-preview-frame"
        src={formPreview.url ? `${formPreview.url}#toolbar=1&navpanes=0` : ''}
        title={formPreview.document?.title || 'Uploaded document'}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={closeFormPreview}>
      Close
    </Button>
    <Button
      variant="primary"
      onClick={() => {
        if (formPreview.url) window.open(`${formPreview.url}#toolbar=1&navpanes=0`, '_blank');
      }}
    >
      Open in New Tab
    </Button>
  </Modal.Footer>
</Modal>








        {/* Student Modal */}
<Modal
  show={showStudentModal}
  onHide={() => setShowStudentModal(false)}
  size="lg"
  centered
  fullscreen="sm-down"
  dialogClassName="admin-class-students-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>Students in {selectedClass?.name}</Modal.Title>
    <div className="ms-auto">
      <Button
        size="sm"
        variant="success"
        onClick={openAddStudentForSelectedClass}
      >
        Add Student
      </Button>
    </div>
  </Modal.Header>
  <Modal.Body>
    {/* desktop / tablet: show table */}
    <div className="d-none d-md-block">
      <div className="table-responsive">
        <Table bordered hover size="sm" className="admin-class-students-table">
          <thead>
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th>Name</th>
              <th style={{ width: 150 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {studentsInClass.map((s, i) => {
              const isEditing = editStudent?.id === s.id;
              return (
                <tr key={s.id}>
                  <td>{i + 1}</td>
                  <td>
                    {isEditing ? (
                      <div className="d-flex gap-2">
                        <Form.Control
                          size="sm"
                          value={editStudent.first_name}
                          onChange={e => setEditStudent(prev => ({ ...prev, first_name: e.target.value }))}
                          placeholder="First"
                        />
                        <Form.Control
                          size="sm"
                          value={editStudent.last_name}
                          onChange={e => setEditStudent(prev => ({ ...prev, last_name: e.target.value }))}
                          placeholder="Last"
                        />
                      </div>
                    ) : (
                      <>
                        <Button variant="link" className="p-0 text-start fw-semibold text-decoration-none" onClick={() => openClassStudentProfile(s)}>
                          {s.first_name} {s.last_name}
                        </Button>
                        <div className="text-muted small">{s.markaz_name || 'No markaz'}</div>
                      </>
                    )}
                  </td>
                  <td>
                    {isEditing ? (
                      <>
                        <Button size="sm" onClick={() => handleSaveStudent(s.id)}>
                          Save
                        </Button>{' '}
                        <Button size="sm" variant="secondary" onClick={() => setEditStudent(null)}>
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <Dropdown>
                        <Dropdown.Toggle size="sm" variant="outline-dark">
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu container={document.body}>
                          <Dropdown.Item onClick={() => openClassStudentProfile(s)}>View Profile</Dropdown.Item>
                          <Dropdown.Item onClick={() => {
                            setShowStudentModal(false);
                            notesApi.openNotesFor(s);
                          }}>
                            View or add notes
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => {
                            setShowStudentModal(false);
                            goalsApi.openGoalsFor(s);
                          }}>
                            Add or view goals
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => openAdminQuranAssignments(s, true)}>
                            Quran assignments
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={() => handleEditStudent(s)}>Update</Dropdown.Item>
                          <Dropdown.Item onClick={() => openMoveStudentModal(s)}>Move to Class</Dropdown.Item>
                          <Dropdown.Item className="text-danger" onClick={() => handleDeleteStudent(s.id)}>
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>

    {/* mobile: show cards */}
    <div className="d-block d-md-none">
      {studentsInClass.map((s, i) => {
        const isEditing = editStudent?.id === s.id;
        return (
          <div key={s.id} className="admin-class-student-card">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div className="fw-semibold">{i + 1}. <Button variant="link" className="p-0 text-start fw-semibold text-decoration-none" onClick={() => openClassStudentProfile(s)}>
                  {s.first_name} {s.last_name}
                </Button></div>
                <div className="text-muted small">{s.markaz_name || 'No markaz'}</div>
              </div>
              {!isEditing && (
                <Dropdown align="end" popperConfig={{ strategy: 'fixed' }}>
                  <Dropdown.Toggle size="sm" variant="outline-dark" className="admin-class-student-actions">
                    Actions
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow" renderOnMount>
                    <Dropdown.Item onClick={() => openClassStudentProfile(s)}>View Profile</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      setShowStudentModal(false);
                      notesApi.openNotesFor(s);
                    }}>
                      View or add notes
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      setShowStudentModal(false);
                      goalsApi.openGoalsFor(s);
                    }}>
                      Add or view goals
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openAdminQuranAssignments(s, true)}>
                      Quran assignments
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => handleEditStudent(s)}>Update</Dropdown.Item>
                    <Dropdown.Item onClick={() => openMoveStudentModal(s)}>Move to Class</Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => handleDeleteStudent(s.id)}>
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            {isEditing && (
              <div className="mb-2">
                <Form.Control
                  size="sm"
                  className="mb-2"
                  value={editStudent.first_name}
                  onChange={e => setEditStudent(prev => ({ ...prev, first_name: e.target.value }))}
                  placeholder="First"
                />
                <Form.Control
                  size="sm"
                  value={editStudent.last_name}
                  onChange={e => setEditStudent(prev => ({ ...prev, last_name: e.target.value }))}
                  placeholder="Last"
                />
                <div className="mt-2 d-flex gap-2">
                  <Button size="sm" onClick={() => handleSaveStudent(s.id)}>Save</Button>
                  <Button size="sm" variant="secondary" onClick={() => setEditStudent(null)}>Cancel</Button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </Modal.Body>
</Modal>





        <Modal show={showParentStudentModal} onHide={() => setShowParentStudentModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Manage Parent Students</Modal.Title>
  </Modal.Header>
  <Form onSubmit={handleSaveParentStudent}>
    <Modal.Body>
      <div className="parent-student-mode mb-3">
        <Button
          type="button"
          size="sm"
          variant={parentStudentForm.mode === 'new' ? 'primary' : 'outline-primary'}
          onClick={() => setParentStudentForm({ ...initialParentStudentForm, mode: 'new' })}
        >
          Add New Student
        </Button>
        <Button
          type="button"
          size="sm"
          variant={parentStudentForm.mode === 'existing' ? 'primary' : 'outline-primary'}
          onClick={() => setParentStudentForm({ ...initialParentStudentForm, mode: 'existing' })}
        >
          Link Existing
        </Button>
      </div>

      {parentStudentForm.mode === 'existing' ? (
        <Form.Group>
          <Form.Label>Select Existing Student</Form.Label>
          <Select
            options={parentExistingStudentOptions}
            value={parentExistingStudentOptions.find((option) => String(option.value) === String(parentStudentForm.existing_student_id)) || null}
            onChange={(option) => setParentStudentForm({
              ...parentStudentForm,
              existing_student_id: option?.value || '',
            })}
            placeholder="Search student"
            isClearable
          />
          <Form.Text className="text-muted">
            This links the student to this parent without changing the student record.
          </Form.Text>
        </Form.Group>
      ) : (
        <Row className="g-3">
          <Col sm={6}>
            <Form.Label>First Name</Form.Label>
            <Form.Control
              value={parentStudentForm.first_name}
              onChange={(e) => setParentStudentForm({ ...parentStudentForm, first_name: e.target.value })}
              required
            />
          </Col>
          <Col sm={6}>
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              value={parentStudentForm.last_name}
              onChange={(e) => setParentStudentForm({ ...parentStudentForm, last_name: e.target.value })}
              required
            />
          </Col>
          <Col sm={6}>
            <Form.Label>Class</Form.Label>
            <Form.Select
              value={parentStudentForm.class_id}
              onChange={(e) => handleParentStudentClassChange(e.target.value)}
              required
            >
              <option value="">Select class</option>
              {allClasses.map((cls) => (
                <option key={cls.id} value={cls.id}>
                  {cls.name}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col sm={6}>
            <Form.Label>Shift</Form.Label>
            <Form.Select
              value={parentStudentForm.shift}
              onChange={(e) => setParentStudentForm({ ...parentStudentForm, shift: e.target.value })}
              required
            >
              {SHIFT_OPTIONS.map((shiftOption) => (
                <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
              ))}
            </Form.Select>
          </Col>
          <Col xs={12}>
            <div className="parent-student-teacher-hint">
              Teacher:{' '}
              {(() => {
                const selectedClass = allClasses.find((cls) => String(cls.id) === String(parentStudentForm.class_id));
                const teacherName = [selectedClass?.teacher_first_name, selectedClass?.teacher_last_name].filter(Boolean).join(' ').trim();
                return teacherName || selectedClass?.teacher_name || 'Select a class to see teacher';
              })()}
            </div>
          </Col>
        </Row>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={() => setShowParentStudentModal(false)}>
        Cancel
      </Button>
      <Button type="submit" variant="primary">
        {parentStudentForm.mode === 'existing' ? 'Link Student' : 'Add Student'}
      </Button>
    </Modal.Footer>
  </Form>
</Modal>

<Modal show={showParentStudentActionModal} onHide={() => setShowParentStudentActionModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {parentStudentActionType === 'update' ? 'Update Assigned Student' : 'Delete Assigned Student'}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>Select Student</Form.Label>
      <Form.Select
        value={parentStudentActionId}
        onChange={(e) => setParentStudentActionId(e.target.value)}
      >
        <option value="">Select student</option>
        {parentStudents.map((student) => (
          <option key={getStudentId(student)} value={getStudentId(student)}>
            {student.first_name} {student.last_name} - {student.class_name || 'No class'}
          </option>
        ))}
      </Form.Select>
      {parentStudentActionType === 'remove' && (
        <Form.Text className="text-muted">
          This deletes the student from the whole system, including attendance records and parent links.
        </Form.Text>
      )}
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="outline-secondary" onClick={() => setShowParentStudentActionModal(false)}>
      Cancel
    </Button>
    <Button
      variant={parentStudentActionType === 'remove' ? 'danger' : 'primary'}
      onClick={handleParentStudentActionSubmit}
    >
      {parentStudentActionType === 'update' ? 'Continue' : 'Delete Student'}
    </Button>
  </Modal.Footer>
</Modal>





        <Modal show={showAddStudentModal} onHide={() => setShowAddStudentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Student</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form onSubmit={handleAddStudent}>
      {/* Student Name */}
      <Row className="g-2">
        <Col>
          <Form.Control
            name="first_name"
            placeholder="First name"
            required
            value={newStudent.first_name}
            onChange={(e) => setNewStudent({ ...newStudent, first_name: e.target.value })}
          />
        </Col>
        <Col>
          <Form.Control
            name="last_name"
            placeholder="Last name"
            required
            value={newStudent.last_name}
            onChange={(e) => setNewStudent({ ...newStudent, last_name: e.target.value })}
          />
        </Col>
      </Row>

      {/* Class and Shift */}
      <Row className="g-2 mt-3">
        <Col>
          <Form.Select
            name="class_id"
            required
            value={newStudent.class_id}
            onChange={(e) => setNewStudent({ ...newStudent, class_id: e.target.value })}
          >
            <option value="">-- Select Class --</option>
            {allClasses.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col>
          <Form.Select
            name="shift"
            required
            value={newStudent.shift}
            onChange={(e) => setNewStudent({ ...newStudent, shift: e.target.value })}
          >
            <option value="">-- Select Shift --</option>
            {SHIFT_OPTIONS.map((shiftOption) => (
              <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      <hr />

      {/* 🔄 Toggle to select existing parent */}
      <Form.Check
        className="mb-3 mt-2"
        type="checkbox"
        label="Use existing Parent 1"
        checked={useExistingParent}
        onChange={() => {
          setUseExistingParent(!useExistingParent);
          setNewStudent({ ...newStudent, parent_id: '', parentSearchTerm: '' });
          if (!useExistingParent && parents.length === 0) {
            fetchParents();
          }
        }}
      />

      {useExistingParent ? (
        <>

          <Form.Group className="mb-3">
            <Form.Label>Parent 1 <span className="text-muted">(main/default)</span></Form.Label>
            <Select
              options={parents.map(p => ({
                value: p.id,
                label: `${p.first_name} ${p.last_name} — ${formatPhone(p.phone_number)}`
              }))}
              value={
                newStudent.parent_id
                  ? {
                      value: newStudent.parent_id,
                      label: parents.find(p => p.id === parseInt(newStudent.parent_id))?.first_name +
                        ' ' +
                        parents.find(p => p.id === parseInt(newStudent.parent_id))?.last_name +
                        ' — ' +
                        parents.find(p => p.id === parseInt(newStudent.parent_id))?.phone_number
                    }
                  : null
              }
              onChange={(selected) => {
                setNewStudent({ ...newStudent, parent_id: selected ? selected.value : '' });
              }}
              placeholder="Search and select Parent 1"
              isClearable
            />
          </Form.Group>
        </>
      ) : (
        <>
          {/* Parent 1 */}
          <h6 className="mt-3">Parent 1 <span className="text-muted fw-normal">(main/default)</span></h6>
          <Row className="g-2">
            <Col>
              <Form.Control
                placeholder="First Name"
                value={newStudent.parent1_first_name || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent1_first_name: e.target.value })
                }
                required
              />
            </Col>
            <Col>
              <Form.Control
                placeholder="Last Name"
                value={newStudent.parent1_last_name || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent1_last_name: e.target.value })
                }
                required
              />
            </Col>
            <Col>
              <Form.Control
                placeholder="Phone Number"
                value={newStudent.parent1_phone || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent1_phone: formatPhone(e.target.value) })
                }
                required
              />
            </Col>
          </Row>
          {/* Parent 2 (Optional) */}
          <h6 className="mt-4">Parent 2 (Optional)</h6>
          <Row className="g-2">
            <Col>
              <Form.Control
                placeholder="First Name"
                value={newStudent.parent2_first_name || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent2_first_name: e.target.value })
                }
              />
            </Col>
            <Col>
              <Form.Control
                placeholder="Last Name"
                value={newStudent.parent2_last_name || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent2_last_name: e.target.value })
                }
              />
            </Col>
            <Col>
              <Form.Control
                placeholder="Phone Number"
                value={newStudent.parent2_phone || ''}
                onChange={(e) =>
                  setNewStudent({ ...newStudent, parent2_phone: formatPhone(e.target.value) })
                }
              />
            </Col>
          </Row>
        </>
      )}

      <div className="mt-4 d-flex justify-content-end">
        <Button variant="secondary" className="me-2" onClick={() => setShowAddStudentModal(false)}>
          Cancel
        </Button>
        <Button type="submit" variant="success">
          Add Student
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>




        <Modal show={showStudentListModal} onHide={() => setShowStudentListModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Assigned Students</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {viewingStudents.length === 0 ? (
      <p>No students assigned to this parent.</p>
    ) : (
      <ul>
        {viewingStudents.map((s, i) => (
          <li key={s.id}>{s.first_name} {s.last_name} ({s.class_name || 'No class'})</li>
        ))}
      </ul>
    )}
  </Modal.Body>
</Modal>

<Modal show={!!editParent} onHide={() => setEditParent(null)}>
  <Modal.Header closeButton>
    <Modal.Title>Edit Parent</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={async e => {
      e.preventDefault();
      await axios.put(`${API_URL}/parents/${editParent.id}`, editParent, authHeader());
      setEditParent(null);
      fetchParents();
    }}>
      <Form.Group className="mb-3">
        <Form.Label>First Name</Form.Label>
        <Form.Control
          value={editParent?.first_name || ''}
          onChange={e => setEditParent({ ...editParent, first_name: e.target.value })}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Last Name</Form.Label>
        <Form.Control
          value={editParent?.last_name || ''}
          onChange={e => setEditParent({ ...editParent, last_name: e.target.value })}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          value={editParent?.phone_number || ''}
          onChange={e => setEditParent({ ...editParent, phone_number: formatPhone(e.target.value) })}
        />
      </Form.Group>
      <Button type="submit" variant="success">Save</Button>{' '}
      <Button variant="secondary" onClick={() => setEditParent(null)}>Cancel</Button>
    </Form>
  </Modal.Body>
</Modal>

  <Modal
    show={showStudentDetailsModal}
    onHide={() => setShowStudentDetailsModal(false)}
    onExited={() => {
      if (returnToClassStudents) {
        setShowStudentModal(true);
        setReturnToClassStudents(false);
      } else if (returnToParentProfile) {
        setShowParentProfile(true);
        setReturnToParentProfile(false);
      }
    }}
    centered
    size="xl"
    fullscreen="sm-down"
    dialogClassName="student-details-modal"
  >
  <Modal.Header closeButton className="student-details-modal__header">
    <div className="student-details-modal__title-row">
      <Modal.Title>
        {editMode ? 'Update student' : 'Student profile'}
      </Modal.Title>
      {!editMode && (
        <Button
          variant="outline-primary"
          size="sm"
          className="student-details-modal__edit-btn"
          onClick={async () => {
            if (!allClasses.length) {
              await fetchAllClasses();
            }
            setEditMode(true);
          }}
        >
          Update
        </Button>
      )}
    </div>
  </Modal.Header>

  <Modal.Body className="text-center student-details-modal__body">
    {editableStudent && (
      <>
        <Card className="student-details-card shadow-sm border-0 rounded-4 bg-white">
          <Card.Body className="student-profile-identity text-center">
            <div className="student-avatar-shell mb-3">
              {!studentAvatarError ? (
                <img
                  src={`${process.env.PUBLIC_URL || ''}/student-placeholder.png`}
                  alt={studentFullName || 'Student'}
                  className="student-photo rounded-circle"
                  onError={() => setStudentAvatarError(true)}
                />
              ) : (
                <div className="student-avatar-fallback" aria-label={studentFullName || 'Student'}>
                  <BiUserCircle size={38} />
                  <span>{studentInitials}</span>
                </div>
              )}
            </div>

            {editMode ? (
              <div className="d-flex flex-column flex-md-row gap-2 mb-2 justify-content-center">
                <Form.Control
                  type="text"
                  value={editableStudent.first_name}
                  onChange={e => setEditableStudent({ ...editableStudent, first_name: e.target.value })}
                  placeholder="First Name"
                />
                <Form.Control
                  type="text"
                  value={editableStudent.last_name}
                  onChange={e => setEditableStudent({ ...editableStudent, last_name: e.target.value })}
                  placeholder="Last Name"
                />
              </div>
            ) : (
              <h5 className="student-details-name mb-1">{editableStudent.first_name} {editableStudent.last_name}</h5>
            )}
          </Card.Body>

          <Card.Body className="student-profile-information">
            <div className="student-profile-section-heading text-start">
              <span>Student information</span>
              <h3>Class and family</h3>
            </div>
            <div className="student-details-grid text-start">
              <div className="student-detail-item d-flex justify-content-between align-items-center">
                <div className="student-detail-label">Class</div>
                <div className="student-detail-value">
                  {editMode ? (
                    <Form.Select
                      size="sm"
                      value={editableStudent.class_id || ''}
                      onChange={(e) => {
                        const selected = allClasses.find((cls) => String(cls.id) === String(e.target.value));
                        setEditableStudent({
                          ...editableStudent,
                          class_id: e.target.value,
                          class_name: selected?.name || '',
                          shift: selected?.shift || editableStudent.shift,
                          teacher_name: getClassTeacherName(e.target.value),
                        });
                      }}
                      style={{ minWidth: 180 }}
                    >
                      <option value="">Select Class</option>
                      {allClasses.map((cls) => {
                        const teacherName = [cls.teacher_first_name, cls.teacher_last_name].filter(Boolean).join(' ').trim();
                        return (
                          <option key={cls.id} value={cls.id}>
                            {cls.name}{teacherName ? ` - ${teacherName}` : ' - No teacher'}
                          </option>
                        );
                      })}
                    </Form.Select>
                  ) : (
                    editableStudent.class_name || 'Not assigned'
                  )}
                </div>
              </div>
              <div className="student-detail-item d-flex justify-content-between align-items-center">
                <div className="student-detail-label">Shift</div>
                <div className="student-detail-value">
                  {editMode ? (
                    <Form.Select
                      size="sm"
                      value={editableStudent.shift}
                      onChange={e => setEditableStudent({ ...editableStudent, shift: e.target.value })}
                      style={{ minWidth: 160 }}
                    >
                      <option value="">Select Shift</option>
                      {SHIFT_OPTIONS.map((shiftOption) => (
                        <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
                      ))}
                    </Form.Select>
                  ) : (
                    editableStudent.shift || 'Not assigned'
                  )}
                </div>
              </div>
              <div className="student-detail-item d-flex justify-content-between align-items-center">
                <div className="student-detail-label">Teacher</div>
                <div className="student-detail-value">
                  {editMode
                    ? (getClassTeacherName(editableStudent.class_id) || editableStudent.teacher_name || 'Not assigned')
                    : (editableStudent.teacher_name || 'Not assigned')}
                </div>
              </div>
              {Array.isArray(editableStudent.parents) && editableStudent.parents.length > 0 ? (
                editableStudent.parents.slice(0, 2).map((parent, index) => (
                  <div
                    key={parent.id || index}
                    className="student-detail-item student-detail-item--parent"
                  >
                    <div className="d-flex justify-content-between align-items-center gap-3">
                      <div className="student-detail-label">{`Parent ${index + 1}`}</div>
                      <div className="student-detail-value">{formatPhone(parent.phone_number) || 'No phone'}</div>
                    </div>
                    <div className="student-parent-name mt-2">{parent.first_name} {parent.last_name}</div>
                  </div>
                ))
              ) : (
                <div className="student-detail-item student-detail-item--empty">
                  No parents assigned
                </div>
              )}
            </div>
          </Card.Body>
          {!editMode && (
            <Card.Body className="student-profile-attendance">
              <StudentAttendancePanel studentId={editableStudent.id} />
            </Card.Body>
          )}
        </Card>
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    {editMode ? (
      <>
        <Button variant="secondary" onClick={() => {
          setEditMode(false);
          setEditableStudent(selectedStudent); // discard changes
        }}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSaveStudent}>
          Update Student
        </Button>

      </>
    ) : (
      <Button variant="secondary" onClick={() => setShowStudentDetailsModal(false)}>Close</Button>
    )}
  </Modal.Footer>
</Modal>









<Modal show={showEditStudentModal} onHide={() => setShowEditStudentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Update Student</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {editStudent && (
      <Form onSubmit={async (e) => {
        e.preventDefault();
        await axios.put(`${API_URL}/students/${editStudent.id}`, {
          first_name: editStudent.first_name,
          last_name: editStudent.last_name,
          shift: editStudent.shift
        }, authHeader());
        setShowEditStudentModal(false);
        fetchAllStudents();
      }}>
        <Form.Group className="mb-3">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            value={editStudent.first_name}
            onChange={e => setEditStudent({ ...editStudent, first_name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            value={editStudent.last_name}
            onChange={e => setEditStudent({ ...editStudent, last_name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Shift</Form.Label>
          <Form.Select
            value={editStudent.shift}
            onChange={e => setEditStudent({ ...editStudent, shift: e.target.value })}
          >
            <option value="">Select shift</option>
            {SHIFT_OPTIONS.map((shiftOption) => (
              <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Button type="submit">Save</Button>
      </Form>
    )}
  </Modal.Body>
</Modal>


<Modal show={showAddClassModal} onHide={() => setShowAddClassModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Class</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleAddClass}>
      <Form.Group className="mb-3">
        <Form.Label>Class Name</Form.Label>
        <Form.Control
          type="text"
          required
          placeholder="Enter class name"
          value={newClass.name}
          onChange={(e) => setNewClass({ ...newClass, name: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Shift</Form.Label>
        <Form.Select
          required
          value={newClass.shift || ''}
          onChange={(e) => setNewClass({ ...newClass, shift: e.target.value })}
        >
          <option value="">Select shift</option>
          {SHIFT_OPTIONS.map((shiftOption) => (
            <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button type="submit" variant="success">
          Add Class
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>


<Modal show={showAddParentModal} onHide={() => setShowAddParentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Parent</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form
      onSubmit={async (e) => {
        e.preventDefault();
        if (!newParent.first_name || !newParent.last_name || !newParent.phone_number) {
          toast.error('All fields are required');
          return;
        }

        try {
          await axios.post(`${API_URL}/parents`, newParent, authHeader());
          toast.success('Parent added successfully');
          setNewParent({ first_name: '', last_name: '', phone_number: '' });
          setShowAddParentModal(false);
          fetchParents();
        } catch (err) {
          toast.error(err?.response?.data?.error || 'Failed to add parent');
        }
      }}
    >
      <Form.Group className="mb-3">
        <Form.Label>First Name</Form.Label>
        <Form.Control
          required
          value={newParent.first_name}
          onChange={e => setNewParent({ ...newParent, first_name: e.target.value })}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Last Name</Form.Label>
        <Form.Control
          required
          value={newParent.last_name}
          onChange={e => setNewParent({ ...newParent, last_name: e.target.value })}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          required
          value={newParent.phone_number}
          onChange={e => setNewParent({ ...newParent, phone_number: formatPhone(e.target.value) })}
        />
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={() => setShowAddParentModal(false)} className="me-2">
          Cancel
        </Button>
        <Button type="submit" variant="success">
          Add Parent
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

<Modal show={showAddTeacherModal} onHide={() => setShowAddTeacherModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Add Teacher</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>First Name</Form.Label>
        <Form.Control
          type="text"
          value={newTeacher.first_name}
          onChange={(e) => setNewTeacher({ ...newTeacher, first_name: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Last Name</Form.Label>
        <Form.Control
          type="text"
          value={newTeacher.last_name}
          onChange={(e) => setNewTeacher({ ...newTeacher, last_name: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          value={newTeacher.email}
          onChange={(e) => setNewTeacher({ ...newTeacher, email: e.target.value })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Phone</Form.Label>
        <Form.Control
          type="text"
          value={newTeacher.phone_number}
          onChange={(e) => setNewTeacher({ ...newTeacher, phone_number: formatPhone(e.target.value) })}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Temporary Password</Form.Label>
        <InputGroup>
          <Form.Control
            type="text"
            value={newTeacher.password}
            onChange={(e) => setNewTeacher({ ...newTeacher, password: e.target.value })}
          />
          <Button
            variant="outline-secondary"
            onClick={() => setNewTeacher({ ...newTeacher, password: generateTempPassword() })}
          >
            Generate
          </Button>
        </InputGroup>
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={() => setShowAddTeacherModal(false)} className="me-2">
          Cancel
        </Button>
        <Button variant="success" onClick={handleCreateTeacher}>
          Create Teacher
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

<Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Update Teacher</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {editTeacher && (
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            value={editTeacher?.first_name || ''}
            onChange={(e) => setEditTeacher({ ...editTeacher, first_name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            value={editTeacher?.last_name || ''}
            onChange={(e) => setEditTeacher({ ...editTeacher, last_name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone</Form.Label>
          <Form.Control
            type="text"
            value={editTeacher?.phone_number || ''}
            onChange={(e) => setEditTeacher({ ...editTeacher, phone_number: formatPhone(e.target.value) })}
            />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={editTeacher?.email || ''}
            onChange={(e) => setEditTeacher({ ...editTeacher, email: e.target.value })}
          />
        </Form.Group>

        <div className="d-flex justify-content-end">
          <Button variant="secondary" onClick={() => setShowUpdateModal(false)} className="me-2">
            Cancel
          </Button>
          <Button variant="success" onClick={handleUpdateTeacher}>
            Save Changes
          </Button>
        </div>
      </Form>
    )}
  </Modal.Body>
</Modal>



<Modal show={showAssignModal} onHide={() => setShowAssignModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Assign "{selectedClass?.name}" to a Teacher</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>Select Teacher</Form.Label>
        <Form.Select
          value={selectedTeacherId}
          onChange={(e) => setSelectedTeacherId(e.target.value)}
        >
          <option value="">-- Select Teacher --</option>
          {teachers.map((t) => (
            <option key={t.id} value={t.id}>
              {t.first_name} {t.last_name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={() => setShowAssignModal(false)} className="me-2">
          Cancel
        </Button>
        <Button variant="success" onClick={handleAssignClassToTeacher}>
          Assign
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

<Modal
  show={showReportModal}
  onHide={() => setShowReportModal(false)}
  size="lg"
  centered
  dialogClassName="attendance-report-modal"
  fullscreen="sm-down"   // mobile-friendly
>
  <Modal.Header closeButton className="attendance-report-modal__header">
    <div>
      <Modal.Title>Attendance Report</Modal.Title>
      <div className="attendance-report-modal__subtitle">
        Quick monthly attendance summary with student-level detail
      </div>
    </div>
  </Modal.Header>
  <Modal.Body className="attendance-report-modal__body">
    {report.length === 0 ? (
      <p>No records found.</p>
    ) : (
      <>
        <div className="attendance-report-toolbar">
          <div>
            <div className="attendance-section-heading mb-1">Attendance overview</div>
            <div className="attendance-section-copy">
              See strongest attendance, weakest attendance, and the full dated log in one place.
            </div>
          </div>
          <div className="attendance-report-actions">
            <Button size="sm" variant="outline-dark" onClick={handlePrintReport}>
              Print
            </Button>
            <Button size="sm" variant="outline-primary" onClick={handleExportInsightsPDF}>
              Download
            </Button>
            <Button size="sm" variant="outline-success" onClick={handleShareAttendanceReport}>
              Share
            </Button>
          </div>
        </div>

        {!isSingleStudentReport && (
          <Row className="g-3">
            <Col md={6}>
              <Card className="report-chart-card shadow-sm h-100 attendance-highlight-card attendance-highlight-card--best">
                <Card.Body>
                  <div className="attendance-highlight-label">Best Attendance</div>
                  {reportInsights.bestStudents?.length ? (
                    <>
                      <div className="attendance-highlight-name">
                        {reportInsights.bestStudents.length === 1
                          ? reportInsights.bestStudents[0].name
                          : `${reportInsights.bestStudents.length} students tied`}
                      </div>
                      <div className="attendance-highlight-value">{reportInsights.bestStudent.pct}% present</div>
                      <div className="attendance-highlight-meta">
                        {reportInsights.bestStudents.map((student) => student.name).join(', ')}
                      </div>
                      <div className="attendance-highlight-meta">
                        {reportInsights.bestStudents.length === 1
                          ? `${reportInsights.bestStudent.present} present, ${reportInsights.bestStudent.late} late, ${reportInsights.bestStudent.absent} absent, ${reportInsights.bestStudent.excused} excused`
                          : `${reportInsights.bestStudents.length} students share the highest present rate.`}
                      </div>
                    </>
                  ) : (
                    <div className="text-muted small">No absent days found in this range.</div>
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="report-chart-card shadow-sm h-100 attendance-highlight-card attendance-highlight-card--worst">
                <Card.Body>
                  <div className="attendance-highlight-label">Needs Attention</div>
                  {reportInsights.worstStudents?.length ? (
                    <>
                      <div className="attendance-highlight-name">
                        {reportInsights.worstStudents.length === 1
                          ? reportInsights.worstStudents[0].name
                          : `${reportInsights.worstStudents.length} students tied`}
                      </div>
                      <div className="attendance-highlight-value">{reportInsights.worstStudent.pct}% present</div>
                      <div className="attendance-highlight-meta">
                        {reportInsights.worstStudents.map((student) => student.name).join(', ')}
                      </div>
                      <div className="attendance-highlight-meta">
                        {reportInsights.worstStudents.length === 1
                          ? `${reportInsights.worstStudent.absent} absent day(s), ${reportInsights.worstStudent.present} present, ${reportInsights.worstStudent.late} late, ${reportInsights.worstStudent.excused} excused`
                          : `${reportInsights.worstStudents.length} students share the most absent days.`}
                      </div>
                    </>
                  ) : (
                    <div className="text-muted small">No attendance data found in this range.</div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        <Card className={`attendance-table-card report-table-card ${isSingleStudentReport ? '' : 'mt-3'}`}>
          <Card.Body>
            <div className="attendance-section-heading">Attendance Log</div>
            <div className="attendance-section-copy mb-3">
              Each attendance mark by date for the selected filters.
            </div>
            <Table responsive size="sm" className="attendance-records-table report-table mb-0 d-none d-md-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Late</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const sortedReport = [...report].sort((a, b) => new Date(b.date) - new Date(a.date));
                  let lastDateLabel = null;

                  return sortedReport.flatMap((r, i) => {
                    const dateLabel = formatDateOnly(r.date);
                    const rows = [];

                    if (dateLabel !== lastDateLabel) {
                      lastDateLabel = dateLabel;
                      rows.push(
                        <tr key={`date-${dateLabel}-${i}`} className="attendance-date-row">
                          <td colSpan={5}>
                            <div className="attendance-date-divider">{dateLabel}</div>
                          </td>
                        </tr>
                      );
                    }

                    rows.push(
                      <tr key={`record-${i}`}>
                        <td className="attendance-record-date">{dateLabel}</td>
                        <td>
                          <div className="attendance-student-name">{r.first_name} {r.last_name}</div>
                        </td>
                        <td>
                          <span className={`attendance-status-pill attendance-status-pill--${String(r.status || '').toLowerCase()}`}>
                            {r.status}{r.is_late ? ' · late' : ''}
                          </span>
                        </td>
                        <td>{r.is_late ? 'Yes' : 'No'}</td>
                        <td>{r.comment || '—'}</td>
                      </tr>
                    );

                    return rows;
                  });
                })()}
              </tbody>
            </Table>
            <div className="attendance-mobile-log d-md-none">
              {(() => {
                const sortedReport = [...report].sort((a, b) => new Date(b.date) - new Date(a.date));
                let lastDateLabel = null;

                return sortedReport.flatMap((r, i) => {
                  const dateLabel = formatDateOnly(r.date);
                  const statusKey = String(r.status || '').toLowerCase();
                  const cards = [];

                  if (dateLabel !== lastDateLabel) {
                    lastDateLabel = dateLabel;
                    cards.push(
                      <div key={`mobile-date-${dateLabel}-${i}`} className="attendance-mobile-date-divider">
                        {dateLabel}
                      </div>
                    );
                  }

                  cards.push(
                    <div key={`mobile-record-${i}`} className={`attendance-mobile-card attendance-mobile-card--${statusKey}`}>
                      <div className="attendance-mobile-card__header">
                        <div>
                          <div className="attendance-mobile-card__name">{r.first_name} {r.last_name}</div>
                        </div>
                        <span className={`attendance-status-pill attendance-status-pill--${statusKey}`}>
                          {r.status}{r.is_late ? ' · late' : ''}
                        </span>
                      </div>
                      <div className="attendance-mobile-card__grid">
                        <div>
                          <div className="attendance-mobile-card__label">Late</div>
                          <div className="attendance-mobile-card__value">{r.is_late ? 'Yes' : 'No'}</div>
                        </div>
                        <div>
                          <div className="attendance-mobile-card__label">Comment</div>
                          <div className="attendance-mobile-card__value">{r.comment || '—'}</div>
                        </div>
                      </div>
                    </div>
                  );

                  return cards;
                });
              })()}
            </div>
          </Card.Body>
        </Card>
      </>
    )}
  </Modal.Body>
</Modal>

<Modal
  show={waitingRegistration.show}
  onHide={closeRegisterWaitingModal}
  centered
  fullscreen="sm-down"
  dialogClassName="waiting-list-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>Register Student</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {waitingRegistration.entry ? (
      <Form>
        <div className="waiting-register-summary">
          <div>
            <span>Student</span>
            <strong>{waitingRegistration.entry.first_name} {waitingRegistration.entry.last_name}</strong>
          </div>
          <div>
            <span>Parent</span>
            <strong>{waitingRegistration.entry.parent_name || '-'}</strong>
          </div>
          <div>
            <span>Phone</span>
            <strong>{formatPhone(waitingRegistration.entry.parent_phone) || '-'}</strong>
          </div>
          <div>
            <span>Requested Shift</span>
            <strong>{waitingRegistration.entry.shift || '-'}</strong>
          </div>
        </div>

        <Form.Group className="mt-3">
          <Form.Label>Class</Form.Label>
          <Form.Select
            value={waitingRegistration.class_id}
            onChange={(e) => setWaitingRegistration((current) => ({
              ...current,
              class_id: e.target.value,
            }))}
          >
            <option value="">Select class</option>
            {allClasses.map((cls) => {
              const teacherName = [cls.teacher_first_name, cls.teacher_last_name].filter(Boolean).join(' ').trim() ||
                cls.teacher_name ||
                'No teacher assigned';

              return (
                <option key={cls.id} value={cls.id}>
                  {cls.name} - {cls.shift || 'No shift'} - {teacherName}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>

        {waitingRegistration.class_id && (
          <div className="waiting-register-class-hint">
            {(() => {
              const selected = allClasses.find((cls) => String(cls.id) === String(waitingRegistration.class_id));
              const teacherName = getClassTeacherName(waitingRegistration.class_id) || 'No teacher assigned';
              return (
                <>
                  <span>Final assignment</span>
                  <strong>
                    {selected?.name || 'Selected class'} · {selected?.shift || waitingRegistration.entry.shift || 'No shift'} · {teacherName}
                  </strong>
                </>
              );
            })()}
          </div>
        )}
      </Form>
    ) : (
      <p className="text-muted mb-0">No waiting list entry selected.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={closeRegisterWaitingModal}
      disabled={waitingRegistration.submitting}
    >
      Cancel
    </Button>
    <Button
      variant="success"
      onClick={handleRegisterWaitingStudent}
      disabled={!waitingRegistration.class_id || waitingRegistration.submitting}
    >
      {waitingRegistration.submitting ? 'Registering...' : 'Register Student'}
    </Button>
  </Modal.Footer>
</Modal>



<Modal show={showWaitingModal} onHide={closeWaitingModal} centered fullscreen="sm-down" dialogClassName="waiting-list-modal">
  <Modal.Header closeButton>
    <Modal.Title>{editingWaitingEntry ? 'Edit Waiting List Entry' : 'Add to Waiting List'}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row className="g-3">
        <Col md={6}>
          <Form.Label>First Name</Form.Label>
          <Form.Control
            value={waitingForm.first_name}
            onChange={(e) => setWaitingForm({ ...waitingForm, first_name: e.target.value })}
            placeholder="Enter first name"
          />
        </Col>

        <Col md={6}>
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            value={waitingForm.last_name}
            onChange={(e) => setWaitingForm({ ...waitingForm, last_name: e.target.value })}
            placeholder="Enter last name"
          />
        </Col>

        <Col md={6}>
          <Form.Label>Parent Phone</Form.Label>
          <Form.Control
            value={waitingForm.parent_phone}
            onChange={(e) => setWaitingForm({ ...waitingForm, parent_phone: formatPhone(e.target.value) })}
            placeholder="e.g. (555) 123-4567"
          />
        </Col>

        <Col md={6}>
          <Form.Label>Parent Name</Form.Label>
          <Form.Control
            value={waitingForm.parent_name}
            onChange={(e) => setWaitingForm({ ...waitingForm, parent_name: e.target.value })}
            placeholder="Enter parent name"
          />
        </Col>

        <Col md={6}>
          <Form.Label>Previous Markaz</Form.Label>
          <Form.Control
            value={waitingForm.previous_markaz}
            onChange={(e) => setWaitingForm({ ...waitingForm, previous_markaz: e.target.value })}
            placeholder="Enter previous markaz"
          />
        </Col>

        <Col md={6}>
          <Form.Label>Shift</Form.Label>
          <Form.Select
            value={waitingForm.shift}
            onChange={(e) => setWaitingForm({ ...waitingForm, shift: e.target.value })}
          >
            <option value="">Select shift</option>
            {SHIFT_OPTIONS.map((shiftOption) => (
              <option key={shiftOption} value={shiftOption}>{shiftOption}</option>
            ))}
          </Form.Select>
        </Col>

        <Col md={6}>
          <Form.Label>Date Added</Form.Label>
          <Form.Control
            type="date"
            value={waitingForm.date_added}
            onChange={(e) => setWaitingForm({ ...waitingForm, date_added: e.target.value })}
          />
        </Col>
      </Row>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={closeWaitingModal}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleWaitingSubmit}>
      {editingWaitingEntry ? 'Save Changes' : 'Add to List'}
    </Button>
  </Modal.Footer>
</Modal>

<Modal show={showCSVModal} onHide={() => setShowCSVModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Upload Students Sheet</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleCSVUpload}>
      <Form.Group>
        <Form.Label>Select Excel or CSV File</Form.Label>
        <Form.Control type="file" accept=".csv,.xlsx,.xls" onChange={e => setCsvFile(e.target.files[0])} />
      </Form.Group>
      <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
        <Button type="button" variant="outline-secondary" onClick={handleDownloadStudentTemplate}>
          Download Template
        </Button>
        <div className="text-end">
        <Button variant="secondary" onClick={() => setShowCSVModal(false)}>Cancel</Button>
        <Button type="submit" className="ms-2" variant="primary">Upload</Button>
        </div>
      </div>
    </Form>
  </Modal.Body>
</Modal>

<Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this student? This action cannot be undone.
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleDeleteStudentConfirmed}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>

<Modal show={confirmAction.show} onHide={() => setConfirmAction({ show: false, type: '', payload: null })} centered>
  <Modal.Header closeButton>
    <Modal.Title>{confirmContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {confirmContent.body}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setConfirmAction({ show: false, type: '', payload: null })}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleConfirmAction}>
      {confirmContent.confirmText}
    </Button>
  </Modal.Footer>
</Modal>



<Modal
  show={showParentProfile}
  onHide={() => {
    setShowParentProfile(false);
  setEditMode(false);
  setParentProfileTab('profile');
  setShowAddFeeModal(false);
  setShowEditFeeModal(false);
  setShowPayBalanceModal(false);
}}
  centered
  fullscreen="sm-down"
  dialogClassName="parent-profile-modal"
>
  <Modal.Header closeButton className="py-2 py-sm-3">
    <Modal.Title className="fs-5 fs-sm-4">Parent Profile</Modal.Title>
  </Modal.Header>

  <Modal.Body className="p-3 p-sm-4">
    {editableParent && (
      <>
        <Tabs
          activeKey={parentProfileTab}
          onSelect={(tab) => setParentProfileTab(tab || 'profile')}
          id="parent-tabs"
          className="mb-3 custom-tabs tabs-scroll tabs-sticky"
          mountOnEnter
          unmountOnExit
        >
          {/* ===================== Details ===================== */}
          <Tab eventKey="profile" title={<span><BiUser className="me-1" /> Details</span>}>
            <div className="parent-profile-content">
              {/* header card */}
              <Card className="parent-details-card shadow-sm border-0 mb-3">
                <Card.Body className="parent-details-card__body">
                  <div className="parent-avatar-shell">
                    <span aria-hidden="true">
                      {`${editableParent.first_name?.[0] || ''}${editableParent.last_name?.[0] || ''}`.toUpperCase() || 'P'}
                    </span>
                  </div>
                  <div className="parent-details-main">
                    {editMode ? (
                      <div className="parent-name-fields">
                        <Form.Control
                          type="text"
                          value={editableParent.first_name}
                          onChange={e => setEditableParent({ ...editableParent, first_name: e.target.value })}
                          placeholder="First Name"
                        />
                        <Form.Control
                          type="text"
                          value={editableParent.last_name}
                          onChange={e => setEditableParent({ ...editableParent, last_name: e.target.value })}
                          placeholder="Last Name"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="parent-details-eyebrow">Parent profile</div>
                        <h5 className="parent-details-name mb-0">{editableParent.first_name} {editableParent.last_name}</h5>
                      </>
                    )}
                    <div className="parent-contact-row">
                      <div className="parent-contact-label">Phone</div>
                      {editMode ? (
                        <Form.Control
                          type="text"
                          value={editableParent.phone_number}
                          onChange={e => setEditableParent({ ...editableParent, phone_number: formatPhone(e.target.value) })}
                          placeholder="Phone Number"
                          size="sm"
                          className="mt-2"
                        />
                      ) : (
                        editableParent.phone_number ? (
                          <a className="parent-contact-value" href={`tel:${normalizePhone(editableParent.phone_number)}`}>
                            {formatPhone(editableParent.phone_number)}
                          </a>
                        ) : (
                          <span className="parent-contact-value parent-contact-value--muted">Not provided</span>
                        )
                      )}
                    </div>
                    {!editMode && (
                      <div className="parent-summary-stats" aria-label="Parent profile summary">
                        <div className="parent-summary-stat">
                          <strong>{parentStudents.length}</strong>
                          <span>{parentStudents.length === 1 ? 'Student' : 'Students'}</span>
                        </div>
                        <div className="parent-summary-stat">
                          <strong>{coParents.length}</strong>
                          <span>Linked parents</span>
                        </div>
                        <button
                          type="button"
                          className="parent-summary-stat parent-summary-stat--button"
                          onClick={() => setParentProfileTab('notes')}
                        >
                          <strong>{notes.length}</strong>
                          <span>{notes.length === 1 ? 'Note' : 'Notes'}</span>
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="parent-details-actions">
                    {editMode ? (
                      <>
                        <Button size="sm" variant="success" onClick={handleSaveParentUpdate}>Save</Button>
                        <Button size="sm" variant="outline-secondary" onClick={() => { setEditableParent(selectedParent); setEditMode(false); }}>Cancel</Button>
                      </>
                    ) : (
                      <Button size="sm" variant="outline-primary" onClick={() => setEditMode(true)}>Edit</Button>
                    )}
                  </div>
                </Card.Body>
              </Card>

              {/* ========== Assigned Students ========== */}
              <div className="parent-section-heading">
                <div>
                  <h6 className="text-start section-title mb-1">Students</h6>
                  <p className="parent-section-copy mb-0">View the students connected to this parent.</p>
                </div>
                <Dropdown align="end" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                  <Dropdown.Toggle size="sm" variant="outline-primary" className="parent-profile-actions-toggle">
                    Manage students
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => openParentStudentAction('update')} disabled={parentStudents.length === 0}>
                      <BiEdit className="me-2" /> Update Student
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openParentStudentAction('add')}>
                      <BiPlus className="me-2" /> Add Student
                    </Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => openParentStudentAction('remove')} disabled={parentStudents.length === 0}>
                      <BiTrash className="me-2" /> Delete Student
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="parent-profile-grid mt-2">
                {parentStudents.length > 0 ? parentStudents.map((student, idx) => (
                  <div key={student.id} className="parent-profile-item-card parent-profile-item-card--student">
                    <div className="parent-profile-item-card__header">
                      <span className="parent-profile-rank">{idx + 1}</span>
                      <div className="flex-grow-1 min-width-0">
                        <div className="parent-profile-item-card__eyebrow">Student</div>
                        <button
                          type="button"
                          className="parent-profile-item-card__title parent-profile-student-link"
                          onClick={() => openParentStudentProfile(student)}
                        >
                          {student.first_name} {student.last_name}
                        </button>
                      </div>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="parent-profile-view-button"
                        onClick={() => openParentStudentProfile(student)}
                      >
                        View profile
                      </Button>
                    </div>
                    <div className="parent-profile-item-card__grid">
                      <div className="parent-profile-item-card__cell">
                        <div className="parent-profile-item-card__label">Class</div>
                        <div className="parent-profile-item-card__value">{student.class_name || 'No class'}</div>
                      </div>
                      <div className="parent-profile-item-card__cell">
                        <div className="parent-profile-item-card__label">Teacher</div>
                        <div className="parent-profile-item-card__value parent-profile-item-card__value--muted">
                          {(student.teacher_first_name || student.teacher_last_name)
                            ? `${student.teacher_first_name || ''} ${student.teacher_last_name || ''}`.trim()
                            : '—'}
                        </div>
                      </div>
                    </div>
                  </div>
                )) : (
                  <div className="parent-profile-empty-state">
                    <BiGroup aria-hidden="true" />
                    <div>
                      <strong>No students linked</strong>
                      <span>Use Manage students to add or link a student.</span>
                    </div>
                  </div>
                )}
              </div>

              <hr className="my-3" />

              {/* ========== Other Parent(s) ========== */}
              <div className="parent-section-heading">
                <div>
                  <h6 className="text-start section-title mb-1">Linked parents</h6>
                  <p className="parent-section-copy mb-0">Other parents connected through the same students.</p>
                </div>
                <Dropdown align="end" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                  <Dropdown.Toggle size="sm" variant="outline-primary" className="parent-profile-actions-toggle">
                    Manage parents
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={openCoParentUpdateAction} disabled={coParents.length === 0}>
                      <BiEdit className="me-2" /> Update Parent
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openCoParentModal('new')} disabled={parentStudents.length === 0}>
                      <BiPlus className="me-2" /> Add New Parent
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => openCoParentModal('existing')} disabled={parentStudents.length === 0}>
                      <BiGroup className="me-2" /> Link Existing Parent
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="parent-profile-grid mt-2">
                {coParents.length > 0 ? coParents.map((parent, idx) => (
                  <div
                    key={parent.id}
                    className="parent-profile-item-card parent-profile-item-card--interactive text-start"
                  >
                    <div className="parent-profile-item-card__header">
                      <span className="parent-profile-rank">{idx + 1}</span>
                      <div>
                        <div className="parent-profile-item-card__eyebrow">Other Parent</div>
                        <button
                          type="button"
                          className="btn btn-link p-0 parent-profile-item-card__title text-start"
                          onClick={() => handleViewParentProfile(parent)}
                        >
                          {parent.first_name} {parent.last_name}
                        </button>
                      </div>
                    </div>
                    <div className="parent-profile-item-card__grid parent-profile-item-card__grid--single">
                      <div className="parent-profile-item-card__cell">
                        <div className="parent-profile-item-card__label">Phone</div>
                        {parent.phone_number ? (
                          <a className="parent-profile-item-card__value parent-profile-phone-link" href={`tel:${normalizePhone(parent.phone_number)}`}>
                            {formatPhone(parent.phone_number)}
                          </a>
                        ) : (
                          <div className="parent-profile-item-card__value parent-profile-item-card__value--muted">Not provided</div>
                        )}
                      </div>
                    </div>
                  </div>
                )) : (
                  <div className="parent-profile-empty-state">
                    <BiUser aria-hidden="true" />
                    <div>
                      <strong>No linked parents</strong>
                      <span>Add another parent when a student has more than one contact.</span>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </Tab>

          {/* ===================== Documents ===================== */}
          <Tab eventKey="documents" title={<span><BiFile className="me-1" /> Documents</span>}>
            <div className="parent-tab-empty-state">
              <span className="parent-tab-empty-state__icon"><BiFile aria-hidden="true" /></span>
              <h6>No documents yet</h6>
              <p>Parent documents will appear here when document uploads are available.</p>
            </div>
          </Tab>

          {/* ===================== Financials ===================== */}
          {isAlsunahMarkaz && (
            <Tab eventKey="financials" title={<span><BiWalletAlt className="me-1" /> Financials</span>}>
              <Card className="shadow-sm border-0 mb-3 ledger-card">
                <Card.Body className="p-3">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">
                    <div>
                      <div className="attendance-section-heading">Fee Ledger</div>
                      <div className="attendance-section-copy">
                        Track this family's monthly charges and payments.
                      </div>
                    </div>
                    <Button size="sm" variant="success" onClick={openAddLedgerRecord}>
                      <BiPlus className="me-1" /> Add Monthly Charge
                    </Button>
                  </div>

                  <div className="ledger-fee-setup mb-3">
                    <div className="ledger-fee-setup__title fw-bold text-primary border-start border-4 border-primary ps-2 mb-2">
                      Monthly Fee Setup
                    </div>
                    <Row className="g-2 align-items-end">
                      <Col md={3}>
                        <Form.Label>Weekend Fee</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="0.01"
                          value={editableParent?.parent_weekend_fee ?? ''}
                          onChange={(e) => setEditableParent({ ...editableParent, parent_weekend_fee: e.target.value })}
                        />
                      </Col>
                      <Col md={3}>
                        <Form.Label>Weekday Fee</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="0.01"
                          value={editableParent?.parent_weekday_fee ?? ''}
                          onChange={(e) => setEditableParent({ ...editableParent, parent_weekday_fee: e.target.value })}
                        />
                      </Col>
                      <Col md={3}>
                        <Form.Label>Supplemental Fee <span className="text-muted fw-normal">(optional)</span></Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="0.01"
                          value={editableParent?.parent_supplemental_fee ?? ''}
                          onChange={(e) => setEditableParent({ ...editableParent, parent_supplemental_fee: e.target.value })}
                        />
                      </Col>
                      <Col md={3}>
                        <Button className="w-100" variant="outline-primary" onClick={handleSaveLedgerFeeSetup}>
                          Save Fees
                        </Button>
                      </Col>
                    </Row>
                  </div>

                  <Row className="g-2 mb-3">
                    <Col md={6} lg={5}>
                      <div className="ledger-summary-card ledger-summary-card--balance">
                        <div className="ledger-summary-card__label">Balance Due</div>
                        <div className="ledger-summary-card__value ledger-summary-card__value--action">
                          <span>${formatMoney(ledgerTotals.balance)}</span>
                          {ledgerTotals.balance > 0 && (
                            <Button size="sm" variant="outline-success" onClick={openPayLedgerBalance}>
                              <BiCheckSquare className="me-1" /> Pay
                            </Button>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {loadingFinancialLedger ? (
                    <div className="text-muted">Loading ledger records...</div>
                  ) : financialLedger.length === 0 ? (
                    <p className="dashboard-empty-state mb-0">No ledger rows yet.</p>
                  ) : (
                    <>
                      <div className="table-responsive d-none d-md-block financial-table-wrap">
                        <table className="table table-sm align-middle mb-0 parent-profile-table ledger-table">
                          <thead>
                            <tr>
                              <th>Month</th>
                              <th>Weekend</th>
                              <th>Weekday</th>
                              <th>Supplemental</th>
                              <th>Paid</th>
                              <th>Method</th>
                              <th>Balance</th>
                              <th className="text-end">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {financialLedger.map((record) => {
                              const balance = parseFloat(record.balance) || 0;
                              return (
                                <tr key={record.id}>
                                  <td>{getLedgerPeriodLabel(record)}</td>
                                  <td>
                                    ${formatMoney(record.weekend_fee)}
                                    <div className={record.weekend_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                      {getPaidLabel(Boolean(record.weekend_paid))}
                                    </div>
                                  </td>
                                  <td>
                                    ${formatMoney(record.weekday_fee)}
                                    <div className={record.weekday_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                      {getPaidLabel(Boolean(record.weekday_paid))}
                                    </div>
                                  </td>
                                  <td>
                                    ${formatMoney(record.supplemental_fee)}
                                    <div className={record.supplemental_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                      {getPaidLabel(Boolean(record.supplemental_paid))}
                                    </div>
                                  </td>
                                  <td>${formatMoney(record.amount_paid)}</td>
                                  <td>{record.payment_method}</td>
                                  <td>
                                    <span className={balance <= 0 ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                                      ${formatMoney(balance)}
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <Dropdown drop="start" align="end" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                                      <Dropdown.Toggle size="sm" variant="outline-secondary" className="financial-actions-toggle ledger-actions-toggle">
                                        <span className="ledger-actions-toggle__text">Actions</span>
                                        <BiDotsVerticalRounded className="ledger-actions-toggle__icon" aria-hidden="true" />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu className="ledger-actions-menu">
                                        {getLedgerReceiptTotal(record) > 0 && (
                                          <Dropdown.Item onClick={() => openLedgerReceipt(record)}>
                                            <BiFile className="me-2" /> Receipt
                                          </Dropdown.Item>
                                        )}
                                        <Dropdown.Item onClick={() => openEditLedgerRecord(record)}>
                                          <BiEdit className="me-2" /> Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item className="text-danger" onClick={() => handleDeleteLedgerRecord(record)}>
                                          <BiTrash className="me-2" /> Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-md-none stack-list">
                        {financialLedger.map((record) => {
                          const balance = parseFloat(record.balance) || 0;
                          return (
                            <div key={record.id} className="stack-card ledger-mobile-card">
                              <div className="financial-card__header">
                                <div>
                                  <div className="financial-card__title">{getLedgerPeriodLabel(record)}</div>
                                  <div className="financial-card__subtitle">{editableParent?.first_name} {editableParent?.last_name}</div>
                                </div>
                                <span className={`fee-status-pill fee-status-pill--${String(record.status || 'unpaid').toLowerCase()}`}>
                                  {record.status}
                                </span>
                              </div>
                              <div className="financial-card__grid">
                                <div>
                                  <div className="financial-card__label">Weekend</div>
                                  <div className="financial-card__value">${formatMoney(record.weekend_fee)}</div>
                                  <div className={record.weekend_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                    {getPaidLabel(Boolean(record.weekend_paid))}
                                  </div>
                                </div>
                                <div>
                                  <div className="financial-card__label">Weekday</div>
                                  <div className="financial-card__value">${formatMoney(record.weekday_fee)}</div>
                                  <div className={record.weekday_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                    {getPaidLabel(Boolean(record.weekday_paid))}
                                  </div>
                                </div>
                                <div>
                                  <div className="financial-card__label">Supplemental</div>
                                  <div className="financial-card__value">${formatMoney(record.supplemental_fee)}</div>
                                  <div className={record.supplemental_paid ? 'text-success small fw-semibold' : 'text-muted small'}>
                                    {getPaidLabel(Boolean(record.supplemental_paid))}
                                  </div>
                                </div>
                                <div>
                                  <div className="financial-card__label">Paid</div>
                                  <div className="financial-card__value">${formatMoney(record.amount_paid)} {record.payment_method}</div>
                                </div>
                              </div>
                              <div className={`ledger-balance ${balance <= 0 ? 'ledger-balance--paid' : 'ledger-balance--owed'}`}>
                                <span>Balance ${formatMoney(balance)}</span>
                              </div>
                              {getVisibleLedgerNote(record.notes) && <div className="ledger-note">{getVisibleLedgerNote(record.notes)}</div>}
                              <div className="ledger-mobile-actions">
                                <Dropdown align="end" renderOnMount popperConfig={{ strategy: 'fixed' }}>
                                  <Dropdown.Toggle size="sm" variant="outline-secondary" className="financial-actions-toggle">
                                    Actions
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {getLedgerReceiptTotal(record) > 0 && (
                                      <Dropdown.Item onClick={() => openLedgerReceipt(record)}>
                                        Receipt
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item onClick={() => openEditLedgerRecord(record)}>
                                      <BiEdit className="me-2" /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item className="text-danger" onClick={() => handleDeleteLedgerRecord(record)}>
                                      <BiTrash className="me-2" /> Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>

              {showMonthlyFeeFinancials && (
                <>
                  <Card className="shadow-sm border-0 mb-3">
                    <Card.Body className="p-3">
                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-end gap-3">
                        <div className="flex-grow-1">
                          <Form.Label className="fw-semibold mb-1">Monthly Fee</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            step="0.01"
                            value={editableParent?.monthly_fee ?? ''}
                            onChange={(e) => {
                              if (!editableParent) return;
                              setEditableParent({
                                ...editableParent,
                                monthly_fee: e.target.value,
                              });
                            }}
                            placeholder="Set monthly fee"
                          />
                        </div>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={handleSaveMonthlyFee}
                          disabled={!editableParent?.id}
                        >
                          Save Monthly Fee
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={handleClearMonthlyFee}
                          disabled={!editableParent?.id}
                        >
                          Clear Fee
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>

                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                    <div>
                      <div className="text-muted small">Total Balance Due</div>
                      <div className="fs-5 fw-semibold">${getTotalBalanceDue()}</div>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      <Button
                        size="sm"
                        variant="success"
                        onClick={handlePayBalance}
                        disabled={!editableParent?.id || financials.every((fee) => fee.status === 'Paid')}
                      >
                        <BiCheckSquare className="me-1" /> Pay Balance
                      </Button>
                    </div>
                  </div>

                  {loadingFinancials ? (
                    <div className="text-muted">Loading financial records…</div>
                  ) : financials.length === 0 ? (
                    <p className="text-muted">No financial records yet.</p>
                  ) : (
                    <>
                  {/* Desktop/tablet */}
                  <div className="table-responsive d-none d-sm-block financial-table-wrap">
                    <table className="table table-sm align-middle mb-0 parent-profile-table">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Year</th>
                          <th>Due</th>
                          <th>Paid</th>
                          <th>Status</th>
                          <th>Balance</th>
                          <th className="text-end">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financials.map((fee) => {
                          const balance = (parseFloat(fee.amount_due) || 0) - (parseFloat(fee.amount_paid) || 0);
                          return (
                            <tr key={fee.id}>
                              <td>{formatMonthLabel(fee.month)}</td>
                              <td>{fee.year}</td>
                              <td>${formatMoney(fee.amount_due)}</td>
                              <td>${formatMoney(fee.amount_paid)}</td>
                              <td>{fee.status}</td>
                              <td className="fw-semibold">${formatMoney(balance)}</td>
                              <td className="text-end">
                                <Dropdown align="end">
                                  <Dropdown.Toggle size="sm" variant="outline-secondary">
                                    Actions
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {(parseFloat(fee.amount_paid) || 0) > 0 && (
                                      <Dropdown.Item onClick={() => openMonthlyFeeReceipt(fee)}>
                                        <BiFile className="me-2" /> Receipt
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item
                                      onClick={() => {
                                        setSelectedFee(fee);
                                        setEditFeeData({
                                          amount_paid: fee.amount_paid ?? 0,
                                          status: fee.status || 'Unpaid',
                                        });
                                        setShowEditFeeModal(true);
                                      }}
                                    >
                                      <BiEdit className="me-2" /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className="text-danger"
                                      onClick={() => handleDeleteFee(fee)}
                                    >
                                      <BiTrash className="me-2" /> Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile cards */}
                  <div className="d-sm-none stack-list">
                    {financials.map((fee) => {
                      const balance = (parseFloat(fee.amount_due) || 0) - (parseFloat(fee.amount_paid) || 0);
                      const monthLabel = formatMonthLabel(fee.month);
                      return (
                        <div key={fee.id} className="stack-card financial-card">
                          <div className="financial-card__header">
                            <div>
                              <div className="financial-card__title">{monthLabel} {fee.year}</div>
                              <div className={`financial-badge financial-badge--${(fee.status || 'unpaid').toLowerCase()}`}>
                                {fee.status}
                              </div>
                            </div>
                            <div className="financial-card__meta">
                              <div className="financial-card__label">Balance</div>
                              <div className="financial-card__balance">${formatMoney(balance)}</div>
                            </div>
                            <Dropdown align="end">
                              <Dropdown.Toggle size="sm" variant="light" className="financial-actions-toggle">
                                <BiDotsVerticalRounded />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {(parseFloat(fee.amount_paid) || 0) > 0 && (
                                  <Dropdown.Item onClick={() => openMonthlyFeeReceipt(fee)}>
                                    <BiFile className="me-2" /> Receipt
                                  </Dropdown.Item>
                                )}
                                <Dropdown.Item
                                  onClick={() => {
                                    setSelectedFee(fee);
                                    setEditFeeData({
                                      amount_paid: fee.amount_paid ?? 0,
                                      status: fee.status || 'Unpaid',
                                    });
                                    setShowEditFeeModal(true);
                                  }}
                                >
                                  <BiEdit className="me-2" /> Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="text-danger"
                                  onClick={() => handleDeleteFee(fee.id)}
                                >
                                  <BiTrash className="me-2" /> Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className="financial-card__grid">
                            <div>
                              <div className="financial-card__label">Due</div>
                              <div className="financial-card__value">${formatMoney(fee.amount_due)}</div>
                            </div>
                            <div>
                              <div className="financial-card__label">Paid</div>
                              <div className="financial-card__value">${formatMoney(fee.amount_paid)}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                    </>
                  )}
                </>
              )}
            </Tab>
          )}

          {/* ===================== Notes ===================== */}
          <Tab eventKey="notes" title={<span><BiMessageSquareDetail className="me-1" /> Notes</span>}>
            <Form onSubmit={handleAddNote} className="mb-3">
              <Form.Label className="fw-semibold">Add a note</Form.Label>
              <InputGroup>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Type internal note for this parent..."
                  value={newNoteText}
                  onChange={(e) => setNewNoteText(e.target.value)}
                />
                <Button type="submit" variant="success">Add</Button>
              </InputGroup>
            </Form>

            {loadingNotes ? (
              <div className="text-muted">Loading notes…</div>
            ) : notes.length === 0 ? (
              <div className="text-muted">No notes yet.</div>
            ) : (
              <>
                {/* desktop/tablet */}
                <div className="d-none d-sm-block list-group">
                  {notes.map(note => (
                    <div key={note.id} className="list-group-item">
                      <div className="d-flex justify-content-between align-items-start">
                        <small className="text-muted">
                          Created: {fmtDateTime(note.created_at)}
                          {note.updated_at ? ` • Updated: ${fmtDateTime(note.updated_at)}` : ''}
                        </small>
                        <div className="d-flex gap-2">
                          {editingNoteId === note.id ? (
                            <>
                              <Button size="sm" variant="primary" onClick={handleSaveNote}>Save</Button>
                              <Button size="sm" variant="outline-secondary" onClick={cancelEditNote}>Cancel</Button>
                            </>
                          ) : (
                            <>
                              <Button size="sm" variant="outline-primary" onClick={() => startEditNote(note)}>Edit</Button>
                              <Button size="sm" variant="outline-danger" onClick={() => confirmDeleteNote(note)}>Delete</Button>
                            </>
                          )}
                        </div>
                      </div>
                      {editingNoteId === note.id ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          className="mt-2"
                          value={editingNoteText}
                          onChange={(e) => setEditingNoteText(e.target.value)}
                        />
                      ) : (
                        <div className="mt-2" style={{ whiteSpace: 'pre-wrap' }}>{note.note_text}</div>
                      )}
                    </div>
                  ))}
                </div>

                {/* mobile */}
                <div className="d-sm-none stack-list">
                  {notes.map(note => (
                    <div key={note.id} className="stack-card">
                      <small className="text-muted note-meta">
                        {fmtDateTime(note.created_at)}
                        {note.updated_at ? ` • Edited ${fmtDateTime(note.updated_at)}` : ''}
                      </small>

                      {editingNoteId === note.id ? (
                        <>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            className="mt-2"
                            value={editingNoteText}
                            onChange={(e) => setEditingNoteText(e.target.value)}
                          />
                          <div className="d-grid gap-2 mt-2">
                            <Button size="sm" variant="primary" onClick={handleSaveNote}>Save</Button>
                            <Button size="sm" variant="outline-secondary" onClick={cancelEditNote}>Cancel</Button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="mt-2" style={{ whiteSpace: 'pre-wrap' }}>{note.note_text}</div>
                          <div className="d-grid gap-2 mt-3">
                            <Button size="sm" variant="outline-primary" onClick={() => startEditNote(note)}>Edit</Button>
                            <Button size="sm" variant="outline-danger" onClick={() => confirmDeleteNote(note)}>Delete</Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Delete confirmation */}
            <Modal show={!!noteToDelete} onHide={() => setNoteToDelete(null)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Delete Note</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this note?
                <div className="mt-2 p-2 bg-light rounded" style={{ whiteSpace: 'pre-wrap' }}>
                  {noteToDelete?.text}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setNoteToDelete(null)}>Cancel</Button>
                <Button variant="danger" onClick={handleDeleteNote}>Delete</Button>
              </Modal.Footer>
            </Modal>
          </Tab>
        </Tabs>

        {isAlsunahMarkaz && (
          <>
            <Modal show={showLedgerModal} onHide={() => setShowLedgerModal(false)} centered size="lg">
              <Modal.Header closeButton>
                <Modal.Title>
                  {ledgerModalMode === 'pay'
                    ? `Pay Fee - ${editingLedgerRecord ? getLedgerPeriodLabel(editingLedgerRecord) : ''}`
                    : editingLedgerRecord
                      ? 'Edit Monthly Charge'
                      : 'Add Monthly Charge'}
                </Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleSaveLedgerRecord}>
                <Modal.Body>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Label>Month</Form.Label>
                      <Form.Select
                        value={ledgerForm.entry_month}
                        disabled={ledgerModalMode === 'pay'}
                        onChange={(e) => setLedgerForm({
                          ...ledgerForm,
                          entry_month: e.target.value,
                          entry_date: getMonthStartDate(e.target.value, ledgerForm.entry_year),
                        })}
                        required
                      >
                        {feeMonthOptions.map((m) => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={6}>
                      <Form.Label>Year</Form.Label>
                      <Form.Select
                        value={ledgerForm.entry_year}
                        disabled={ledgerModalMode === 'pay'}
                        onChange={(e) => setLedgerForm({
                          ...ledgerForm,
                          entry_year: e.target.value,
                          entry_date: getMonthStartDate(ledgerForm.entry_month, e.target.value),
                        })}
                        required
                      >
                        {feeYearOptions.map((y) => (
                          <option key={y.value} value={y.value}>{y.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={6}>
                      <Form.Label>Payment Method</Form.Label>
                      <Form.Select
                        value={ledgerForm.payment_method}
                        onChange={(e) => setLedgerForm({ ...ledgerForm, payment_method: e.target.value })}
                      >
                        {['Cash', 'Card', 'Check', 'Zelle', 'Online', 'Other'].map((method) => (
                          <option key={method} value={method}>{method}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <Form.Label>Weekend Fee</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        disabled={ledgerModalMode === 'pay'}
                        value={ledgerForm.weekend_fee}
                        onChange={(e) => setLedgerForm({ ...ledgerForm, weekend_fee: e.target.value })}
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Label>Weekday Fee</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        disabled={ledgerModalMode === 'pay'}
                        value={ledgerForm.weekday_fee}
                        onChange={(e) => setLedgerForm({ ...ledgerForm, weekday_fee: e.target.value })}
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Label>Supplemental Fee <span className="text-muted fw-normal">(optional)</span></Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        disabled={ledgerModalMode === 'pay'}
                        value={ledgerForm.supplemental_fee}
                        onChange={(e) => setLedgerForm({ ...ledgerForm, supplemental_fee: e.target.value })}
                      />
                    </Col>
                    <Col xs={12}>
                      <div className="ledger-paid-options">
                        <div className="ledger-paid-options__title">Mark fees paid</div>
                        <Form.Check
                          type="checkbox"
                          id="ledger-weekend-paid"
                          label={`Weekend fee paid (${formatMoney(ledgerForm.weekend_fee)})`}
                          checked={Boolean(ledgerForm.weekend_paid)}
                          onChange={(e) => setLedgerForm({ ...ledgerForm, weekend_paid: e.target.checked })}
                        />
                        <Form.Check
                          type="checkbox"
                          id="ledger-weekday-paid"
                          label={`Weekday fee paid (${formatMoney(ledgerForm.weekday_fee)})`}
                          checked={Boolean(ledgerForm.weekday_paid)}
                          onChange={(e) => setLedgerForm({ ...ledgerForm, weekday_paid: e.target.checked })}
                        />
                        <Form.Check
                          type="checkbox"
                          id="ledger-supplemental-paid"
                          label={`Supplemental fee paid (${formatMoney(ledgerForm.supplemental_fee)})`}
                          checked={Boolean(ledgerForm.supplemental_paid)}
                          disabled={(parseFloat(ledgerForm.supplemental_fee) || 0) <= 0}
                          onChange={(e) => setLedgerForm({ ...ledgerForm, supplemental_paid: e.target.checked })}
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={ledgerForm.notes}
                        onChange={(e) => setLedgerForm({ ...ledgerForm, notes: e.target.value })}
                        placeholder="Optional notes"
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowLedgerModal(false)}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="primary">
                    {ledgerModalMode === 'pay' ? 'Record Payment' : editingLedgerRecord ? 'Save Charge' : 'Add Charge'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>

            <Modal show={showReceiptModal} onHide={() => setShowReceiptModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Payment Receipt</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {receiptRecord && (
                  <div className="receipt-card">
                    <div className="receipt-card__header">
                      <div>
                        <div className="receipt-card__eyebrow">MarkazSync Receipt</div>
                        <div className="receipt-card__title">{receiptRecord.parent_name || 'Parent'}</div>
                        <div className="receipt-card__meta">{formatPhone(receiptRecord.parent_phone) || 'No phone'}</div>
                      </div>
                      <div className="receipt-card__number">{receiptRecord.receipt_number}</div>
                    </div>

                    <div className="receipt-card__details">
                      <div>
                        <div className="receipt-card__label">Period</div>
                        <div className="receipt-card__value">{receiptRecord.period_label}</div>
                      </div>
                      <div>
                        <div className="receipt-card__label">Date</div>
                        <div className="receipt-card__value">{receiptRecord.receipt_date}</div>
                      </div>
                      <div>
                        <div className="receipt-card__label">Method</div>
                        <div className="receipt-card__value">{receiptRecord.payment_method || 'Cash'}</div>
                      </div>
                    </div>

                    <div className="receipt-card__items">
                      {getLedgerReceiptItems(receiptRecord).map((item) => (
                        <div key={item.label} className="receipt-card__item">
                          <span>{item.label}</span>
                          <strong>${formatMoney(item.amount)}</strong>
                        </div>
                      ))}
                    </div>

                    <div className="receipt-card__total">
                      <span>Total Paid</span>
                      <strong>${formatMoney(receiptRecord.receipt_total)}</strong>
                    </div>
                    <div className="receipt-card__balance">
                      <span>Balance</span>
                      <strong>${formatMoney(receiptRecord.receipt_balance)}</strong>
                    </div>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => setShowReceiptModal(false)}>
                  Close
                </Button>
                <Button variant="outline-success" onClick={handleWhatsAppReceipt} disabled={isSharingReceipt}>
                  <FaWhatsapp className="me-1" /> WhatsApp
                </Button>
                <Button variant="outline-primary" onClick={handleShareReceipt} disabled={isSharingReceipt}>
                  {isSharingReceipt ? 'Sharing...' : 'Share'}
                </Button>
                <Button variant="primary" onClick={handlePrintReceipt}>
                  Print
                </Button>
              </Modal.Footer>
            </Modal>

            {showMonthlyFeeFinancials && (
              <>
            <Modal show={showAddFeeModal} onHide={() => setShowAddFeeModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Add Monthly Fee</Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleAddFeeSubmit}>
                <Modal.Body>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Label>Month</Form.Label>
                      <Form.Select
                        value={newFee.month}
                        onChange={(e) => setNewFee({ ...newFee, month: e.target.value })}
                        required
                      >
                        <option value="">Select month</option>
                        {feeMonthOptions.map((m) => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={6}>
                      <Form.Label>Year</Form.Label>
                      <Form.Select
                        value={newFee.year}
                        onChange={(e) => setNewFee({ ...newFee, year: e.target.value })}
                        required
                      >
                        <option value="">Select year</option>
                        {feeYearOptions.map((y) => (
                          <option key={y.value} value={y.value}>{y.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={6}>
                      <Form.Label>Amount Due</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        value={newFee.amount_due}
                        onChange={(e) => setNewFee({ ...newFee, amount_due: e.target.value })}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <Form.Label>Amount Paid</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        value={newFee.amount_paid}
                        onChange={(e) => setNewFee({ ...newFee, amount_paid: e.target.value })}
                      />
                    </Col>
                    <Col md={6}>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        value={newFee.status}
                        onChange={(e) => setNewFee({ ...newFee, status: e.target.value })}
                      >
                        <option value="Unpaid">Unpaid</option>
                        <option value="Partial">Partial</option>
                        <option value="Paid">Paid</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowAddFeeModal(false)}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="primary">
                    Add Fee
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>

            <Modal show={showEditFeeModal} onHide={() => setShowEditFeeModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit Fee</Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleEditFeeSubmit}>
                <Modal.Body>
                  {selectedFee && (
                    <div className="mb-3 text-muted small">
                      {formatMonthLabel(selectedFee.month)} {selectedFee.year} •
                      Due ${formatMoney(selectedFee.amount_due)}
                    </div>
                  )}
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Label>Amount Paid</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        value={editFeeData.amount_paid}
                        onChange={(e) => setEditFeeData({ ...editFeeData, amount_paid: e.target.value })}
                      />
                    </Col>
                    <Col md={6}>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        value={editFeeData.status}
                        onChange={(e) => setEditFeeData({ ...editFeeData, status: e.target.value })}
                      >
                        <option value="Unpaid">Unpaid</option>
                        <option value="Partial">Partial</option>
                        <option value="Paid">Paid</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowEditFeeModal(false)}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="primary">
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>

            <Modal show={showPayBalanceModal} onHide={() => setShowPayBalanceModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Pay Balance</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3 text-muted">
                  Total balance due: <strong>${getTotalBalanceDue()}</strong>
                </div>
                <Form.Group>
                  <Form.Label>Partial amount (optional)</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    value={payBalanceAmount}
                    onChange={(e) => setPayBalanceAmount(e.target.value)}
                    placeholder="Enter partial payment amount"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowPayBalanceModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handlePayBalanceFull}>
                  Pay Full
                </Button>
                <Button variant="outline-primary" onClick={handlePayBalancePartial}>
                  Pay Partial
                </Button>
              </Modal.Footer>
            </Modal>
              </>
            )}
          </>
        )}
      </>
    )}
  </Modal.Body>
</Modal>





{showMonthlyFeeFinancials && (
  <Modal show={showFinancialReport} onHide={() => setShowFinancialReport(false)} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>📊 Parent Financial Report</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form className="mb-4">
        <Row className="g-3 align-items-end">
          <Col md={5}>
            <Form.Label><strong>Select Parent</strong></Form.Label>
            <Select
              options={parentOptions}
              value={selectedReportParents}
              onChange={setSelectedReportParents}
              placeholder="All Parents"
              isClearable
            />
          </Col>
          <Col md={3}>
            <Form.Label><strong>Select Month</strong></Form.Label>
            <Select
              options={monthOptions}
              value={selectedReportMonth}
              onChange={setSelectedReportMonth}
              placeholder="All Months"
              isClearable
            />
          </Col>
          <Col md={3}>
            <Form.Label><strong>Select Year</strong></Form.Label>
            <Select
              options={yearOptions}
              value={selectedReportYear}
              onChange={setSelectedReportYear}
              placeholder="All Years"
              isClearable
            />
          </Col>
          <Col md={1}>
            <Button variant="primary" className="w-100" onClick={fetchUnpaidBalances}>
              Go
            </Button>
          </Col>
        </Row>
      </Form>

      {unpaidReports.length > 0 && (
        <>
          <Row className="g-3 financial-report-summary">
            <Col sm={6} lg={4}>
              <div className="financial-summary-card financial-summary-card--paid">
                <div className="financial-summary-card__label">Paid Parents</div>
                <div className="financial-summary-card__value">{financialReportSummary.paidParents.size}</div>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="financial-summary-card financial-summary-card--unpaid">
                <div className="financial-summary-card__label">Not Paid</div>
                <div className="financial-summary-card__value">{financialReportSummary.notPaidParents.size}</div>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="financial-summary-card financial-summary-card--partial">
                <div className="financial-summary-card__label">Partial</div>
                <div className="financial-summary-card__value">{financialReportSummary.partialParents.size}</div>
              </div>
            </Col>
          </Row>

          <div className="financial-report-toolbar">
            <Form.Control
              value={financialReportSearch}
              onChange={(e) => {
                setFinancialReportSearch(e.target.value);
                setFinancialReportPage(1);
              }}
              placeholder="Search parent, phone, month, status, or amount"
              aria-label="Search financial report"
            />
            <div className="financial-report-count">
              Showing {financialReportStart}-{financialReportEnd} of {filteredFinancialReports.length}
            </div>
          </div>
        </>
      )}

    {unpaidReports.length === 0 ? (
      <p className="text-center text-muted mt-3">No financial records found.</p>
    ) : filteredFinancialReports.length === 0 ? (
      <p className="text-center text-muted mt-3">No records match your search.</p>
    ) : (
      <>
        {/* Desktop/tablet */}
        <div className="d-none d-sm-block">
          <Table bordered hover responsive className="mt-3 financial-report-table">
            <thead>
              <tr>
                <th>Parent</th>
                <th>Phone</th>
                <th>Month</th>
                <th>Year</th>
                <th>Due</th>
                <th>Paid</th>
                <th>Status</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {paginatedFinancialReports.map((r, idx) => {
                const statusKey = String(r.status || 'unpaid').toLowerCase();
                const balance = parseFloat(r.balance) || 0;
                return (
                  <tr key={`${r.parent_id}-${r.month}-${r.year}-${idx}`} className={`financial-report-row financial-report-row--${statusKey}`}>
                    <td className="fw-semibold">{r.first_name} {r.last_name}</td>
                    <td>{formatPhone(r.phone_number)}</td>
                    <td>{formatMonthLabel(r.month)}</td>
                    <td>{r.year}</td>
                    <td>${formatMoney(r.amount_due)}</td>
                    <td>${formatMoney(r.amount_paid)}</td>
                    <td>
                      <span className={`financial-status-badge financial-status-badge--${statusKey}`}>
                        {r.status}
                      </span>
                    </td>
                    <td className={`financial-balance ${balance <= 0 ? 'financial-balance--paid' : 'financial-balance--owed'}`}>
                      ${formatMoney(balance)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        {/* Mobile cards */}
        <div className="d-sm-none stack-list mt-3">
          {paginatedFinancialReports.map((r, idx) => (
            <div key={`${r.parent_id}-${r.month}-${r.year}-${idx}`} className="stack-card financial-card report-card">
              <div className="financial-card__header report-section">
                <div>
                  <div className="financial-card__title">{r.first_name} {r.last_name}</div>
                  <div className="financial-card__subtitle">{formatPhone(r.phone_number) || '—'}</div>
                </div>
                <div className="financial-card__meta">
                  <div className="financial-card__label">Balance</div>
                  <div className={`financial-card__balance ${(parseFloat(r.balance) || 0) <= 0 ? 'financial-balance--paid' : 'financial-balance--owed'}`}>
                    ${formatMoney(r.balance)}
                  </div>
                </div>
              </div>
              <div className="financial-card__chips report-section">
                <span className="financial-chip">{formatMonthLabel(r.month)} {r.year}</span>
                <span className={`financial-chip financial-chip--${String(r.status || 'unpaid').toLowerCase()}`}>
                  {r.status}
                </span>
              </div>
              <div className="financial-card__grid report-section">
                <div className="financial-card__cell">
                  <div className="financial-card__label">Due</div>
                  <div className="financial-card__value">${formatMoney(r.amount_due)}</div>
                </div>
                <div className="financial-card__cell">
                  <div className="financial-card__label">Paid</div>
                  <div className="financial-card__value">${formatMoney(r.amount_paid)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {financialReportTotalPages > 1 && (
          <div className="financial-report-pagination">
            <Pagination className="mb-0">
              <Pagination.Prev
                disabled={currentFinancialReportPage === 1}
                onClick={() => setFinancialReportPage((page) => Math.max(1, page - 1))}
              />
              {Array.from({ length: financialReportTotalPages }, (_, index) => index + 1)
                .filter((page) => (
                  page === 1 ||
                  page === financialReportTotalPages ||
                  Math.abs(page - currentFinancialReportPage) <= 1
                ))
                .map((page, index, pages) => (
                  <React.Fragment key={page}>
                    {index > 0 && page - pages[index - 1] > 1 && <Pagination.Ellipsis disabled />}
                    <Pagination.Item
                      active={page === currentFinancialReportPage}
                      onClick={() => setFinancialReportPage(page)}
                    >
                      {page}
                    </Pagination.Item>
                  </React.Fragment>
                ))}
              <Pagination.Next
                disabled={currentFinancialReportPage === financialReportTotalPages}
                onClick={() => setFinancialReportPage((page) => Math.min(financialReportTotalPages, page + 1))}
              />
            </Pagination>
          </div>
        )}
      </>
    )}
    </Modal.Body>
  </Modal>
)}

<Modal
  show={showCoParentModal}
  onHide={closeCoParentModal}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>
      {coParentForm.mode === 'edit'
        ? 'Update Other Parent'
        : coParentForm.mode === 'existing'
          ? 'Link Existing Parent'
          : 'Add Other Parent'}
    </Modal.Title>
  </Modal.Header>

  <Form onSubmit={handleSaveCoParent}>
    <Modal.Body>
      {parentStudents.length === 0 && coParentForm.mode !== 'edit' ? (
        <p className="text-muted mb-0">Assign a student to this parent before adding another parent.</p>
      ) : (
        <>
          {coParentForm.mode === 'existing' ? (
            <Form.Group className="mb-3">
              <Form.Label>Select Parent</Form.Label>
              <Select
                options={coParentExistingOptions}
                value={coParentExistingOptions.find((option) => String(option.value) === String(coParentForm.existing_parent_id)) || null}
                onChange={(option) => setCoParentForm({ ...coParentForm, existing_parent_id: option?.value || '' })}
                placeholder="Search by name or phone"
                isClearable
                styles={{
                  menu: base => ({
                    ...base,
                    zIndex: 9999,
                  })
                }}
              />
              <Form.Text className="text-muted">
                This parent will be linked to all students currently assigned in this profile.
              </Form.Text>
            </Form.Group>
          ) : (
            <>
              <Row className="g-2">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      value={coParentForm.first_name}
                      onChange={(e) => setCoParentForm({ ...coParentForm, first_name: e.target.value })}
                      placeholder="First name"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      value={coParentForm.last_name}
                      onChange={(e) => setCoParentForm({ ...coParentForm, last_name: e.target.value })}
                      placeholder="Last name"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  value={coParentForm.phone_number}
                  onChange={(e) => setCoParentForm({ ...coParentForm, phone_number: formatPhone(e.target.value) })}
                  placeholder="Phone number"
                  required
                />
              </Form.Group>
              {coParentForm.mode !== 'edit' && (
                <Form.Text className="text-muted">
                  The new parent will be linked to all students currently assigned in this profile.
                </Form.Text>
              )}
            </>
          )}
        </>
      )}
    </Modal.Body>

    <Modal.Footer>
      <Button variant="outline-secondary" onClick={closeCoParentModal}>
        Cancel
      </Button>
      <Button
        type="submit"
        variant="primary"
        disabled={parentStudents.length === 0 && coParentForm.mode !== 'edit'}
      >
        {coParentForm.mode === 'edit' ? 'Update' : 'Save'}
      </Button>
    </Modal.Footer>
  </Form>
</Modal>

<Modal
  show={showCoParentActionModal}
  onHide={() => {
    setShowCoParentActionModal(false);
    setCoParentActionId('');
  }}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Other Parent</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>Select Parent</Form.Label>
      <Form.Select
        value={coParentActionId}
        onChange={(e) => setCoParentActionId(e.target.value)}
      >
        <option value="">Select parent</option>
        {coParents.map((parent) => (
          <option key={parent.id} value={parent.id}>
            {parent.first_name} {parent.last_name} - {formatPhone(parent.phone_number) || 'No phone'}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="outline-secondary"
      onClick={() => {
        setShowCoParentActionModal(false);
        setCoParentActionId('');
      }}
    >
      Cancel
    </Button>
    <Button variant="primary" onClick={handleCoParentActionSubmit}>
      Continue
    </Button>
  </Modal.Footer>
</Modal>

<Modal
  show={showAssignParentModal}
  onHide={() => {
    setShowAssignParentModal(false);
    setSelectedStudent(null);
    setSelectedParentToAssign(null);
  }}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Assign to Parent</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedStudent ? (
      <>
        <p className="mb-3">
          Assigning <strong>{selectedStudent.first_name} {selectedStudent.last_name}</strong>
        </p>

        <Form onSubmit={handleAssignToParent}>
          <Form.Group className="mb-3">
            <Form.Label>Select Parent</Form.Label>
            <Select
              options={allParents?.map(p => ({
                value: p.id,
                label: `${p.first_name} ${p.last_name} — ${formatPhone(p.phone_number)}`,
              }))}
              value={selectedParentToAssign}
              onChange={setSelectedParentToAssign}
              placeholder="Search by name or phone"
              isClearable
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 9999, // ensures dropdown appears above modals
                })
              }}
            />
          </Form.Group>

          <div className="text-end">
            <Button
              variant="secondary"
              className="me-2"
              onClick={() => {
                setShowAssignParentModal(false);
                setSelectedParentToAssign(null);
              }}
            >
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={!selectedParentToAssign}>
              Assign
            </Button>
          </div>
        </Form>
      </>
    ) : (
      <p className="text-muted">No student selected.</p>
    )}
  </Modal.Body>
</Modal>



<Modal
  show={showMoveStudentModal}
  onHide={() => {
    setShowMoveStudentModal(false);
    setStudentToMove(null);
    setTargetClassId('');
  }}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Move Student</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {studentToMove ? (
      <>
        <p className="mb-3">
          Move <strong>{studentToMove.student_first_name || studentToMove.first_name} {studentToMove.student_last_name || studentToMove.last_name}</strong> to another class.
        </p>
        <Form.Group>
          <Form.Label>Target Class</Form.Label>
          <Form.Select value={targetClassId} onChange={(e) => setTargetClassId(e.target.value)}>
            <option value="">Select a class</option>
            {allClasses.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}{cls.shift ? ` - ${cls.shift}` : ''}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </>
    ) : (
      <p className="text-muted mb-0">No student selected.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowMoveStudentModal(false);
        setStudentToMove(null);
        setTargetClassId('');
      }}
    >
      Cancel
    </Button>
    <Button variant="primary" onClick={handleMoveStudent} disabled={!studentToMove || !targetClassId}>
      Move Student
    </Button>
  </Modal.Footer>
</Modal>

<StudentNotesModal
  show={notesApi.showNotes}
  onHide={() => {
    notesApi.setShowNotes(false);
    setShowStudentModal(true);  // 👈 reopen Students modal
  }}
  student={notesApi.notesStudent}
  notesApi={notesApi}
/>

<StudentGoalsModal
  show={goalsApi.showGoals}
  onHide={() => {
    goalsApi.setShowGoals(false);
    setShowStudentModal(true);  // 👈 reopen Students modal
  }}
  student={goalsApi.goalsStudent}
  goalsApi={goalsApi}
/>

<QuranAssignmentsModal
  show={showQuranAssignmentsModal}
  onHide={closeAdminQuranAssignments}
  student={quranAssignmentsStudent}
/>












      </Container>
      </div>
    </div>
  );
};

export default AdminDashboard;
